<style lang="scss">
// .player.pip .drag-container {
//   display: grid;
//   grid-template-columns: repeat(5, 1fr);
//   gap: 0px;
// }

.player.pip .player-dialog {
  cursor: move;
}

#custom-tooltip-reg {
  display: none;
  float: right;
  padding: 5px 12px;
  background-color: #ffffff;
  border-radius: 4px;
  color: #2376e5;
  text-align: center;
}
.google-signup-button {
  display: inline-block;
  padding: 10px 15px;
  border: 1px solid #959595;
  border-radius: 6px;
  font-weight: 600;
  font-size: 14px;
  margin-right: 10px;
  background: url(./assets/Images/google-login-icon.png) no-repeat left 5px
    center;
  width: 24%;
}
.facebook-signup-button {
  display: inline-block;
  padding: 10px 15px;
  border: 1px solid #959595;
  border-radius: 6px;
  font-weight: 600;
  font-size: 14px;
  margin-right: 10px;
  background: url(./assets/Images/facebook-letter-logo.svg) no-repeat left 5px
    center;
  width: 24%;
}

.whatsap-connector {
  margin: 10px 29px 10px;
  padding: 6px 10px;
  border-radius: 8px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: #79ba7e;
  cursor: pointer;
}
.whatsap-connector:hover {
  background: #436746;
}

.whatsap-img {
  width: 40px;
  flex: 40px 0 0;
}
.whatsap-text {
  padding-left: 10px;
}
.whatsap-text h3 {
  font-size: 16px;
  font-weight: 400;
  color: #fff;
  margin: 0;
}
.help-desk-container-options .v-list-item__subtitle,
.v-list-item__title {
  overflow: inherit !important;
  text-overflow: inherit !important;
  white-space: inherit !important;
}
.help-desk-container {
  position: fixed;
  right: 20px;
  bottom: 90px;
  height: 400px;
  width: 323px;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 0 15px rgb(138 138 138 / 60%);
}

.help-desk-container-top {
  background: #383f97;
  overflow: hidden;
  padding: 15px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
.help-desk-container-top-text h3 {
  color: #fff;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
}
.help-desk-container-top-text p {
  margin: 0 !important;
  color: #fff;
  font-size: 14px;
  line-height: 20px;
}

.help-desk-inner-wrapper .v-list-item {
  border-radius: 10px;
  box-shadow: 0 0 15px rgb(138 138 138 / 50%);
  margin-bottom: 10px !important;
}

.help-desk-inner-wrapper .help-desk-container-options {
  padding: 10px 15px;
  border-radius: 6px;
  cursor: pointer;
}

.help-desk-inner-wrapper
  .help-desk-container-options:hover
  .v-list-item__title {
  color: #383f97;
}

.help-desk-inner-wrapper
  .v-application--is-ltr
  .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 22px !important;
}

.help-desk-inner-wrapper .v-list-item {
  margin: 0 28px 0px !important;
}

.help-desk-inner-wrapper .v-avatar {
  border: 4px solid #383f97 !important;
  -webkit-box-shadow: 0 0 0 6px rgb(36 63 151 / 30%);
  box-shadow: 0 0 0 6px rgb(36 63 151 / 30%);
}
.ipad-overlay {
  position: fixed;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99999999999999;
}
.open-section {
  height: 100%;
}
.chat-unread-count-top-menu {
  position: absolute;
  font-size: 12px;
  display: inline-flex;
  right: 0px;
  top: 0px;
  background: #288aef;
  color: #fff;
  justify-content: center;
  height: 23px;
  width: 23px;
  align-items: center;
  border-radius: 50%;
}
.top-menu-chat-buble {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.top-menu-chat-buble img {
  height: 48px !important;
  width: 48px !important;
}
.topmenu {
  position: relative;
}
#leftMenuParent {
  height: 100%;
}

/*  ---  yellow notification div ---- */
.yellow-bell-notification {
  position: fixed;
  right: 0;
  top: 4px;
  z-index: 99999;
  background: #fab801;
  width: 400px;
  padding: 15px;
  border-radius: 8px 0 0 8px;
}
.yellowNotification-close {
  position: absolute;
  display: inline-block;
  right: 20px;
  top: 8px;
  font-size: 27px;
}
.app-version {
  cursor: default !important;
  font-size: 10px;
  font-weight: 400;
  display: block;
  padding: 10px 18px;
  color: #a0a0a0;
  text-align: right;
}
.app-version:hover {
  color: #a0a0a0 !important;
}
.banner-toppart .my-profile.dropdown span.menu-profile-pic {
  margin-right: 8px;
}
.menu-seperator {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.extendmenu-wrap {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.extend-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background: #fff;
  /* height: 100%; */
  display: inline-block;
  min-height: 104px;
  min-width: 200px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
}
.extend-menu ul {
  margin: 0;
  padding: 0 !important;
}
.extend-menu ul li {
  display: block;
  list-style: none;
}
.extend-menu ul li a {
  display: block;
  padding: 5px 10px !important;
  font-size: 16px;
  font-weight: 600;
  color: #1b1b1b;
}
.top-help {
  margin-right: 10px;
  cursor: pointer;
}
.top-help img {
  height: 28px;
  width: 28px;
}
.mobile-menu-icon-wrap {
  height: 30px !important;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 20px !important;
}
.notification-btn button {
  font-weight: 400;
}
.briefcase-card-wrapper .v-card__text {
  padding: 0 !important;
}
.new-notification {
  position: fixed;
  z-index: 99999999;
  top: 15px;
  right: 0;
}
.leaderboaed-dialog .list-order p {
  margin-bottom: 0 !important;
}
.leaderboaed-dialog .v-avatar {
  height: 50px !important;
  width: 50px !important;
}
.leaderboaed-dialog .leader-board-userlist .v-avatar.no-image span {
  font-size: 22px;
}
.leaderboaed-dialog .v-list-item__content {
  padding: 0 !important;
}
.leaderboaed-dialog .v-list-item__subtitle p {
  margin: 0;
}
.v-dialog.leaderboaed-dialog {
  width: 1000px;
  overflow-x: hidden;
  border: 12px solid rgba(255, 255, 255, 0.5) !important;
  border-radius: 20px !important;
  background-clip: padding-box;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.4),
    0 4px 14px rgba(0, 0, 0, 0.18) !important;
}
.leaderboaed-dialog .leader-board-rank-list-hld ul li .v-card {
  padding: 25px 0;
}
.leaderboaed-dialog .leader-board-rank-list-hld ul li.topers-top {
  height: 422px;
}
.leaderboaed-dialog .list-right {
  width: 62%;
}
.leaderboaed-dialog #leader-board-wrapper-hld #sectionId .page-head {
  font-size: 24px !important;
}
.notification-autohide {
  animation: autohide 10s;
}
.chat-img-wraper {
  text-align: center;
  height: auto;
}

#app.full-screen {
  height: 100vh;
  width: 100% !important;
  cursor: default;
}
.full-screen .v-main {
  padding-top: 0 !important;
}
#iframeReg {
  height: 100vh;
}
@keyframes autohide {
  0% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

/* =========================================================================
   Side menu — Figma 1:1 (frame 36181:3580 / item 36196:570)
   Glass container: 72px content + 8px padding => 88px outer, 16px radius,
   rgba(0,0,0,0.60) + 12px backdrop blur. Each item is a 72x72 flex column,
   24x24 white icon, Inter 12/400 white label, gap 8.
   Applies in BOTH lightMenu and redMenu modes so the dark glass shell is
   consistent and the legacy white active-state box from screen.css is
   suppressed.
   ========================================================================= */
#leftmenu.survey-left-menu-wrapper,
.survey-left-menu-wrapper.left-menu-sec {
  width: 105px !important;
  padding: 8px !important;
  border-radius: 16px !important;
  background: rgba(0, 0, 0, 0.6) !important;
  -webkit-backdrop-filter: blur(12px);
  backdrop-filter: blur(12px);
  left: 10px;
  overflow: visible;
  border: none !important;
}
#leftmenu.survey-left-menu-wrapper ul,
.survey-left-menu-wrapper.left-menu-sec ul {
  display: flex;
  flex-direction: column;
  gap: 0;
}
#leftmenu.survey-left-menu-wrapper ul li,
.survey-left-menu-wrapper.left-menu-sec ul li {
  padding: 0 !important;
  border-radius: 12px;
  overflow: hidden;
  background: transparent !important;
}
#leftmenu.survey-left-menu-wrapper ul li a,
.survey-left-menu-wrapper.left-menu-sec ul li a {
  // width: 72px !important;
  // height: 72px !important;
  // min-height: 72px !important;
  padding: 0 !important;
  // gap: 8px !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  align-items: center !important;
  border-bottom: none !important;
  background: transparent !important;
  color: #fff !important;
  font-family: "Inter", sans-serif !important;
  font-weight: 400 !important;
  font-size: 12px !important;
  line-height: 12px !important;
  padding: 0 15px;
}
#leftmenu.survey-left-menu-wrapper ul li a span,
.survey-left-menu-wrapper.left-menu-sec ul li a span {
  margin: 0 !important;
  padding: 0 !important;
  font-family: "Inter", sans-serif !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  line-height: 12px !important;
  color: #fff !important;
  display: block;
}
#leftmenu.survey-left-menu-wrapper ul li a span img,
.survey-left-menu-wrapper.left-menu-sec ul li a span img {
  width: 24px !important;
  height: 24px !important;
  display: block;
  margin: 0 auto;
}
#leftmenu.survey-left-menu-wrapper ul li a center,
.survey-left-menu-wrapper.left-menu-sec ul li a center {
  width: 100%;
  padding: 0 6px;
  display: block;
  color: #fff !important;
  font-size: 12px !important;
  line-height: 12px !important;
}
/* Suppress the legacy white "active" box (lightMenu) and the red leading bar. */
#leftmenu.survey-left-menu-wrapper ul li.active a,
.survey-left-menu-wrapper.left-menu-sec ul li.active a {
  background: rgba(255, 255, 255, 0.12) !important;
  color: #fff !important;
}
#leftmenu.survey-left-menu-wrapper ul li.active a:before,
.survey-left-menu-wrapper.left-menu-sec ul li.active a:before {
  display: none !important;
}
#leftmenu.survey-left-menu-wrapper ul li a:hover,
.survey-left-menu-wrapper.left-menu-sec ul li a:hover {
  background: rgba(255, 255, 255, 0.08) !important;
}
</style>
<style>
#zmmtg-root {
  display: none !important;
}
#wc-container-right {
  width: 398px !important;
}
/* .v-dialog__content {
  z-index: 1041 !important;
} */

@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .ex-dialog-body {
    width: 700px !important;
  }
  .client-dialog-exhibitors .ex-dialog-body {
    width: 100% !important;
  }
}
@media only screen and (max-width: 667px) {
  .ex-dialog-body {
    width: 100% !important;
  }
  .v-dialog:not(.v-dialog--fullscreen) {
    width: 100%;
    margin: 5px !important;
  }
}
</style>
<style></style>
<style>
#pipDialog {
  position: absolute;
  left: var(--player-left) !important;
  top: var(--player-top) !important;
  /* left: 0;
    top: 0;  */
  /* set these so Chrome doesn't return 'auto' from getComputedStyle */
  height: 273px;
  width: 348px;
  /* background: rgba(255,255,255,0.66);
    border: 2px  solid rgba(0,0,0,0.5);
    border-radius: 4px;
    padding: 8px; */
  /* z-index: 9; */
}

#videoPlayerApp.vjs-custom-skin {
  height: 100% !important;
}
#videoPlayerApp .video-js {
  width: 100% !important;
}
#videoPlayerApp .video-js .vjs-fullscreen-control {
  margin-left: calc(100% - 180px);
}
</style>
<template>
  <v-app :class="IsFullScreen ? 'full-screen' : ''">
    <v-main :class="isMobileView ? 'mobile' : ''">
      <!-- <aside draggable="true" id="dragme">
        This is an aside, drag me.
      </aside> -->
      <div style="position: absolute; z-index: 1199; left: -100px; top: -100px">
        <!-- <a href="javascript:void(0)" @click="showVideoPlayer">Start</a> -->
        <a id="startVideo" href="javascript:void(0)" style="font-size: 1px"
          >START</a
        >
      </div>
      <div
        :class="
          closeLiveAttendeeCount
            ? 'page-online-people position-fixed'
            : 'd-none'
        "
        v-if="
          liveVisitorIndicator &&
          attendeeHeadList &&
          attendeeHeadList.length > 0 &&
          showChatComponent &&
          !IsAdminEditPage
        "
      >
        <div
          :class="
            newAttendeePresenceFound
              ? 'pulse-blur-circle glow-blur-circle'
              : 'pulse-blur-circle'
          "
        >
          <img
            v-if="attendeeHeadList.length > 0 && livePeopleText"
            src="./assets/Images/online.svg"
          />

          <p v-if="attendeeHeadList.length > 0 && !livePeopleText">
            {{ attendeeHeadList.length }}
          </p>
          <span
            v-if="attendeeHeadList.length > 0 && !livePeopleText"
            class="online-indication"
          ></span>
        </div>
        <div
          :class="
            isMobileView
              ? 'presence-fade-out fadeout-text1'
              : 'presence-fade-out'
          "
        >
          <h5 v-if="attendeeHeadList.length == 1 && livePeopleText">
            <b>{{ attendeeHeadList.length }}</b> more co-visiting this page with
            you!
          </h5>
          <h5 v-if="attendeeHeadList.length > 1 && livePeopleText">
            <b>{{ attendeeHeadList.length }}</b> more co-visiting this page with
            you!
          </h5>
        </div>

        <!-- <v-btn
          small
          text
          color="#2376e5"
          class="view-chat"
          @click="openChatPannelWithPresence()"
          >Chat Now</v-btn
        > -->
        <div class="presence-head-wrapper ml-4">
          <ul style="position: relative">
            <li
              v-for="(attendee, index) in allOnlineAttendeeHeadList.slice(0, 5)"
              :key="attendee"
            >
              <a
                href="javascript:void(0)"
                @click="showAttendeePopup(attendee, index)"
                v-if="attendee && attendee.profilepic"
                ><img
                  :src="attendee.profilepic"
                  alt="presence head"
                  @error="attendee.profilepic = ''"
              /></a>
              <a
                href="javascript:void(0)"
                @click="showAttendeePopup(attendee, index)"
                v-else
                ><span>{{ attendee.NameInitial }}</span></a
              >
            </li>

            <li
              v-if="
                allOnlineAttendeeHeadList &&
                allOnlineAttendeeHeadList.length > 5
              "
            >
              <a href="javascript:void(0)" @click="openChatPannelWithPresence()"
                >+{{ allOnlineAttendeeHeadList.length - 5 }}</a
              >
            </li>

            <div
              class="bubble-head-presence-details"
              v-if="attendeeDetailsPopup"
              :style="'left:' + leftPresenceBubble + 'px !important'"
            >
              <div
                class="d-flex justify-content-between align-items-center"
                style="width: 100%"
              >
                <div class="mr-5">
                  <h3 v-if="selectedAttendeeName">
                    {{ selectedAttendeeName }}
                  </h3>
                  <p class="m-0" v-if="selectedAttendeeTitle">
                    {{ selectedAttendeeTitle }}
                  </p>
                  <p class="m-0" v-if="selectedAttendeeCompany">
                    {{ selectedAttendeeCompany }}
                  </p>
                  <!-- <h5 class="pl-0"><b>Reg Type:</b> <span>Attendee</span></h5> -->
                </div>
                <!-- <p>Customer Success Manager</p> -->
                <ul>
                  <!-- <li>
                        <v-btn
                          height="40px"
                          min-width="40px"
                          width="40px"
                          color="#e9edf1"
                          elevation="0"
                          ><img src="./assets/Images/icons/set-meeting.svg"
                        /></v-btn>
                      </li> -->
                  <!-- <li>

                    <v-btn
                      height="35px"
                      small
                      outlined
                      color="#eee"
                      elevation="0"
                      @click="OpenOneToOneChat(selectedAttendeeId)"
                      ><img
                        src="./assets/Images/icons/1-1-chat.svg"
                        class="mr-2"
                      />
                      Private Chat</v-btn
                    >
                  </li> -->
                  <li class="mr-0">
                    <v-btn
                      @click="
                        OpenOneToOneChat(
                          selectedAttendeeId,
                          selectedAttendeeName
                        )
                      "
                      class="ml-2"
                      fab
                      dark
                      small
                      color="#1a73e8"
                    >
                      <img
                        src="./assets/Images/icons/private-chat.svg"
                        style="height: 20px; width: 20px"
                    /></v-btn>
                  </li>
                  <!-- <li>
                        <v-btn
                          height="40px"
                          min-width="40px"
                          width="40px"
                          color="#e9edf1"
                          elevation="0"
                          ><img src="./assets/Images/icons/video-call-bubble.svg"
                        /></v-btn>
                      </li> -->
                </ul>
              </div>
            </div>
          </ul>
        </div>

        <v-btn
          text
          fab
          small
          class="close-noti"
          @click="closeLiveAttendeeCount = false"
          ><v-icon color="#333" size="15px">mdi-close</v-icon></v-btn
        >
      </div>
      <div
        id="adminEventsPopup"
        class="modal admin-events-popup"
        tabindex="-1"
        role="dialog"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header px-6 mb-0">
              <div class="full-width">
                <h5 class="modal-title">
                  Select An Event
                  <router-link
                    to="/eventoverview#ManageMyEvents"
                    data-dismiss="modal"
                    class="vae pl-3 pr-4"
                    >View all events</router-link
                  >
                </h5>
                <p class="m-0">
                  <v-icon color="#333" size="20px" class="mr-1"
                    >mdi-earth</v-icon
                  >{{ localTimeZone }}
                </p>
              </div>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body head-top-wrap p-0">
              <div class="ss-top-ev-dp">
                <!--selected event-->
                <a
                  v-if="CurrentAdminEvent"
                  :class="
                    CurrentAdminEvent.IsPastEvent
                      ? 'dropdown-item px-6 se_lect-ev past-event'
                      : 'dropdown-item px-6 se_lect-ev'
                  "
                  href="#"
                >
                  <div class="d-flex align-items-center py-6">
                    <div class="ev-dp-box-img d-none"></div>
                    <div class="aep-ev-des">
                      <span class="" role="button">
                        {{ CurrentAdminEvent.EventFullName }}
                      </span>
                      <label class="aep-ev-date">
                        <!-- Dec 14, 2021 12:07 - Dec 15, 2021 12:07 (Asia/Calcutta) -->
                        {{ CurrentAdminEvent.EventTime }}
                      </label>
                    </div>
                  </div>
                  <div class="selected-text">
                    <p>Selected</p>
                  </div>
                </a>
                <!--selected event end-->
                <div class="">
                  <a
                    v-for="AdminEvent in AdminEventsSorted"
                    :key="AdminEvent.EventId"
                    :class="
                      AdminEvent.IsPastEvent
                        ? 'dropdown-item px-6 past-event'
                        : 'dropdown-item px-6'
                    "
                    href="#"
                    @click="OnChangeCurrentEvent(AdminEvent)"
                  >
                    <div class="d-flex align-items-center py-6">
                      <div
                        class="ev-dp-box-img d-none"
                        :style="
                          'background-image: url(' + AdminEvent.EventLogo + ');'
                        "
                      ></div>
                      <div class="aep-ev-des">
                        <span>{{ AdminEvent.EventFullName }}</span>
                        <label class="aep-ev-date">
                          <!-- Dec 14, 2021 12:07 - Dec 15, 2021 12:07
                          (Asia/Calcutta) -->
                          {{ AdminEvent.EventTime }}
                        </label>
                      </div>
                    </div>
                    <div class="ev_list_arrow">
                      <img src="./assets/Images/icons/vote-next.svg" />
                      <!-- <v-icon color="#1976d2" size="50px">mdi-chevron-left</v-icon> -->
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- create event Loader -->
      <v-dialog
        v-model="selfServiceLoader"
        width="300"
        persistent
        content-class="loader-class"
      >
        <div class="gif-wrap">
          <!-- <v-btn
              icon
              class="close-dialog-btn position-absolute"
              @click="openGif = false"
              ><v-icon color="#333333" size="25px">mdi-close</v-icon></v-btn
            > -->
          <div class="gif-hldr">
            <img
              src="./assets/Images/self-service/creating-event-loader-2.gif"
            />
            <p>Please wait while we setup the event for you...</p>
          </div>
        </div>
      </v-dialog>
      <!-- view snackbar-->
      <!-- <v-snackbar top color="primary" timeout="0" v-model="viewSnack">
        <p class="m-0 device-msg">For the Best Experience, Please Rotate your device in Landscape</p>

        <template v-slot:action="{ attrs }">
          <v-btn
            icon
            v-bind="attrs"
            @click="viewSnack = false"
          >
            <v-icon color="#ffffff" size="22px">mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar> -->
      <!-- view snackbar-->
      <!-- create event Loader -->
      <div
        id="social-share"
        class="position-fixed"
        style="
          right: 0px;
          top: 0px;
          background: rgba(255, 255, 255, 0);
          z-index: 999;
          display: none;
          width: 100%;
          height: 100%;
        "
        @click="HideSocialShare"
      >
        <ul
          v-if="ShareEvent"
          class="share-network"
          style="list-style-type: none"
        >
          <li v-for="social in socialShareOptions" :key="social.Name">
            <ShareNetwork
              v-if="siteLink"
              :network="social.Name"
              :url="siteLink"
              :title="ShareEvent.EventFullName"
              :description="pageLink"
              :quote="hostName"
              hashtags="e2mlive"
            >
              <label>{{ social.Label }}</label>
              <span :style="'background:' + social.Color + ';'">
                <img height="25" width="25" :src="social.Icon" />
              </span>
            </ShareNetwork>
          </li>
        </ul>
      </div>

      <v-dialog
        content-class="box-shadow"
        style="z-index: 999999"
        v-model="showPublishConfirmDialog"
        max-width="500px"
        hide-overlay
      >
        <v-card>
          <v-card-title>
            <div
              class="restore-default-head d-flex justify-content-end align-items-start"
            >
              <v-btn
                text
                fab
                color="#1c1d26"
                height="30px"
                width="30px"
                @click="cancelEventStatusConfirm"
                ><v-icon color="#1c1d26" size="25px">mdi-close</v-icon></v-btn
              >
            </div>
            <div
              class="confirmation-option-button pb-10 final-button d-flex justify-content-center align-items-center flex-column"
            >
              <h5 v-if="CurrentAdminEvent && CurrentAdminEvent.IsPublished">
                Are you sure you want to unpublish the event?
              </h5>
              <h5 v-if="CurrentAdminEvent && !CurrentAdminEvent.IsPublished">
                Are you sure you want to publish the event?
              </h5>
              <div class="mt-5">
                <v-btn
                  dark
                  large
                  color="#1c1d26"
                  width="120px"
                  class="mr-2"
                  @click="changeEventStatus"
                  >Yes</v-btn
                >
                <v-btn
                  large
                  color="#1c1d26"
                  outlined
                  width="120px"
                  @click="cancelEventStatusConfirm"
                  >No</v-btn
                >
              </div>
            </div>
          </v-card-title>
        </v-card>
      </v-dialog>

      <div
        id="mobile-preview"
        class="position-fixed"
        style="
          right: 0px;
          top: 0px;
          background: rgba(110, 110, 110, 0.9);
          z-index: 99999;
          display: none;
          width: 100%;
          height: 100%;
        "
        @click="HideMobilePreview"
      >
        <div class="mobile-preview-dropdown d-none" @click.stop="">
          <p class="mb-3">Mobile Preview</p>
          <v-select
            :items="mobileItems"
            label="Choose a device"
            outlined
            dark
            color="#ffffff"
            v-model="selectedMobile"
          ></v-select>
        </div>
        <MobilePreview
          v-if="mobilePreviewVisible"
          :key="mobilePreviewKey"
        ></MobilePreview>
      </div>
      <!-- <div style="text-align:center;">{{hideEventHeaderAndMenu}}-{{ShowTopBar}}</div> -->
      <!-- survey-chat-popup-start -->
      <!-- Button trigger modal -->
      <!-- <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#SurveyModalCenter">
        Launch demo modal
      </button> -->

      <!-- Modal -->
      <!-- <div class="modal fade survey-start-modal" id="SurveyModalCenter" tabindex="-1" role="dialog" aria-labelledby="surveyModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-body">

              <div class="survey-modal-start-wrap">
                <div class="survey-start-modal-top-wrap position-relative">
                  <div class="survey-start-modal-top">
                  </div>
                  <div class="pophead-image">
                  <img src="./assets/Images/survey_1.png"/>
                  </div>
                  <div class="pop-head-image-2">
                    <img src="./assets/Images/icons/survey-icon.svg"/>
                  </div>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="survey-start-popup-statement">
                  <h4>A new Survey has been created by the host.</h4>
                  <v-btn dark color="#2376e5" class="mt-4">Participate Now!</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- survey-chat-popup-End -->
      <!-- Notification-top-left-->
      <div id="pushNotification" class="new-notification">
        <v-card
          v-for="notification in filteredNotificatioData"
          :key="notification.Index"
          class="mx-auto mb-3"
          min-width="344"
          max-width="344"
          color="#ffce44"
          @click="
            isDialing &&
            notification.MeetingId &&
            notification.MeetingType == 'VideoCalling/CallStarted' &&
            notification.CTimestamp + 10000 + extraTime > correntTimeMS
              ? null
              : updateMeetingNotification(notification.NotificationId)
          "
          v-show="
            notification.CTimestamp +
              (isDialing ? dialTime * 1000 : 10000) +
              extraTime >
              correntTimeMS &&
            (notification.MeetingType != 'VideoCalling/CallStarted' ||
              notification.NotificationId == dialingNotificationId)
          "
        >
          <v-list-item three-line>
            <div class="list-item-img-notification mr-2">
              <!--src="https://www.pngfind.com/pngs/m/154-1548293_male-headshot-visitante-icon-hd-png-download.png"-->
              <img
                v-if="notification.Image"
                :src="notification.Image"
                @error="notification.Image = ''"
              />
              <span v-else-if="notification.NameInitial">{{
                notification.NameInitial
              }}</span>
              <img
                v-else
                :src="'https://firebasestorage.googleapis.com/v0/b/e2monair.firebasestorage.app/o/OA_UAT%2FDefaults%2Fimage%2Fnotification-bell.svg?alt=media'"
              />
            </div>
            <v-list-item-content>
              <v-list-item-title class="text-h8 mb-1">
                {{ notification.Title }}
                <!-- <br />{{ isDialing }}-{{ notification.MeetingId  }}-{{ dialingNotificationId }}-{{dialTimeRemaining}} -->
                <!--<br />{{ notification.Index }}-->
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ notification.Message }}
                <!--<br />{{ new Date(notification.Timestamp.seconds * 1000) }}-->
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <div
                  v-if="
                    notification.MeetingId &&
                    notification.NotificationId == dialingNotificationId &&
                    notification.MeetingType == 'VideoCalling/CallStarted' &&
                    notification.CTimestamp +
                      (isDialing ? dialTime * 1000 : 10000) +
                      extraTime >
                      correntTimeMS
                  "
                  class="notification-btn d-flex justify-content-start mb-3 mt-3"
                  style="width: 100%"
                >
                  <div v-if="isDialing">
                    <v-btn
                      width="110px"
                      outline
                      color="#1ab063"
                      class="chat-mouse-pointer mr-2 accept-call"
                      dark
                      @click="
                        startVideoChat({
                          roomId: notification.MeetingId,
                          memberIDs: notification.UserIdList,
                        });
                        updateMeetingNotification(notification.NotificationId);
                      "
                      ><v-icon color="#fff" size="20px">mdi-check</v-icon>
                      Accept
                    </v-btn>
                    <v-btn
                      width="110px"
                      color="#eb4e37"
                      dark
                      class="ml-1 chat-mouse-pointer decline-call"
                      @click="
                        VideoChatDecline({
                          roomId: notification.MeetingId,
                          sender: notification.Sender,
                          actionType: 1,
                        });
                        updateMeetingNotification(notification.NotificationId);
                      "
                      ><v-icon color="#fff" size="20px">mdi-close</v-icon
                      >Decline
                    </v-btn>
                  </div>
                </div>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </div>
      <!-- Notification-top-left-->
      <div
        v-show="ShowTopBar"
        id="topmenu"
        class="topmenu"
        :class="lightOrDark() == 'dark' ? 'darkTop' : 'lightTop'"
      >
        <v-app-bar
          ref="appBarHeader"
          v-show="ShowTopBar"
          id="divHeader"
          flat
          app
          style="display: block !important"
          class=""
        >
          <div
            v-if="showPreviewLogin"
            id="previewMode"
            style="
              width: auto;
              text-align: center;
              padding: 8px 14px;
              background-color: rgb(255, 170, 51);
              color: rgb(255, 255, 255);
              overflow: overlay;
              z-index: 999999;
              position: fixed;
              top: 0px;
              left: 50%;
              line-height: 18px;
              border-radius: 0px 0px 8px 8px;
              box-shadow: rgb(0 0 0 / 50%) 0px 3px 7px;
              transform: translateX(-50%);
            "
          >
            This is Admin Preview,
            <a class="preview-mode-btn" @click="goToCMS()">Click Here</a> to go
            back to CMS or
            <a class="preview-mode-btn" @click="clearstate">Exit Preview</a>
          </div>

          <v-app-bar-nav-icon
            @click.stop="drawer = !drawer"
            class="ml-2"
            v-if="$vuetify.breakpoint.mobile && AllMenuData.length > 0"
          ></v-app-bar-nav-icon>

          <div
            v-if="!$vuetify.breakpoint.mobile && ShowBanner"
            class="banner-width"
          >
            <label
              v-if="IsAdminEditPage"
              for="topBannerFile"
              class="circle_blink_button d-none"
              @click="OpenChangeBanner"
              ><span>&nbsp;</span></label
            >
            <!-- <input
              type="file"
              id="topBannerFile"
              name="topBannerFile"
              @change="onTopBannerFileChange"
            /> -->

            <!--link plus end-->

            <a
              v-if="BannerURL"
              id="routerlnkBanner"
              class="full-width d-block"
              href="javascript:void(0);"
              target="_blank"
            >
              <img
                id="imgBanner"
                class="full-width"
                :src="BannerURL"
                alt="e2m"
                @load="onTopBannerLoad"
              />
            </a>
            <div
              v-if="!app"
              class="head-top-wrap full-width d-flex align-items-center"
            >
              <div class="row justify-content-between my-0">
                <div class="col py-0 text-center">
                  <!--preview mode start-->
                  <div
                    v-if="
                      ShowQuickEventSelection &&
                      IsAdminPreviewPage &&
                      isEventAdmin()
                    "
                    class="top-blue-previewmode"
                  >
                    <span v-show="previewOpened" class="mr-2">
                      <router-link :to="PreviewOrEditLink">
                        <img
                          src="./assets/Images/icons/exit-preview.svg"
                          alt="e2m"
                        />
                      </router-link>
                    </span>
                    <span v-show="previewOpened">
                      You are in preview mode
                    </span>
                    <span v-show="previewOpened" class="selected ml-2">
                      <img
                        src="./assets/Images/icons/preview-desktop.svg"
                        alt="e2m"
                      />
                    </span>
                    <span
                      v-show="previewOpened"
                      class="cursor-pointer"
                      @click="ShowMobilePreview"
                    >
                      <img
                        src="./assets/Images/icons/preview-mobile.svg"
                        alt="e2m"
                      />
                    </span>
                    <span
                      :class="previewOpened ? '' : 'down-arrow'"
                      @click="previewOpened = !previewOpened"
                    >
                      <img
                        src="./assets/Images/icons/hide-arrow.svg"
                        alt="e2m"
                      />
                    </span>
                  </div>
                  <!--preview mode end-->
                  <div class="sstop-btn-hld">
                    <v-menu
                      v-if="
                        ShowAdminOptions &&
                        ShowAdminEventMenu &&
                        CurrentAdminEvent
                      "
                      nudge-bottom="18"
                      offset-y
                      open-on-hover
                      style="z-index: 9999"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <ul class="manage-menu">
                          <li v-bind="attrs" v-on="on">
                            <!-- <router-link to="/overview" class="btn btn-dp"> -->
                            <router-link to="/eventsetup" class="btn btn-dp">
                              <!-- <a v-bind="attrs" v-on="on" class="btn btn-dp"> -->
                              <!-- <span> <i class="fa fa-gear"></i> {{ $t("menu.manage") }} </span> -->
                              <span>
                                <i class="fa fa-gear mr-2"></i>
                                {{
                                  CurrentAdminEvent &&
                                  CurrentAdminEvent.IsPublished
                                    ? "Modify Setup"
                                    : "Finish Setup"
                                }}
                              </span>
                              <label class="drop-toggle"> </label>
                              <!-- </a> -->
                            </router-link>
                          </li>
                        </ul>
                      </template>
                      <v-list>
                        <ul class="manage-dropdown">
                          <li v-if="ShowAdminEventMenu">
                            <router-link to="/eventsetup">
                              <span class="pl-0">
                                <v-icon color="#585963" size="20px"
                                  >mdi-application-cog-outline</v-icon
                                >
                                {{ $t("menu.basicsetup") }}
                              </span>
                            </router-link>
                          </li>
                          <li v-if="ShowAdminEventMenu" @click="OpenManageMenu">
                            <a>
                              <span class="pl-0">
                                <v-icon color="#585963" size="20px"
                                  >mdi-menu</v-icon
                                >
                                {{ $t("menu.managemenu") }}
                              </span>
                            </a>
                          </li>
                          <li>
                            <router-link
                              v-if="ShowAdminEventMenu"
                              :to="'/admin-event/' + eventId"
                            >
                              <span
                                class="pl-0 d-flex justify-content-start align-items-center"
                              >
                                <!-- <v-icon color="#585963" size="20px"
                                  >mdi-account-plus-outline</v-icon> -->
                                <img
                                  src="./assets/Images/reg-ico/registration.svg"
                                  width="20px"
                                  height="20px"
                                  class="mr-3"
                                />
                                {{ $t("menu.registration") }}
                              </span>
                            </router-link>
                            <router-link v-else :to="'/eventv3/' + eventId">
                              <span class="pl-0">
                                <v-icon color="#585963" size="20px"
                                  >mdi-account-plus-outline</v-icon
                                >
                                {{ $t("menu.registration") }}
                              </span>
                            </router-link>
                          </li>
                          <li v-if="ShowAdminEventMenu">
                            <router-link to="/overview">
                              <span class="pl-0">
                                <v-icon color="#585963" size="20px"
                                  >mdi-poll</v-icon
                                >
                                {{ $t("menu.analytics") }}
                              </span>
                            </router-link>
                          </li>
                          <li>
                            <a
                              v-if="AdminEvents.length > 1"
                              @click="OpenAdminEventsPopup"
                            >
                              <span
                                class="pl-0 d-flex justify-content-start align-items-center"
                              >
                                <!-- <v-icon color="#585963" size="20px"
                                  >mdi-calendar-text-outline</v-icon> -->
                                <img
                                  src="./assets/Images/reg-ico/switch-event.svg"
                                  width="23px"
                                  height="23px"
                                  class="mr-2"
                                />
                                {{ $t("menu.switchEvent") }}
                              </span>
                            </a>
                          </li>
                        </ul>
                      </v-list>
                    </v-menu>
                    <v-menu
                      v-if="
                        ShowQuickEventSelection &&
                        IsAdminEditPage &&
                        CurrentAdminEvent
                      "
                      nudge-bottom="18"
                      offset-y
                      open-on-hover
                      style="z-index: 9999"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <ul class="pl-0">
                          <li>
                            <a
                              v-bind="attrs"
                              v-on="on"
                              class="btn btn-publish btn-dp"
                              @click="changeEventStatusConfirm()"
                            >
                              <span
                                v-if="
                                  CurrentAdminEvent &&
                                  CurrentAdminEvent.IsPublished
                                "
                              >
                                <img
                                  src="./assets/Images/reg-ico/unpublish-3.svg"
                                  class="mr-2"
                                />
                                {{ $t("menu.unpublish") }}
                              </span>
                              <span
                                v-if="
                                  CurrentAdminEvent &&
                                  !CurrentAdminEvent.IsPublished
                                "
                              >
                                <img
                                  src="./assets/Images/reg-ico/publish-3.svg"
                                  class="mr-2"
                                />
                                {{ $t("menu.publish") }}
                              </span>
                              <label class="drop-toggle"></label>
                            </a>
                          </li>
                        </ul>
                      </template>
                      <v-list>
                        <ul class="manage-dropdown">
                          <li v-if="IsAdminEditPage && HasPreviewPage">
                            <!-- <a>
                              <span class="pl-0"> Preview </span>
                            </a> -->
                            <router-link class="" :to="PreviewOrEditLink">
                              <v-icon color="#585963" size="20px">
                                mdi-eye-arrow-right-outline
                              </v-icon>
                              {{ $t("menu.preview") }}
                            </router-link>
                          </li>
                          <li v-if="false">
                            <a
                              href="javascript:void(0)"
                              @click="openInviteDialog()"
                            >
                              <span class="pl-0">
                                <v-icon color="#585963" size="20px">
                                  mdi-account-plus-outline
                                </v-icon>
                                {{ $t("menu.invite") }}
                              </span>
                            </a>
                          </li>
                          <li>
                            <a @click="ShowSocialShare()">
                              <span class="pl-0">
                                <v-icon color="#585963" size="20px">
                                  mdi-share-outline
                                </v-icon>
                                {{ $t("menu.share") }}
                              </span>
                            </a>
                          </li>
                        </ul>
                      </v-list>
                    </v-menu>
                    <ul
                      v-if="ShowBannerMenu || ShowAdminEventMenu"
                      class="px-0"
                    >
                      <li>
                        <div
                          v-if="helpChatIcon"
                          class="cursor-pointer"
                          data-toggle="tooltip"
                          data-placement="left"
                          data-original-title="Get Help"
                          @click="turnOnHelp()"
                        >
                          <img
                            v-if="lightOrDark() == 'light'"
                            src="./assets/Images/help-top.svg"
                            alt="e2m"
                            width="28"
                            height="28"
                          />
                          <img
                            v-else
                            src="./assets/Images/help-top.svg"
                            alt="e2m"
                            width="28"
                            height="28"
                          />
                        </div>
                      </li>
                      <li v-if="!ShowAdminEventMenu && !publicEventCollection">
                        <router-link
                          class="pb-1 top-banner-menu"
                          :to="EnableSelfService ? '/showcase' : '/events'"
                        >
                          {{ $t("menu.eventtemplate") }}
                        </router-link>
                      </li>
                      <li v-if="!ShowAdminEventMenu && false">
                        <router-link
                          class="pb-1 top-banner-menu"
                          :to="EnableSelfService ? '/events' : '/events'"
                        >
                          {{ $t("menu.eventhub") }}
                        </router-link>
                      </li>
                      <li v-if="IsEventListPage && EnableSelfService && false">
                        <button
                          v-if="uid"
                          class="btn btn-primary"
                          @click="CreateEventPopup()"
                        >
                          {{ $t("menu.createevent") }}
                        </button>
                        <button
                          v-else
                          class="btn btn-primary"
                          @click="DisplaySignInPopup()"
                        >
                          {{ $t("menu.createevent") }}
                        </button>
                      </li>
                      <!-- <li>
                        <div
                          v-if="showNotification"
                          class="
                            notification-icon
                            d-inline-block
                            mr-4
                            position-relative
                          "
                          @click="displayMyNotifications"
                        >
                          <span
                            v-show="filteredNotificatioData.length > 0"
                            class="badge"
                            >{{ filteredNotificatioData.length }}</span
                          >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="28"
                            height="28"
                            viewBox="0 0 20 24"
                          >
                            <path
                              id="notification.svg"
                              fill="#585963"
                              d="M1463,2078h0a4,4,0,0,1-8,0h-6v-2h1v-8c0-5.19,1.96-9.4,7.02-9.9a19.411,19.411,0,0,1,3.96,0c5.06,0.5,7.02,4.71,7.02,9.9v8h1v2h-6Zm-6,0a2,2,0,0,0,4,0h-4Zm9-6v-4c0-4.42-1.58-8-6-8h-2c-4.42,0-6,3.58-6,8v8h14v-4Z"
                              transform="translate(-1449 -2058)"
                            />
                          </svg>
                        </div>
                      </li> -->
                      <!-- <li v-if="ShowSignInPopup && !hasSession">
                        <a href="javascript:void(0)" @click="DisplaySignInPopup"
                          >Sign In</a
                        >
                      </li> -->
                      <!-- v-else-if="!hasSession" -->

                      <li v-if="!uid">
                        <router-link class="pb-1 top-banner-menu" to="/">
                          <img src="./assets/Images/reg-ico/sign-in.svg" />
                          {{ $t("menu.signin") }}
                        </router-link>
                      </li>
                      <li
                        v-else-if="currentRouteName != 'AdminStageView'"
                        class="nav-item dropdown"
                      >
                        <v-menu open-on-hover nudge-bottom="40" rounded="6">
                          <template v-slot:activator="{ on, attrs }">
                            <a
                              v-bind="attrs"
                              v-on="on"
                              class="nav-link"
                              href="#"
                              id="navbarDropdownMenuLink"
                            >
                              <img
                                v-if="getUserProfilePictureURL"
                                :src="getUserProfilePictureURL"
                                :alt="getUserInitial"
                                class="rounded-circle"
                                width="30"
                                height="30"
                              />
                              <v-avatar
                                v-else
                                size="30"
                                style="text-transform: uppercase"
                                color="grey"
                              >
                                {{ getUserInitial }}
                              </v-avatar>
                              <span
                                class="dropbtn pl-2 top-banner-menu"
                                :style="'color:' + getMenuFont + '!important'"
                              >
                                {{ getUserFirstName }}
                                <!-- <i class="fa fa-caret-down"></i> -->
                              </span>
                            </a>
                          </template>

                          <v-list
                            class="manage-ev-dp"
                            aria-labelledby="navbarDropdownMenuLink"
                          >
                            <a
                              v-if="EnableSelfService"
                              class="dropdown-item d-none"
                              href="javascript:void(0)"
                              @click="OpenMyUserProfile"
                            >
                              <v-icon color="#585963" size="20px">
                                mdi-account-circle-outline
                              </v-icon>
                              {{ $t("menu.editprofile") }}
                            </a>
                            <router-link
                              v-if="!IsEventListPage && !publicEventCollection"
                              class="dropdown-item"
                              to="/showcase"
                            >
                              <v-icon color="#585963" size="20px">
                                mdi-home-outline</v-icon
                              >
                              {{ $t("menu.eventtemplate") }}
                            </router-link>
                            <!-- <a
                              v-if="!IsAdminEditPage && !disableLanguageOption"
                              id="switchLanguageLink"
                              href="#chnagelangModalCenter"
                              data-toggle="modal"
                              data-target="#chnagelangModalCenter"
                            >
                              <v-icon color="#585963" size="20px">
                                mdi-translate</v-icon
                              >
                              {{ $t("menu.language") }}
                            </a> -->
                            <router-link
                              v-if="hasEventAdminRole()"
                              class="dropdown-item"
                              to="/eventoverview#ManageMyEvents"
                            >
                              <v-icon color="#585963" size="20px">
                                mdi-calendar-cursor</v-icon
                              >
                              {{ $t("menu.managemyevents") }}
                            </router-link>
                            <router-link
                              v-if="hasEventAdminRole()"
                              class="dropdown-item"
                              to="/eventlist"
                              ><v-icon color="#585963" size="20px">
                                mdi-calendar-text-outline</v-icon
                              >
                              {{ $t("menu.viewallevents") }}
                            </router-link>
                            <a
                              v-if="
                                !EnableSelfService &&
                                (isClientAdmin() || isEventAdmin())
                              "
                              id="AdminConsolelnk"
                              href="https://onaircms.e2m.live/"
                              class="dropdown-item"
                              target="blank"
                            >
                              <span
                                class="d-flex justify-content-start align-items-center"
                              >
                                <v-icon color="#585963" size="20px" class="mr-1"
                                  >mdi-console</v-icon
                                >
                                {{ $t("menu.adminConsole") }}
                                <v-icon color="#333" size="20px" class="ml-2"
                                  >mdi-open-in-new</v-icon
                                ></span
                              >
                            </a>
                            <a
                              class="dropdown-item"
                              href="javascript:void(0)"
                              @click="Logout"
                              ><v-icon color="#585963" size="20px"
                                >mdi-logout</v-icon
                              >
                              {{ $t("menu.logout") }}
                            </a>
                          </v-list>
                        </v-menu>
                      </li>
                    </ul>
                  </div>
                </div>
                <!-- <div class="col t-fixed-w py-0">
                </div> -->
              </div>
            </div>
          </div>
          <v-spacer v-if="$vuetify.breakpoint.mobile && !app"></v-spacer>
          <div
            v-if="$vuetify.breakpoint.mobile && showChatIcon && !app"
            class="chat-icon d-inline-block mr-6 position-relative"
            @click="clickToOpenChat()"
          >
            <span v-show="totalUnReadMsg >= 1" class="badge">{{
              totalUnReadMsg
            }}</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M4.25895 16.5936C3.14076 14.7086 2.74916 12.4802 3.15768 10.3269C3.56621 8.17365 4.74675 6.24356 6.47764 4.89909C8.20853 3.55462 10.3707 2.88826 12.5581 3.02514C14.7455 3.16202 16.8078 4.09273 18.3575 5.6425C19.9073 7.19226 20.838 9.25448 20.9749 11.4419C21.1118 13.6293 20.4455 15.7915 19.101 17.5224C17.7565 19.2533 15.8264 20.4338 13.6732 20.8424C11.5199 21.2509 9.29149 20.8593 7.40649 19.7411L7.40651 19.741L4.29808 20.6292C4.16947 20.6659 4.03338 20.6676 3.90391 20.634C3.77443 20.6005 3.65628 20.5329 3.5617 20.4384C3.46713 20.3438 3.39956 20.2256 3.36601 20.0961C3.33246 19.9667 3.33415 19.8306 3.37089 19.702L4.25901 16.5935L4.25895 16.5936Z"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12 13.125C12.6213 13.125 13.125 12.6213 13.125 12C13.125 11.3787 12.6213 10.875 12 10.875C11.3787 10.875 10.875 11.3787 10.875 12C10.875 12.6213 11.3787 13.125 12 13.125Z"
                fill="white"
              />
              <path
                d="M7.5 13.125C8.12132 13.125 8.625 12.6213 8.625 12C8.625 11.3787 8.12132 10.875 7.5 10.875C6.87868 10.875 6.375 11.3787 6.375 12C6.375 12.6213 6.87868 13.125 7.5 13.125Z"
                fill="white"
              />
              <path
                d="M16.5 13.125C17.1213 13.125 17.625 12.6213 17.625 12C17.625 11.3787 17.1213 10.875 16.5 10.875C15.8787 10.875 15.375 11.3787 15.375 12C15.375 12.6213 15.8787 13.125 16.5 13.125Z"
                fill="white"
              />
            </svg>
          </div>
          <div
            v-if="$vuetify.breakpoint.mobile && showNotification && !app"
            class="notification-icon d-inline-block mr-6 position-relative"
            @click="displayMyNotifications"
          >
            <span v-show="filteredNotificatioData.length > 0" class="badge">{{
              filteredNotificatioData.length
            }}</span>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 21H15"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.26904 9.74994C5.2678 8.86045 5.44262 7.97951 5.78343 7.1579C6.12424 6.33628 6.6243 5.59025 7.25477 4.9628C7.88525 4.33535 8.63368 3.83889 9.45693 3.50204C10.2802 3.16519 11.1619 2.99461 12.0514 3.00013C15.763 3.02772 18.7317 6.11276 18.7317 9.83468V10.4999C18.7317 13.8577 19.4342 15.8061 20.0529 16.871C20.1196 16.9848 20.1551 17.1142 20.1558 17.246C20.1565 17.3779 20.1224 17.5076 20.0569 17.6221C19.9915 17.7366 19.8971 17.8318 19.7831 17.8982C19.6691 17.9645 19.5397 17.9996 19.4078 17.9999H4.59222C4.46034 17.9996 4.33087 17.9645 4.21689 17.8981C4.1029 17.8318 4.00844 17.7366 3.94301 17.622C3.87759 17.5075 3.84352 17.3778 3.84425 17.2459C3.84498 17.114 3.88048 16.9846 3.94716 16.8709C4.56622 15.8059 5.26904 13.8575 5.26904 10.4999L5.26904 9.74994Z"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>

          <!-- <v-btn><v-icon>mdi-bell-outline</v-icon></v-btn> -->
          <v-menu
            v-if="$vuetify.breakpoint.mobile && !app"
            offset-y
            nudge-bottom="6"
            content-class="app-mobile-user-menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="mr-1" icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <div v-if="uid" class="app-mobile-user-menu-header">
              <v-avatar size="40">
                <img
                  v-if="getUserProfilePictureURL"
                  :src="getUserProfilePictureURL"
                  alt="user"
                />
                <v-avatar v-else color="teal" size="40">
                  <span class="white--text">{{ getUserInitial }}</span>
                </v-avatar>
              </v-avatar>
              <div class="app-mobile-user-menu-name">
                {{ getUserName }}
              </div>
            </div>
            <v-list class="app-mobile-user-menu-list">
              <v-list-item
                v-if="uid && EnableSelfService && !publicEventCollection"
                @click="$router.push('/showcase')"
              >
                <v-list-item-icon>
                  <v-icon size="20" color="#585963">mdi-home-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{
                  $t("menu.eventtemplate")
                }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="uid && IsAdminEditPage"
                @click="$router.push('/eventoverview#ManageMyEvents')"
              >
                <v-list-item-icon>
                  <v-icon size="20" color="#585963">mdi-calendar-cursor</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{
                  $t("menu.managemyevents")
                }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="uid && ShowEventMenu && !isVisitor()"
                @click="$router.push('/myprofile')"
              >
                <v-list-item-icon>
                  <span class="app-mobile-user-menu-svg">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M21.0802 8.58003V15.42C21.0802 16.54 20.4802 17.58 19.5102 18.15L13.5702 21.58C12.6002 22.14 11.4002 22.14 10.4202 21.58L4.48016 18.15C3.51016 17.59 2.91016 16.55 2.91016 15.42V8.58003C2.91016 7.46003 3.51016 6.41999 4.48016 5.84999L10.4202 2.42C11.3902 1.86 12.5902 1.86 13.5702 2.42L19.5102 5.84999C20.4802 6.41999 21.0802 7.45003 21.0802 8.58003Z"
                        stroke="#585963"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M11.9999 11.0001C13.2867 11.0001 14.3299 9.95687 14.3299 8.67004C14.3299 7.38322 13.2867 6.34009 11.9999 6.34009C10.7131 6.34009 9.66992 7.38322 9.66992 8.67004C9.66992 9.95687 10.7131 11.0001 11.9999 11.0001Z"
                        stroke="#585963"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M16 16.6601C16 14.8601 14.21 13.4001 12 13.4001C9.79 13.4001 8 14.8601 8 16.6601"
                        stroke="#585963"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                </v-list-item-icon>
                <v-list-item-title>{{
                  $t("menu.myProfile")
                }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="uid && ShowEventMenu && !isVisitor()"
                @click="openBriefcase()"
              >
                <v-list-item-icon>
                  <span class="app-mobile-user-menu-svg">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M7.99983 22H15.9998C20.0198 22 20.7398 20.39 20.9498 18.43L21.6998 10.43C21.9698 7.99 21.2698 6 16.9998 6H6.99983C2.72983 6 2.02983 7.99 2.29983 10.43L3.04983 18.43C3.25983 20.39 3.97983 22 7.99983 22Z"
                        stroke="#585963"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M8 6V5.2C8 3.43 8 2 11.2 2H12.8C16 2 16 3.43 16 5.2V6"
                        stroke="#585963"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M14 13V14C14 14.01 14 14.01 14 14.02C14 15.11 13.99 16 12 16C10.02 16 10 15.12 10 14.03V13C10 12 10 12 11 12H13C14 12 14 12 14 13Z"
                        stroke="#585963"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M21.65 11C19.34 12.68 16.7 13.68 14 14.02"
                        stroke="#585963"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M2.62012 11.27C4.87012 12.81 7.41012 13.74 10.0001 14.03"
                        stroke="#585963"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                </v-list-item-icon>
                <v-list-item-title>{{
                  $t("menu.myBriefcase")
                }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="uid && ShowEventMenu && isSpeaker && myAgendaCount"
                @click="$router.push('/speakerslounge')"
              >
                <v-list-item-icon>
                  <v-icon size="20" color="#585963">mdi-microphone-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{
                  $t("menu.speakersLounge")
                }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="uid && !IsAdminEditPage && !disableLanguageOption"
                href="#chnagelangModalCenter"
                data-toggle="modal"
                data-target="#chnagelangModalCenter"
              >
                <v-list-item-icon>
                  <v-icon size="20" color="#585963">mdi-translate</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{
                  $t("menu.language")
                }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="uid && $store.state.eventCount > 1"
                @click="switchEvent()"
              >
                <v-list-item-icon>
                  <span class="app-mobile-user-menu-svg">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M3.58008 5.15991H17.4201C19.0801 5.15991 20.4201 6.49991 20.4201 8.15991V11.4799"
                        stroke="#585963"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M6.74008 2L3.58008 5.15997L6.74008 8.32001"
                        stroke="#585963"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M20.4201 18.84H6.58008C4.92008 18.84 3.58008 17.5 3.58008 15.84V12.52"
                        stroke="#585963"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M17.2598 21.9999L20.4198 18.84L17.2598 15.6799"
                        stroke="#585963"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                </v-list-item-icon>
                <v-list-item-title>{{
                  $store.state.DefaultLoginLandingPage == "/clientLobby"
                    ? $t("menu.switchEventClient")
                    : $t("menu.switchEvent")
                }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="
                  uid &&
                  !EnableSelfService &&
                  (isClientAdmin() || isEventAdmin())
                "
                href="https://onaircms.e2m.live/"
                target="blank"
              >
                <v-list-item-icon>
                  <v-icon size="20" color="#585963">mdi-console</v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                  {{ $t("menu.adminConsole") }}
                  <v-icon color="#333" size="16" class="ml-1">mdi-open-in-new</v-icon>
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="uid" @click.prevent="Logout">
                <v-list-item-icon>
                  <span class="app-mobile-user-menu-svg">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M8.90039 7.55999C9.21039 3.95999 11.0604 2.48999 15.1104 2.48999H15.2404C19.7104 2.48999 21.5004 4.27999 21.5004 8.74999V15.27C21.5004 19.74 19.7104 21.53 15.2404 21.53H15.1104C11.0904 21.53 9.24039 20.08 8.91039 16.54"
                        stroke="#585963"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M15.0001 12H3.62012"
                        stroke="#585963"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M5.85 8.65002L2.5 12L5.85 15.35"
                        stroke="#585963"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                </v-list-item-icon>
                <v-list-item-title>{{ $t("menu.logout") }}</v-list-item-title>
              </v-list-item>
              <v-list-item v-else @click="$router.push('/')">
                <v-list-item-icon>
                  <v-icon size="20" color="#585963">mdi-login</v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                  {{ $t("menu.signin") }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <template
            v-if="
              !$vuetify.breakpoint.mobile &&
              ShowTopMenuBar &&
              (ShowEventMenu || ShowAdminEventMenu) &&
              !app
            "
            v-slot:extension
            class="pl-0"
          >
            <div
              id="divBannerTop"
              :class="
                ShowAdminEventMenu
                  ? 'banner-toppart self-s-custom-menu1'
                  : 'banner-toppart'
              "
              :style="'height:51px; background-color:' + topBannerColour"
            >
              <div
                :class="
                  event_collectionName
                    ? 'container pa-0'
                    : 'container pa-0 justify-content-center'
                "
              >
                <div
                  class="menu-player-info-switch d-none pl-2"
                  @click="toggleMenuPlayerInfo"
                >
                  <span class="player-info player-info-close" />
                </div>
                <!-- <table class="menubtn-icon d-block d-md-none">
                  <tbody>
                    <tr>
                      <td>
                        <button
                          id="open-button"
                          type="button"
                          class="menubtn-icon"
                          @click="openMenu"
                        >
                          <span class="icon-bar" />
                          <span class="icon-bar" />
                          <span class="icon-bar" />
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table> -->
                <span
                  v-show="event_collectionName"
                  class="icon ico-home menu-back"
                  style="background-image: none"
                ></span>
                <!-- <router-link
            id="ancHome"
            v-bind:to="homeUrl"
            class="icon ico-home menu-back"
            data-toggle="tooltip"
            data-placement="bottom"
            title
            data-original-title="Home"
          >Lobby</router-link>-->
                <!----top nav link------->
                <!-- Nav tabs -->
                <div id="menuSessionInfo" class="menu-session-info d-none">
                  <p style="margin-bottom: 0px !important"></p>
                </div>
                <div
                  id="topMenuWrap"
                  class="menu-dot-top"
                  style="display: flex"
                >
                  <!-- {{ dialTimeRemaining }} -->
                  <ul
                    v-show="ShowEventMenu || ShowAdminEventMenu"
                    class="nav nav-tabs nav-tab-one p-0"
                  >
                    <!-- <li
                      v-for="item in PublicMenuList"
                      v-show="ShowPublicMenu"
                      :id="
                        'li' +
                        String(item.PageUrl).substring(1, item.PageUrl.length)
                      "
                      :key="item.MenuID"
                      class="nav-item"
                      :data-val="item.MenuID"
                      :element-type="'menu'"
                      @click="onMenuCLick($event)"
                    >
                      <router-link
                        class="nav-link tab-link left-effect"
                        :style="'color:' + getMenuFont"
                        :to="getMenuUrl(item.MenuID, String(item.PageUrl))"
                        onmouseover="hovermenu(this)"
                        :element-type="'menu'"
                      >
                        <span v-if="item.IconUrl">
                          <img :src="item.IconUrl" alt="icon" />
                        </span>
                        <span>
                          {{
                            $store.state.locale == "German" &&
                            item.DisplayLabel_de
                              ? item.DisplayLabel_de
                              : $store.state.locale == "French" &&
                                item.DisplayLabel_fr
                              ? item.DisplayLabel_fr
                              : $store.state.locale == "Chinese" &&
                                item.DisplayLabel_zh
                              ? item.DisplayLabel_zh
                              : $store.state.locale == "Spanish" &&
                                item.DisplayLabel_es
                              ? item.DisplayLabel_es
                              : item.DisplayLabel
                          }}
                        </span>
                      </router-link>
                    </li> -->
                    <li
                      v-for="item in MenuData.slice(0, 5)"
                      :id="
                        'li' +
                        String(item.PageUrl).substring(1, item.PageUrl.length)
                      "
                      :key="item.MenuID"
                      class="nav-item"
                      :data-val="item.MenuID"
                      :element-type="'menu'"
                      @click="onMenuCLick($event)"
                    >
                      <router-link
                        class="nav-link tab-link left-effect"
                        :style="'color:' + getMenuFont"
                        :to="getMenuUrl(item.MenuID, String(item.PageUrl))"
                        onmouseover="hovermenu(this)"
                        :element-type="'menu'"
                      >
                        <span>
                          <img :src="getTopMenuIcon(item)" alt="icon" />
                        </span>
                        <span>
                          {{ getNavDisplayLabel(item) }}
                        </span>
                      </router-link>
                    </li>
                  </ul>

                  <v-menu
                    v-if="ShowEventMenu && MenuData.length > 5"
                    nudge-bottom="18"
                    offset-y
                    style="z-index: 9999"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <img
                        v-if="lightOrDark() == 'light'"
                        class="ml-2"
                        v-bind="attrs"
                        v-on="on"
                        src="./assets/Images/circular-dot.svg"
                        style="transform: rotate(90deg)"
                      />
                      <img
                        v-else
                        class="ml-2"
                        v-bind="attrs"
                        v-on="on"
                        src="./assets/Images/circular-dot-dark.svg"
                        style="transform: rotate(90deg)"
                      />
                    </template>

                    <v-list>
                      <template
                        v-for="(item, index) in MenuData.slice(
                          4,
                          MenuData.length
                        )"
                      >
                        <v-hover :key="index">
                          <v-list-item
                            :style="
                              'cursor: pointer' + 'color:' + getMenuFont != ''
                                ? getMenuFont
                                : '#1c1d26'
                            "
                            :element-type="'menu'"
                          >
                            <router-link
                              class="nav-link tab-link"
                              :style="
                                'color:' + getMenuFont != ''
                                  ? getMenuFont
                                  : '#1c1d26'
                              "
                              :to="String(item.PageUrl)"
                              :element-type="'menu'"
                              onmouseover="hovermenu(this)"
                            >
                              <span style="color: #1c1d26">
                                <img :src="getTopMenuIcon(item)" alt="icon" />
                              </span>
                              <span
                                style="
                                  font-size: 18px;
                                  font-weight: 600;
                                  margin-left: 5px;
                                  color: #1c1d26;
                                "
                              >
                                {{ getNavDisplayLabel(item) }}
                              </span>
                            </router-link>
                          </v-list-item>
                        </v-hover>
                      </template>
                    </v-list>
                  </v-menu>

                  <ul
                    v-if="ShowAdminOptions && ShowAdminEventMenu"
                    class="nav nav-tabs nav-tab-one d-none"
                  >
                    <!---gear icon-->
                    <li class="nav-item">
                      <a href="#" class="nav-link tab-link">
                        <span class="pl-0">
                          <i class="fa fa-gear"></i>
                        </span>
                      </a>
                    </li>
                    <!---gear icon-->
                    <li class="nav-item">
                      <router-link
                        v-if="ShowAdminEventMenu"
                        to="/analytics"
                        class="nav-link tab-link"
                      >
                        <span class="pl-0"> Analytics </span>
                      </router-link>
                    </li>
                    <li class="nav-item">
                      <router-link
                        v-if="ShowAdminEventMenu"
                        :to="'/admin-event/' + eventId"
                        class="nav-link tab-link"
                      >
                        <span class="pl-0"> Registration </span>
                      </router-link>
                      <router-link
                        v-else
                        :to="'/eventv3/' + eventId"
                        class="nav-link tab-link"
                      >
                        <span class="pl-0"> Registration </span>
                      </router-link>
                    </li>
                  </ul>

                  <!-- <ul
                    class="nav nav-tabs nav-tab-one"
                  >
                    <li class="nav-item">
                      <a class="nav-link tab-link" href="#">
                        <span class="pl-0">Get Help</span>
                      </a>
                    </li>
                    <li class="nav-item">
                      <router-link
                        :class="
                          currentRouteName == 'Events'
                            ? 'nav-link tab-link router-link-active'
                            : 'nav-link tab-link'
                        "
                        to="/events"
                      >
                        <span class="pl-0"> Event Hub</span>
                      </router-link>
                    </li>
                    <li v-if="!uid" class="nav-item">
                      <router-link class="nav-link tab-link" to="/">
                        <span class="pl-0">Login</span>
                      </router-link>
                    </li>
                  </ul> -->
                </div>

                <!-- Menu for mobile-->
                <ul
                  id="headerMenuParent"
                  class="nav nav-tabs nav-tab-one d-block d-md-none d-lg-none"
                >
                  <li
                    v-for="item in AllMenuData"
                    :id="
                      'li' +
                      String(item.PageUrl).substring(1, item.PageUrl.length)
                    "
                    :key="item.MenuID"
                    class="nav-item"
                    :data-val="item.MenuID"
                    :element-type="'menu'"
                    @click="onMenuCLick($event, true)"
                  >
                    <router-link
                      class="nav-link tab-link"
                      :style="'color:' + getMenuFont"
                      :to="String(item.PageUrl)"
                      onmouseover="hovermenu(this)"
                      :element-type="'menu'"
                    >
                      <span>
                        <img :src="getTopMenuIcon(item)" alt="icon" />
                      </span>
                      <!-- <span :style="'color:' + getMenuFont" > -->
                      <span
                        v-if="
                          $store.state.locale == 'German' &&
                          item.DisplayLabel_de
                        "
                      >
                        {{ item.DisplayLabel_de }}
                      </span>
                      <span
                        v-else-if="
                          $store.state.locale == 'English' && item.DisplayLabel
                        "
                      >
                        {{ item.DisplayLabel }}
                      </span>
                      <span
                        v-else-if="
                          $store.state.locale == 'French' &&
                          item.DisplayLabel_fr
                        "
                      >
                        {{ item.DisplayLabel_fr }}
                      </span>
                      <span
                        v-else-if="
                          $store.state.locale == 'Chinese' &&
                          item.DisplayLabel_zh
                        "
                      >
                        {{ item.DisplayLabel_zh }}
                      </span>
                      <span
                        v-else-if="
                          $store.state.locale == 'Spanish' &&
                          item.DisplayLabel_es
                        "
                      >
                        {{ item.DisplayLabel_es }}
                      </span>
                      <span v-else>
                        {{ item.DisplayLabel }}
                      </span>
                      <!-- </span> -->
                    </router-link>
                  </li>
                </ul>
                <div class="mob-menu-overlay d-none" @click="closeSubMenu" />
                <!----top nav link------->
                <div class="topHeader-Right d-flex align-items-center w-auto">
                  <!-- Notification Icon Start -->
                  <!--data-toggle="modal"
              data-target="#notification"-->

                  <!-- <ul
                    class="nav nav-tabs nav-tab-one mr-2"
                  >
                    <li class="nav-item">
                      <a class="nav-link tab-link" href="#">
                        <span class="pl-0">Get Help</span>
                      </a>
                    </li>
                    <li class="nav-item">
                      <router-link
                        :class="
                          currentRouteName == 'Events'
                            ? 'nav-link tab-link router-link-active'
                            : 'nav-link tab-link'
                        "
                        to="/events"
                      >
                        <span class="pl-0"> Event Hub</span>
                      </router-link>
                    </li>
                    <li v-if="!uid" class="nav-item">
                      <router-link class="nav-link tab-link" to="/">
                        <span class="pl-0">Login</span>
                      </router-link>
                    </li>
                  </ul> -->
                  <div
                    v-if="
                      (ShowEventMenu || ShowAdminEventMenu) &&
                      event_collectionName &&
                      helpChatIcon
                    "
                    class="top-help"
                    data-toggle="tooltip"
                    data-placement="left"
                    data-original-title="Get Help"
                    @click="turnOnHelp()"
                    style="flex: 48px 0 0; text-align: right"
                  >
                    <svg
                      v-if="lightOrDark() == 'light'"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M17 18.43H13L8.54999 21.39C7.88999 21.83 7 21.36 7 20.56V18.43C4 18.43 2 16.43 2 13.43V7.42993C2 4.42993 4 2.42993 7 2.42993H17C20 2.42993 22 4.42993 22 7.42993V13.43C22 16.43 20 18.43 17 18.43Z"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M11.9998 11.36V11.15C11.9998 10.47 12.4198 10.11 12.8398 9.82001C13.2498 9.54001 13.6598 9.18002 13.6598 8.52002C13.6598 7.60002 12.9198 6.85999 11.9998 6.85999C11.0798 6.85999 10.3398 7.60002 10.3398 8.52002"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M11.9955 13.75H12.0045"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <!-- <img
                      
                      src="./assets/Images/help-top.svg"
                      alt="e2m"
                    /> -->
                    <img v-else src="./assets/Images/help-top.svg" alt="e2m" />
                  </div>

                  <div
                    v-if="
                      (ShowEventMenu || ShowAdminEventMenu) &&
                      event_collectionName &&
                      showChatIcon &&
                      (chatDisplayView == 'Top' || chatDisplayView == 'Both')
                    "
                    class="chat-icon d-inline-block mr-4 position-relative"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    data-original-title="Chat"
                    @click="clickToOpenChat()"
                  >
                    <span v-show="totalUnReadMsg >= 1" class="badge">{{
                      totalUnReadMsg
                    }}</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M4.25895 16.5936C3.14076 14.7086 2.74916 12.4802 3.15768 10.3269C3.56621 8.17365 4.74675 6.24356 6.47764 4.89909C8.20853 3.55462 10.3707 2.88826 12.5581 3.02514C14.7455 3.16202 16.8078 4.09273 18.3575 5.6425C19.9073 7.19226 20.838 9.25448 20.9749 11.4419C21.1118 13.6293 20.4455 15.7915 19.101 17.5224C17.7565 19.2533 15.8264 20.4338 13.6732 20.8424C11.5199 21.2509 9.29149 20.8593 7.40649 19.7411L7.40651 19.741L4.29808 20.6292C4.16947 20.6659 4.03338 20.6676 3.90391 20.634C3.77443 20.6005 3.65628 20.5329 3.5617 20.4384C3.46713 20.3438 3.39956 20.2256 3.36601 20.0961C3.33246 19.9667 3.33415 19.8306 3.37089 19.702L4.25901 16.5935L4.25895 16.5936Z"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12 13.125C12.6213 13.125 13.125 12.6213 13.125 12C13.125 11.3787 12.6213 10.875 12 10.875C11.3787 10.875 10.875 11.3787 10.875 12C10.875 12.6213 11.3787 13.125 12 13.125Z"
                        fill="white"
                      />
                      <path
                        d="M7.5 13.125C8.12132 13.125 8.625 12.6213 8.625 12C8.625 11.3787 8.12132 10.875 7.5 10.875C6.87868 10.875 6.375 11.3787 6.375 12C6.375 12.6213 6.87868 13.125 7.5 13.125Z"
                        fill="white"
                      />
                      <path
                        d="M16.5 13.125C17.1213 13.125 17.625 12.6213 17.625 12C17.625 11.3787 17.1213 10.875 16.5 10.875C15.8787 10.875 15.375 11.3787 15.375 12C15.375 12.6213 15.8787 13.125 16.5 13.125Z"
                        fill="white"
                      />
                    </svg>
                  </div>

                  <div
                    v-if="
                      (ShowEventMenu || ShowAdminEventMenu) &&
                      event_collectionName &&
                      showNotification
                    "
                    class="notification-icon d-inline-block mr-4 position-relative"
                    @click="displayMyNotifications"
                  >
                    <span
                      v-show="filteredNotificatioData.length > 0"
                      class="badge"
                      >{{ filteredNotificatioData.length }}</span
                    >

                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 21H15"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M5.26904 9.74994C5.2678 8.86045 5.44262 7.97951 5.78343 7.1579C6.12424 6.33628 6.6243 5.59025 7.25477 4.9628C7.88525 4.33535 8.63368 3.83889 9.45693 3.50204C10.2802 3.16519 11.1619 2.99461 12.0514 3.00013C15.763 3.02772 18.7317 6.11276 18.7317 9.83468V10.4999C18.7317 13.8577 19.4342 15.8061 20.0529 16.871C20.1196 16.9848 20.1551 17.1142 20.1558 17.246C20.1565 17.3779 20.1224 17.5076 20.0569 17.6221C19.9915 17.7366 19.8971 17.8318 19.7831 17.8982C19.6691 17.9645 19.5397 17.9996 19.4078 17.9999H4.59222C4.46034 17.9996 4.33087 17.9645 4.21689 17.8981C4.1029 17.8318 4.00844 17.7366 3.94301 17.622C3.87759 17.5075 3.84352 17.3778 3.84425 17.2459C3.84498 17.114 3.88048 16.9846 3.94716 16.8709C4.56622 15.8059 5.26904 13.8575 5.26904 10.4999L5.26904 9.74994Z"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                  <!-- Notification Icon Ends -->
                  <div
                    v-if="uid && event_collectionName"
                    :style="'color:' + getMenuFont + '!important'"
                    :class="
                      lightOrDark() == 'dark'
                        ? 'dropdown my-profile darkTop'
                        : 'dropdown my-profile lightTop'
                    "
                  >
                    <div
                      v-show="displayScoreOnProfile && myLeaderboardScore"
                      class="user-tip-point"
                      @click="openLBModal"
                    >
                      <span
                        :class="
                          myLBScoreChangeState == 2
                            ? 'badge-x-large'
                            : myLBScoreChangeState == 1
                            ? 'badge-large'
                            : ''
                        "
                        >{{ formatMyLeaderboardScore }}</span
                      >
                    </div>

                    <span
                      v-if="getUserProfilePictureURL"
                      class="menu-profile-pic"
                    >
                      <img
                        :src="getUserProfilePictureURL"
                        :alt="getUserInitial"
                        @error="getUserProfilePictureURL = ''"
                      />
                    </span>
                    <v-avatar
                      size="30"
                      style="text-transform: uppercase"
                      v-else
                      color="grey"
                      >{{ getUserInitial }}</v-avatar
                    >
                    <button
                      class="dropbtn pl-2"
                      :style="'color:' + getMenuFont + '!important'"
                    >
                      {{ getUserFirstName }}

                      <!-- <i class="fa fa-caret-down"></i> -->
                    </button>
                    <div
                      id="divdrop"
                      class="dropdown-content"
                      :style="'color:' + getMenuFont + '!important'"
                    >
                      <router-link
                        v-if="EnableSelfService && !publicEventCollection"
                        to="/showcase"
                        :style="'color:' + getMenuFont + '!important'"
                      >
                        <v-icon color="#585963" size="20px">
                          mdi-home-outline</v-icon
                        >
                        {{ $t("menu.eventtemplate") }}
                      </router-link>
                      <router-link
                        v-if="EnableSelfService && false"
                        to="/events"
                        :style="'color:' + getMenuFont + '!important'"
                      >
                        <v-icon color="#585963" size="20px">
                          mdi-calendar-text-outline</v-icon
                        >
                        {{ $t("menu.eventhub") }}
                      </router-link>
                      <router-link
                        v-if="IsAdminEditPage"
                        to="/eventoverview#ManageMyEvents"
                        :style="'color:' + getMenuFont + '!important'"
                      >
                        <v-icon color="#585963" size="20px">
                          mdi-calendar-cursor</v-icon
                        >
                        {{ $t("menu.managemyevents") }}
                      </router-link>
                      <router-link
                        v-if="ShowEventMenu && !isVisitor()"
                        to="/myprofile"
                        :style="'color:' + getMenuFont + '!important'"
                      >
                        <span
                          ><svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M21.0802 8.58003V15.42C21.0802 16.54 20.4802 17.58 19.5102 18.15L13.5702 21.58C12.6002 22.14 11.4002 22.14 10.4202 21.58L4.48016 18.15C3.51016 17.59 2.91016 16.55 2.91016 15.42V8.58003C2.91016 7.46003 3.51016 6.41999 4.48016 5.84999L10.4202 2.42C11.3902 1.86 12.5902 1.86 13.5702 2.42L19.5102 5.84999C20.4802 6.41999 21.0802 7.45003 21.0802 8.58003Z"
                              stroke="#26282B"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M11.9999 11.0001C13.2867 11.0001 14.3299 9.95687 14.3299 8.67004C14.3299 7.38322 13.2867 6.34009 11.9999 6.34009C10.7131 6.34009 9.66992 7.38322 9.66992 8.67004C9.66992 9.95687 10.7131 11.0001 11.9999 11.0001Z"
                              stroke="#26282B"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M16 16.6601C16 14.8601 14.21 13.4001 12 13.4001C9.79 13.4001 8 14.8601 8 16.6601"
                              stroke="#26282B"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            /></svg
                        ></span>
                        {{ $t("menu.myProfile") }}
                      </router-link>
                      <a
                        v-if="ShowEventMenu && !isVisitor()"
                        @click="openBriefcase()"
                        target="_blank"
                        :style="'color:' + getMenuFont + '!important'"
                      >
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M7.99983 22H15.9998C20.0198 22 20.7398 20.39 20.9498 18.43L21.6998 10.43C21.9698 7.99 21.2698 6 16.9998 6H6.99983C2.72983 6 2.02983 7.99 2.29983 10.43L3.04983 18.43C3.25983 20.39 3.97983 22 7.99983 22Z"
                              stroke="#26282B"
                              stroke-width="1.5"
                              stroke-miterlimit="10"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M8 6V5.2C8 3.43 8 2 11.2 2H12.8C16 2 16 3.43 16 5.2V6"
                              stroke="#26282B"
                              stroke-width="1.5"
                              stroke-miterlimit="10"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M14 13V14C14 14.01 14 14.01 14 14.02C14 15.11 13.99 16 12 16C10.02 16 10 15.12 10 14.03V13C10 12 10 12 11 12H13C14 12 14 12 14 13Z"
                              stroke="#26282B"
                              stroke-width="1.5"
                              stroke-miterlimit="10"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M21.65 11C19.34 12.68 16.7 13.68 14 14.02"
                              stroke="#26282B"
                              stroke-width="1.5"
                              stroke-miterlimit="10"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M2.62012 11.27C4.87012 12.81 7.41012 13.74 10.0001 14.03"
                              stroke="#26282B"
                              stroke-width="1.5"
                              stroke-miterlimit="10"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>
                        {{ $t("menu.myBriefcase") }}
                      </a>
                      <router-link
                        v-if="ShowEventMenu && isSpeaker && myAgendaCount"
                        to="/speakerslounge"
                        :style="'color:' + getMenuFont + '!important'"
                      >
                        <v-icon color="#585963" size="20px">
                          mdi-microphone-outline</v-icon
                        >
                        {{ $t("menu.speakersLounge") }}
                      </router-link>
                      <!--<a href="/mymeetings">My Meetings</a>-->
                      <!--<router-link id="switchEventLink" to="/eventlist">Switch Event</router-link>-->

                      <a
                        v-if="!IsAdminEditPage && !disableLanguageOption"
                        id="switchLanguageLink"
                        href="#chnagelangModalCenter"
                        data-toggle="modal"
                        data-target="#chnagelangModalCenter"
                        :style="'color:' + getMenuFont + '!important'"
                      >
                        <v-icon color="#585963" size="20px">
                          mdi-translate</v-icon
                        >
                        {{ $t("menu.language") }}
                      </a>
                      <a
                        v-if="ShowEventMenu && $store.state.eventCount > 1"
                        @click="switchEvent()"
                        id="switchEventLink"
                        :style="'color:' + getMenuFont + '!important'"
                      >
                        <span
                          ><svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M3.58008 5.15991H17.4201C19.0801 5.15991 20.4201 6.49991 20.4201 8.15991V11.4799"
                              stroke="#26282B"
                              stroke-width="1.5"
                              stroke-miterlimit="10"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M6.74008 2L3.58008 5.15997L6.74008 8.32001"
                              stroke="#26282B"
                              stroke-width="1.5"
                              stroke-miterlimit="10"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M20.4201 18.84H6.58008C4.92008 18.84 3.58008 17.5 3.58008 15.84V12.52"
                              stroke="#26282B"
                              stroke-width="1.5"
                              stroke-miterlimit="10"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M17.2598 21.9999L20.4198 18.84L17.2598 15.6799"
                              stroke="#26282B"
                              stroke-width="1.5"
                              stroke-miterlimit="10"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            /></svg
                        ></span>
                        {{
                          $store.state.DefaultLoginLandingPage == "/clientLobby"
                            ? $t("menu.switchEventClient")
                            : $t("menu.switchEvent")
                        }}
                      </a>
                      <a
                        id="AdminConsolelnk"
                        v-if="
                          !EnableSelfService &&
                          (isClientAdmin() || isEventAdmin())
                        "
                        href="https://onaircms.e2m.live/"
                        target="blank"
                        :style="'color:' + getMenuFont + '!important'"
                      >
                        <span
                          class="d-flex justify-content-start align-items-center"
                        >
                          <v-icon color="#585963" size="20px" class="mr-1"
                            >mdi-console</v-icon
                          >
                          {{ $t("menu.adminConsole") }}
                          <v-icon color="#333" size="20px" class="ml-2"
                            >mdi-open-in-new</v-icon
                          ></span
                        >
                      </a>
                      <a
                        href="#"
                        @click.prevent="Logout"
                        :style="'color:' + getMenuFont + '!important'"
                      >
                        <span
                          ><svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M8.90039 7.55999C9.21039 3.95999 11.0604 2.48999 15.1104 2.48999H15.2404C19.7104 2.48999 21.5004 4.27999 21.5004 8.74999V15.27C21.5004 19.74 19.7104 21.53 15.2404 21.53H15.1104C11.0904 21.53 9.24039 20.08 8.91039 16.54"
                              stroke="#26282B"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M15.0001 12H3.62012"
                              stroke="#26282B"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M5.85 8.65002L2.5 12L5.85 15.35"
                              stroke="#26282B"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            /></svg
                        ></span>
                        {{ $t("menu.logout") }}
                      </a>
                      <span v-if="releaseNoteURL == ''" class="app-version">
                        v{{ productVersion }}
                      </span>
                      <span v-else class="app-version">
                        <a
                          class="version-link"
                          :href="releaseNoteURL"
                          target="_blank"
                          :style="'color:' + getMenuFont + '!important'"
                          >v{{ productVersion }}
                        </a>
                      </span>
                    </div>
                  </div>
                </div>

                <!--<ul class="pull-right lgout-icon-hld list-inline nav-list-rgt">
          <li>
            <a
              title
              data-placement="bottom"
              data-toggle="tooltip"
              class="icon-logout"
              href="/"
              data-original-title="Logout"
            ></a>
          </li>
          <li>
            <div id="dvNoticeHolder" class="custom-pushmsgs-wrapper"></div>
          </li>
          </ul>-->
              </div>
            </div>
          </template>
        </v-app-bar>

        <!---strip start--->

        <!---strip end--->
        <!------megamenu start 08.05.2020---------->
        <div v-if="!app" id="sidebar" class="megamenu d-none">
          <span id="dismiss" class="d-block d-md-none">
            <svg
              class="fa-times"
              xmlns="http://www.w3.org/2000/svg"
              width="18.03"
              height="18.031"
              viewBox="0 0 18.03 18.031"
            >
              <path
                id="close.svg"
                fill="#fff"
                d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                transform="translate(-1412 -516)"
              />
            </svg>
          </span>
          <!---only mobile clickable left icon---->
          <ul
            id="headerMenuParentMobile"
            class="nav nav-tabs nav-tab-one d-block d-md-none"
          >
            <!-- <li class="nav-item">
          <a class="nav-link tab-link" data-toggle="tab" href="#Agenda">
            <span>
              <img src="images/menu-icon/session.png" alt="icon" />
            </span>
            Session
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link tab-link" data-toggle="tab" href="#Live">
            <span>
              <img src="images/menu-icon/live.png" alt="icon" />
            </span>
            Live
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link no-tab-link" href="my-profile.html">
            <span>
              <img src="images/menu-icon/me.png" alt="icon" />
            </span>
            ME
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link no-tab-link" href="#">
            <span>
              <img src="images/menu-icon/etc.png" alt="icon" />
            </span>
            ETC
          </a>
          </li>-->
          </ul>

          <div id="divSubmenu" class="tab-content tab-content-one">
            <!---session start--->
            <!---session end--->
            <!---Live start--->
            <!---Live end--->
          </div>
        </div>

        <!------megamenu end---------->
        <!-- <loading-bar></loading-bar> -->
      </div>
      <div
        v-show="!$online"
        id="appOffline"
        style="
          width: 100%;
          text-align: center;
          padding: 2px;
          background-color: red;
          color: #fff;
        "
      >
        {{ $t("messages.weakinternet") }}
      </div>

      <div v-if="this.IsBrowserCheck === true" class="browser-detect">
        {{ $t("messages.seemtousing") }}" {{ this.$browserDetect.meta.name }} "
        {{ $t("messages.browser") }}.
        {{ $t("messages.changebrowser") }}
        <a href="https://www.google.com/intl/en_in/chrome/" target="_blank"
          >Chrome</a
        >
        or
        <a href="https://www.microsoft.com/en-us/edge" target="_blank">Edge</a>
        {{ $t("messages.forbetterexperience") }}
        <button class="btn btn-transparent">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18.03"
            height="18.031"
            viewBox="0 0 18.03 18.031"
          >
            <path
              id="close.svg"
              fill="#ffffff"
              d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
              transform="translate(-1412 -516)"
            />
          </svg>
        </button>
      </div>
      <div class="page-wrap-inner position-relative">
        <div class="lobby-top-bubble-menus" v-if="showLobbyBubbleMenu">
          <ul>
            <v-tooltip bottom v-if="helpChatIcon">
              <template v-slot:activator="{ on, attrs }">
                <li v-bind="attrs" v-on="on" @click="turnOnHelp()">
                  <div class="single-bubble">
                    <img src="./assets/Images/lobby-templates/help.svg" />
                  </div>
                </li>
              </template>
              <span>Help</span>
            </v-tooltip>

            <v-tooltip bottom v-if="showNotification">
              <template v-slot:activator="{ on, attrs }">
                <li v-bind="attrs" v-on="on" @click="displayMyNotifications">
                  <div class="single-bubble">
                    <img
                      src="./assets/Images/lobby-templates/notification.svg"
                    />
                  </div>
                </li>
              </template>
              <span>Notification</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <li v-bind="attrs" v-on="on">
                  <v-menu
                    bottom
                    auto
                    :offset-y="offset"
                    content-class="bubble-dropdown-menu p-0"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div class="single-bubble" v-bind="attrs" v-on="on">
                        <img
                          v-if="getUserProfilePictureURL"
                          :src="getUserProfilePictureURL"
                          :alt="getUserInitial"
                        />
                        <v-avatar
                          v-else
                          size="48px"
                          class="text-h5"
                          style="text-transform: uppercase"
                          color="#fff"
                          >{{ getUserInitial }}</v-avatar
                        >
                      </div>
                    </template>
                    <v-list>
                      <div class="menu-user-details p-3">
                        <h6>{{ getUserName }}</h6>
                        <p v-if="getUserDesignation">
                          {{ getUserDesignation }}
                        </p>
                        <p v-if="getUserCompany">{{ getUserCompany }}</p>
                      </div>
                      <div class="px-3 py-0 lobby-profile-menu-list-hld">
                        <v-list-item
                          dense
                          v-if="EnableSelfService && !publicEventCollection"
                          @click="$router.push('/showcase')"
                        >
                          <v-list-item-title>{{
                            $t("menu.eventtemplate")
                          }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          dense
                          v-if="IsAdminEditPage"
                          @click="$router.push('/eventoverview#ManageMyEvents')"
                        >
                          <v-list-item-title>{{
                            $t("menu.managemyevents")
                          }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          dense
                          v-if="ShowEventMenu && !isVisitor()"
                          @click="$router.push('/myprofile')"
                        >
                          <v-list-item-title>
                            <span class="lobby-bubble-icon">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M21.0802 8.58003V15.42C21.0802 16.54 20.4802 17.58 19.5102 18.15L13.5702 21.58C12.6002 22.14 11.4002 22.14 10.4202 21.58L4.48016 18.15C3.51016 17.59 2.91016 16.55 2.91016 15.42V8.58003C2.91016 7.46003 3.51016 6.41999 4.48016 5.84999L10.4202 2.42C11.3902 1.86 12.5902 1.86 13.5702 2.42L19.5102 5.84999C20.4802 6.41999 21.0802 7.45003 21.0802 8.58003Z" stroke="#26282B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M11.9999 11.0001C13.2867 11.0001 14.3299 9.95687 14.3299 8.67004C14.3299 7.38322 13.2867 6.34009 11.9999 6.34009C10.7131 6.34009 9.66992 7.38322 9.66992 8.67004C9.66992 9.95687 10.7131 11.0001 11.9999 11.0001Z" stroke="#26282B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M16 16.6601C16 14.8601 14.21 13.4001 12 13.4001C9.79 13.4001 8 14.8601 8 16.6601" stroke="#26282B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </span>
                            {{ $t("menu.myProfile") }}</v-list-item-title
                          >
                        </v-list-item>
                        <v-list-item
                          dense
                          v-if="ShowEventMenu && !isVisitor()"
                          @click="openBriefcase()"
                        >
                          <v-list-item-title>
                            <span class="lobby-bubble-icon">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M7.99983 22H15.9998C20.0198 22 20.7398 20.39 20.9498 18.43L21.6998 10.43C21.9698 7.99 21.2698 6 16.9998 6H6.99983C2.72983 6 2.02983 7.99 2.29983 10.43L3.04983 18.43C3.25983 20.39 3.97983 22 7.99983 22Z" stroke="#26282B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M8 6V5.2C8 3.43 8 2 11.2 2H12.8C16 2 16 3.43 16 5.2V6" stroke="#26282B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M14 13V14C14 14.01 14 14.01 14 14.02C14 15.11 13.99 16 12 16C10.02 16 10 15.12 10 14.03V13C10 12 10 12 11 12H13C14 12 14 12 14 13Z" stroke="#26282B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M21.65 11C19.34 12.68 16.7 13.68 14 14.02" stroke="#26282B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M2.62012 11.27C4.87012 12.81 7.41012 13.74 10.0001 14.03" stroke="#26282B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </span>
                            {{ $t("menu.myBriefcase") }}</v-list-item-title
                          >
                        </v-list-item>
                        <v-list-item
                          dense
                          v-if="ShowEventMenu && isSpeaker && myAgendaCount"
                          @click="$router.push('/speakerslounge')"
                        >
                          <v-list-item-title
                            ><v-icon color="#585963" size="20px" class="mr-2"
                              >mdi-microphone-outline</v-icon
                            >{{ $t("menu.speakersLounge") }}</v-list-item-title
                          >
                        </v-list-item>
                        <v-list-item
                          dense
                          v-if="!IsAdminEditPage && !disableLanguageOption"
                          href="#chnagelangModalCenter"
                          data-toggle="modal"
                          data-target="#chnagelangModalCenter"
                        >
                          <v-list-item-title
                            ><v-icon color="#585963" size="20px" class="mr-2"
                              >mdi-translate</v-icon
                            >{{ $t("menu.language") }}</v-list-item-title
                          >
                        </v-list-item>
                        <v-list-item
                          dense
                          v-if="ShowEventMenu && $store.state.eventCount > 1"
                          @click="switchEvent()"
                        >
                          <v-list-item-title>
                            <span class="lobby-bubble-icon">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M3.58008 5.15991H17.4201C19.0801 5.15991 20.4201 6.49991 20.4201 8.15991V11.4799" stroke="#26282B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M6.74008 2L3.58008 5.15997L6.74008 8.32001" stroke="#26282B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M20.4201 18.84H6.58008C4.92008 18.84 3.58008 17.5 3.58008 15.84V12.52" stroke="#26282B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M17.2598 21.9999L20.4198 18.84L17.2598 15.6799" stroke="#26282B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </span>
                            {{
                              $store.state.DefaultLoginLandingPage ==
                              "/clientLobby"
                                ? $t("menu.switchEventClient")
                                : $t("menu.switchEvent")
                            }}</v-list-item-title
                          >
                        </v-list-item>
                        <v-list-item
                          dense
                          v-if="
                            !EnableSelfService &&
                            (isClientAdmin() || isEventAdmin())
                          "
                          href="https://onaircms.e2m.live/"
                          target="blank"
                        >
                          <v-icon color="#585963" size="20px" class="mr-1"
                            >mdi-console</v-icon
                          >
                          <v-list-item-title>
                            {{ $t("menu.adminConsole") }}</v-list-item-title
                          >
                        </v-list-item>
                        <v-list-item dense @click.prevent="Logout">
                          <v-list-item-title>
                            <span class="lobby-bubble-icon">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M8.90039 7.55999C9.21039 3.95999 11.0604 2.48999 15.1104 2.48999H15.2404C19.7104 2.48999 21.5004 4.27999 21.5004 8.74999V15.27C21.5004 19.74 19.7104 21.53 15.2404 21.53H15.1104C11.0904 21.53 9.24039 20.08 8.91039 16.54" stroke="#26282B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M15.0001 12H3.62012" stroke="#26282B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M5.85 8.65002L2.5 12L5.85 15.35" stroke="#26282B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </span>
                            {{ $t("menu.logout") }}</v-list-item-title
                          >
                        </v-list-item>
                      </div>
                    </v-list>
                  </v-menu>
                </li>
              </template>
              <span>{{ getUserFirstName }}</span>
            </v-tooltip>
          </ul>
        </div>
        <div
          v-if="
            (showChatComponent || enableHiddenChatComponent) &&
            chatEnabledFromPlugins &&
            !currentDomain.includes('edulife')
          "
        >
          <!-- Live, Firebase-backed chat with the Engage@Event skin overlay
               (overlay lives at the bottom of ChatPanelv2.vue's <style>). -->
          <ChatPanel2
            :showChatComponent="showChatComponent"
            :enableHiddenChatComponent="enableHiddenChatComponent"
          />
        </div>
        <div
          v-if="
            ShowEventMenu &&
            !ShowAdminEventMenu &&
            LeftData.length > 0 &&
            !HideLeftMenu
          "
          id="leftMenuParent"
        >
          <!-- v-if="
              !$vuetify.breakpoint.mobile &&
              $route.name &&
              [
                'login',
                'lobby',
                'eventlist',
                'events',
                'videoplayer',
                'Reg',
                'LiveStage',
                'MainLobby',
                'Lobby',
              ].indexOf($route.name) == -1 &&
              checkRoutePage

            " -->
          <div
            id="leftmenu"
            :style="'background-color:' + $store.state.EventBranding[0].topBar"
            class="survey-left-menu-wrapper left-menu-sec"
            :class="{
              expo: IsExpoPage,
              redMenu: lightOrDark() == 'dark',
              lightMenu: lightOrDark() != 'dark',
              'd-none': hideLeftmenuMobile,
            }"
          >
            <ul v-if="!$vuetify.breakpoint.mobile" id="ulLeftMenu" class="pl-0">
              <!-- <li
              class="lileftmenu active"
              :id="'lileftmenuhome'"
              @click.prevent="onLeftMenuCLick('lileftmenuhome')"
            >
              <router-link id="ancHome" v-bind:to="homeUrl" data-original-title="Home">
                <span>
                  <img src="././assets/Images/icons/lobby.svg" alt="icon" />
                </span>
                Lobby
              </router-link>
            </li>-->

              <li
                v-for="item in LeftData.slice(0, showLeftMenuBoxes)"
                :id="
                  'li' + String(item.PageUrl).substring(1, item.PageUrl.length)
                "
                :key="item.MenuID"
                :class="[
                  'lileftmenu',
                  { active: activeLeftMenuId === String(item.MenuID) },
                ]"
                :data-val="item.MenuID"
                :element-type="'menu'"
                @click="onMenuCLick($event)"
              >
                <router-link
                  :to="getMenuUrl(item.MenuID, String(item.PageUrl))"
                  :style="'color:' + getMenuFont + '!important'"
                  :class="{ active: activeLeftMenuId === String(item.MenuID) }"
                  @mouseover="hovermenu(this)"
                  :element-type="'menu'"
                  active-class="active"
                  exact-active-class="active"
                >
                  <span>
                    <img :src="getSideMenuIcon(item)" alt="icon" />
                  </span>

                  <center>
                    <span
                      v-if="
                        $store.state.locale == 'German' && item.DisplayLabel_de
                      "
                    >
                      {{ item.DisplayLabel_de.replace(" ", "\n") }}
                    </span>
                    <span
                      v-else-if="
                        $store.state.locale == 'English' && item.DisplayLabel
                      "
                    >
                      {{ item.DisplayLabel.replace(" ", "\n") }}
                    </span>
                    <span
                      v-else-if="
                        $store.state.locale == 'French' && item.DisplayLabel_fr
                      "
                    >
                      {{ item.DisplayLabel_fr.replace(" ", "\n") }}
                    </span>
                    <span
                      v-else-if="
                        $store.state.locale == 'Chinese' && item.DisplayLabel_zh
                      "
                    >
                      {{ item.DisplayLabel_zh.replace(" ", "\n") }}
                    </span>
                    <span
                      v-else-if="
                        $store.state.locale == 'Spanish' && item.DisplayLabel_es
                      "
                    >
                      {{ item.DisplayLabel_es.replace(" ", "\n") }}
                    </span>
                    <span v-else>
                      {{ item.DisplayLabel.replace(" ", "\n") }}
                    </span>
                    <!-- {{ item.DisplayLabel.replace(" ", "\n") }} -->
                  </center>
                </router-link>
              </li>

              <li v-if="LeftData && LeftData.length > showLeftMenuBoxes">
                <div class="left-dropdown">
                  <v-menu
                    right
                    top
                    offset-x
                    :content-class="
                      lightOrDark() == 'dark'
                        ? 'leftmenu-extend leftmenu-extend1'
                        : 'leftmenu-extend leftmenu-extend-light'
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        text
                        :ripple="false"
                        width="100%"
                        height="80px"
                        v-bind="attrs"
                        v-on="on"
                        ><v-icon size="26px" color="#c1c1c1"
                          >mdi-dots-horizontal</v-icon
                        ></v-btn
                      >
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="item in LeftData.slice(
                          showLeftMenuBoxes,
                          LeftData.length
                        )"
                        :key="item.MenuID"
                        :data-val="item.MenuID"
                        :element-type="'menu'"
                        @click="onMenuCLick($event)"
                      >
                        <router-link
                          :to="getMenuUrl(item.MenuID, String(item.PageUrl))"
                          :style="'color:' + getMenuFont + '!important'"
                          @mouseover="hovermenu(this)"
                          :element-type="'menu'"
                        >
                          <span
                            style="color: #1c1d26"
                            class="mr-2 d-inline-block"
                          >
                            <img :src="item.IconUrl" alt="icon" />
                          </span>
                          <v-list-item-title
                            v-if="
                              $store.state.locale == 'German' &&
                              item.DisplayLabel_de
                            "
                          >
                            {{ item.DisplayLabel_de.replace(" ", "\n") }}
                          </v-list-item-title>
                          <v-list-item-title
                            v-else-if="
                              $store.state.locale == 'English' &&
                              item.DisplayLabel
                            "
                          >
                            {{ item.DisplayLabel.replace(" ", "\n") }}
                          </v-list-item-title>
                          <v-list-item-title
                            v-else-if="
                              $store.state.locale == 'French' &&
                              item.DisplayLabel_fr
                            "
                          >
                            {{ item.DisplayLabel_fr.replace(" ", "\n") }}
                          </v-list-item-title>
                          <v-list-item-title
                            v-else-if="
                              $store.state.locale == 'Chinese' &&
                              item.DisplayLabel_zh
                            "
                          >
                            {{ item.DisplayLabel_zh.replace(" ", "\n") }}
                          </v-list-item-title>
                          <v-list-item-title
                            v-else-if="
                              $store.state.locale == 'Spanish' &&
                              item.DisplayLabel_es
                            "
                          >
                            {{ item.DisplayLabel_es.replace(" ", "\n") }}
                          </v-list-item-title>
                          <v-list-item-title v-else>
                            {{ item.DisplayLabel.replace(" ", "\n") }}
                          </v-list-item-title>
                        </router-link>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </li>
            </ul>
            <!--------onAir Icon---->
            <!-- <div class="logo-onAir">
            <a
              href="https://e2m.live/"
              target="_blank"
              data-toggle="tooltip"
              data-placement="top"
              title
              data-original-title="Powered by E2M OnAir"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="41px"
                height="32px"
              >
                <path
                  fill-rule="evenodd"
                  fill="#585963"
                  d="M32.811,16.179 C32.811,20.549 30.554,24.382 27.155,26.587 L24.456,23.874 C27.222,22.430 29.115,19.529 29.115,16.179 C29.115,12.829 27.222,9.929 24.456,8.485 L27.155,5.772 C30.554,7.976 32.811,11.810 32.811,16.179 ZM8.171,16.179 C8.171,11.810 10.427,7.976 13.827,5.772 L16.526,8.485 C13.760,9.929 11.867,12.829 11.867,16.179 C11.867,19.529 13.760,22.430 16.526,23.874 L13.827,26.587 C10.427,24.382 8.171,20.549 8.171,16.179 ZM4.475,16.179 C4.475,21.573 7.122,26.335 11.171,29.257 L8.534,31.909 C3.828,28.287 0.779,22.598 0.779,16.179 C0.779,9.761 3.828,4.072 8.534,0.450 L11.171,3.102 C7.122,6.024 4.475,10.786 4.475,16.179 ZM36.507,16.179 C36.507,10.786 33.860,6.024 29.811,3.102 L32.448,0.450 C37.154,4.072 40.203,9.761 40.203,16.179 C40.203,22.598 37.154,28.287 32.448,31.909 L29.811,29.257 C33.860,26.335 36.507,21.573 36.507,16.179 Z"
                />
                <path
                  fill-rule="evenodd"
                  fill="rgb(234, 33, 45)"
                  d="M25.419,16.179 C25.419,18.916 23.212,21.134 20.491,21.134 C17.769,21.134 15.563,18.916 15.563,16.179 C15.563,13.443 17.769,11.225 20.491,11.225 C23.212,11.225 25.419,13.443 25.419,16.179 Z"
                />
              </svg>
            </a>
          </div>-->
            <!--------onAir Icon end------>
          </div>
        </div>
        <v-navigation-drawer
          v-if="ShowAdminEventMenu && !HideLeftMenu"
          fixed
          permanent
          width="370"
          height="100%"
          class="event-setup-left-menu"
        >
          <SelfServiceLeftMenu
            :eventFullName="
              CurrentAdminEvent && CurrentAdminEvent.EventFullName
                ? CurrentAdminEvent.EventFullName
                : ''
            "
            :eventTime="
              CurrentAdminEvent && CurrentAdminEvent.EventTime
                ? CurrentAdminEvent.EventTime
                : ''
            "
            :MenuIDs="MenuIDs"
            :eventId="eventId"
            :key="selfServiceMenuKey"
          >
          </SelfServiceLeftMenu>
        </v-navigation-drawer>
        <router-view
          :class="{ 'admin-page-effect': ShowAdminEventMenu && !HideLeftMenu }"
          :style="bodyWith"
          @LoadEvent="LoadEvent"
        />
        <EventShare v-if="ShowAdminEventMenu && !HideLeftMenu" />
        <SelfServiceFooter
          v-if="
            ShowAdminEventMenu &&
            (!HideLeftMenu || currentRouteName == 'AdminStageView')
          "
          :HasPreviewPage="HasPreviewPage"
          :MenuIDs="MenuIDs"
          :eventId="eventId"
        />
      </div>

      <button id="btnLoadMenu" style="display: none" @click="LoadEvent" />
      <button id="btnAddUserView" style="display: none" @click="AddUserView" />
      <button
        id="btnRedirectValidUrl"
        style="display: none"
        @click="RedirectValidUrl"
      />
      <button id="btnPlugins" style="display: block" @click="showPlugin" />

      <!-- notification  Modal-->
      <div
        id="notification"
        class="modal right fade speakers-popup"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myModalLabel2"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div
              class="modal-body new-addendee-list new-addendee-details px-0 pb-2"
            >
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18.03"
                  height="18.031"
                  viewBox="0 0 18.03 18.031"
                >
                  <path
                    id="close.svg"
                    fill="#242432"
                    d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                    transform="translate(-1412 -516)"
                  />
                </svg>
              </button>
              <!----------notification message--------------->
              <div class="notification">
                <div
                  class="notification-top d-flex align-items-center justify-content-between"
                >
                  <h2 class="notification-head pt-2">MY NOTIFICATIONS</h2>
                  <button
                    v-show="IsSubscribed == false"
                    id="btnSubscribe"
                    class="btn"
                    @click="SubscribeForWebPush()"
                  >
                    <i class="fa fa-bell-o" aria-hidden="true" /> Get Alerts!
                  </button>
                  <button
                    v-show="IsSubscribed"
                    id="btnUnsubscribe"
                    class="btn"
                    @click="UnSubscribeForWebPush()"
                  >
                    Turn off Alerts
                  </button>
                </div>
                <!------notification box start----->
                <!-- <div class="notific-single-box">
                <div class="media align-items-center">
                  <div class="align-self-center mr-3 small-img-hld">
                    <img
                      class
                      src="https://firebasestorage.googleapis.com/v0/b/e2monair.firebasestorage.app/o/OA_UAT_C1591904892446E1591907102804%2FAttendee%2FprofileImage%2FPP_2.jpg?alt=media"
                      alt
                    />
                  </div>
                  <div class="media-body">
                    <h5 class="mt-0">Akash Nag has joined your roundtable</h5>
                  </div>
                </div>
                <div class="prev-time align-items-center justify-content-between d-flex ml-3">
                  <div class="button-hld btn-theme">
                    <button class="btn">Join Now</button>
                  </div>
                  <span class="mb-0">5 min ago</span>
                </div>
              </div>-->
                <!------notification box end----->
                <!------notification box start----->
                <div
                  class="notification-online-head"
                  v-if="
                    liveVisitorIndicator &&
                    onlineAttendeeList &&
                    onlineAttendeeList.length > 0 &&
                    showChatComponent
                  "
                >
                  <div class="pulse-blur-circle">
                    <img src="./assets/Images/online.svg" />
                  </div>

                  <h5 v-if="onlineAttendeeList.length == 1">
                    <span>{{ onlineAttendeeList.length }} Person</span> is
                    online now on this event !
                  </h5>
                  <h5 v-if="onlineAttendeeList.length > 1">
                    <span>{{ onlineAttendeeList.length }} People</span> are
                    online now in this event !
                  </h5>
                  <v-btn
                    small
                    text
                    color="#2376e5"
                    class="view-chat"
                    @click="openChatPannelWithPresence()"
                    >Chat Now</v-btn
                  >
                </div>
                <div
                  v-for="(Notification, index) in NotificationData"
                  :key="index"
                  class="notific-single-box"
                >
                  <input
                    id="NotificationId"
                    v-model="Notification.NotificationId"
                    type="hidden"
                  />

                  <div
                    class="media align-items-start justify-content-between flex-column"
                  >
                    <div
                      class="d-flex align-items-center justify-content-start"
                    >
                      <div class="align-self-start mr-3 small-img-hld">
                        <img
                          v-if="Notification.Image"
                          :src="Notification.Image"
                          @error="Notification.Image = ''"
                          class="imguserthumb"
                        />
                        <span v-else-if="Notification.NameInitial">{{
                          Notification.NameInitial
                        }}</span>
                        <img
                          v-else
                          src="./assets/Images/notification.svg"
                          class="imguserthumb"
                          height="25px"
                          width="35px"
                        />
                      </div>
                      <div class="media-body">
                        <h4 class="mt-0 d-none">
                          {{ Notification.Name }}
                        </h4>
                        <h4 v-if="Notification.isSeen == '0'" class="mt-0">
                          {{ Notification.Title }}
                        </h4>
                        <p
                          v-else
                          style="color: #1c1d26; font-size: 1.1em"
                          class="mt-0 mb-0"
                        >
                          {{ Notification.Title }}
                        </p>
                        <h5
                          v-if="Notification.isSeen == '0'"
                          class="mt-0"
                          v-html="Notification.Message"
                        >
                          <!-- <router-link
                          @click.native="
                            updateMeetingNotification(Notification.NotificationId)
                          "
                          to="/mymeetings"
                          >{{ Notification.Message }}</router-link
                        > -->
                          <!--{{ Notification.Message }}-->
                        </h5>
                        <p
                          v-else
                          style="color: #848484"
                          class="mt-0 mb-2"
                          v-html="Notification.Message"
                        >
                          <!--{{ Notification.Message }}-->
                        </p>
                        <p class="d-none">{{ Notification.NotificationId }}</p>
                      </div>
                    </div>
                    <div
                      v-if="
                        Notification.MeetingId &&
                        Notification.MeetingType ==
                          'One2OneMeeting/MeetingJoined' &&
                        Notification.CTimestamp + 120000 > correntTimeMS
                      "
                      class="notification-btn d-flex justify-content-end mb-3 mt-3"
                      style="width: 100%"
                    >
                      <router-link
                        :to="Notification.JoinLink"
                        style="padding: 0; margin: 0; background: unset"
                        data-dismiss="modal"
                      >
                        <v-btn small color="#1976d2" dark class="mr-3">
                          Join
                        </v-btn>
                      </router-link>
                      <!--<v-btn
                        v-if="Notification.Sender"
                        small
                        color="error"
                        outlined
                        dark
                        @click="declineJoinMeeting(Notification.NotificationId)"
                        >Decline</v-btn
                      >-->
                    </div>
                    <!-- <div>
                      {{ Notification.MeetingId }}<br />{{
                        Notification.NotificationId
                      }}<br />{{
                        videoCallNotification[Notification.MeetingId]
                          ? videoCallNotification[Notification.MeetingId]
                              .Occupied
                          : ""
                      }}
                    </div> -->
                    <div
                      v-if="
                        Notification.MeetingId &&
                        Notification.MeetingType ==
                          'VideoCalling/CallStarted' &&
                        Notification.UserIdList.length > 2 &&
                        Notification.CTimestamp + 1200000 > correntTimeMS &&
                        videoCallNotification[Notification.MeetingId] &&
                        videoCallNotification[Notification.MeetingId]
                          .NotificationId == Notification.NotificationId &&
                        videoCallNotification[Notification.MeetingId].Occupied >
                          0
                      "
                      class="notification-btn d-flex justify-content-start mb-3 mt-3"
                      style="width: 100%"
                    >
                      <v-btn
                        width="100px"
                        outline
                        color="#1ab063"
                        class="chat-mouse-pointer mr-2 accept-call"
                        dark
                        @click="
                          startVideoChat({
                            roomId: Notification.MeetingId,
                            memberIDs: Notification.UserIdList,
                          })
                        "
                        ><v-icon color="#fff" size="20px">mdi-check</v-icon>
                        Join
                      </v-btn>
                      <!-- <v-btn
                        width="120px"
                        color="#eb4e37"
                        dark
                        class="ml-1 chat-mouse-pointer decline-call"
                        ><v-icon color="#fff" size="20px">mdi-close</v-icon
                        >Decline
                      </v-btn> -->
                      <!-- <v-btn small color="#1976d2" dark class="mr-3"
                        style="padding: 0; margin: 0; background: unset">
                        Join
                      </v-btn> -->
                      <!--<v-btn
                        v-if="Notification.Sender"
                        small
                        color="error"
                        outlined
                        dark
                        @click="declineJoinMeeting(Notification.NotificationId)"
                        >Decline</v-btn
                      >-->
                    </div>
                  </div>
                  <div
                    class="prev-time align-items-center justify-content-between d-flex ml-3"
                  >
                    <div class="button-hld btn-theme">
                      <!-- <button
                      v-if="Notification.NotifyTypeIndex == 2"
                      v-on:click="OpenMyMeetings(Notification.NotificationId)"
                      class="btn"
                    >
                      Join Now
                    </button> -->
                    </div>
                    <span class="mb-0">{{ Notification.Time }}</span>
                  </div>
                </div>
                <!------notification box end----->
              </div>
              <!----------notification message--------------->
            </div>
          </div>
          <!-- modal-content -->
        </div>
        <!-- modal-dialog -->
      </div>
      <!-- Notification modal -->
      <div><localeswitcher /></div>
      <!-- <div v-if="showChatComponent">
        <ChatPanel />
      </div> -->
      <CreateEvent
        v-if="openCreateEventSidePannel"
        v-model="openCreateEventSidePannel"
        :key="resetCreateEvent"
      />

      <div v-if="alertScreenPotraitMsg" class="ipad-overlay">
        <v-snackbar
          :timeout="-1"
          style="z-index: 1021"
          top
          color="#ffce44"
          v-model="alertScreenPotraitMsg"
          max-width="100vw"
          ><span class="pr-3"><v-icon color="black">info</v-icon></span>

          <span style="color: #000; font-size: 1.25rem; font-weight: 600"
            >For Best Results, use Landscape mode
            <v-btn
              dark
              small
              @click="refreshPage()"
              color="#288aef"
              class="v-btn--example"
            >
              RELOAD NOW
              <v-icon size="16" class="ml-2" color="white">cached</v-icon>
            </v-btn>
          </span>
        </v-snackbar>
      </div>

      <v-snackbar
        :timeout="-1"
        style="z-index: 1021; margin-top: 76px"
        top
        color="#d73a49"
        v-model="versionInfo"
        max-width="100vw"
        class="reload_info"
        ><span class="pr-3"><v-icon color="white">info</v-icon></span>
        <span
          >A new version is available. Press CTRL+F5 or CTRL+SHIFT+R or Click on
          the refresh Icon</span
        >
        <template v-slot:action="{ attrs }">
          <v-icon style="cursor: pointer" @click="refreshPage()" v-bind="attrs">
            cached
          </v-icon>
        </template>
      </v-snackbar>
      <v-snackbar
        :timeout="5000"
        :style="position == 'top' ? 'padding-top:9%' : ''"
        :top="position == 'top'"
        :right="position == 'right'"
        :bottom="position == 'right'"
        :color="snackBarType ? snackBarType : ''"
        v-model="snackbar"
      >
        <span class="pr-3" v-if="snackBarType == 'error'"
          ><v-icon color="white">error</v-icon></span
        >
        <span>{{ snackbarMessage }}</span>
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar = false"> Close </v-btn>
        </template>
      </v-snackbar>

      <v-snackbar
        :timeout="-1"
        style="z-index: 1021"
        top
        color="#fdc854"
        v-model="popupBlockInfo"
        max-width="100vw"
        ><span class="pr-3"><v-icon color="white">info</v-icon></span>
        <span
          >Your browser setting may block pop-ups to open. Please make sure to
          allow them.<a @click="openGuideline()"> See Guide</a></span
        >
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="popupBlockInfo = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>

      <v-navigation-drawer
        left
        fixed
        v-model="drawer"
        class="app-mobile-drawer"
        width="280"
      >
        <div class="app-mobile-drawer-close">
          <button
            type="button"
            class="app-mobile-drawer-close-btn"
            aria-label="Close menu"
            @click="drawer = false"
          >
            <v-icon size="22">mdi-close</v-icon>
          </button>
        </div>
        <v-list v-if="uid" class="app-mobile-drawer-user">
          <v-list-item class="flex-column text-center">
            <v-list-item-avatar size="64" class="mx-auto mt-2 mb-2">
              <img
                v-if="getUserProfilePictureURL"
                :src="getUserProfilePictureURL"
                alt="e2m"
              />
              <v-avatar v-else color="teal" size="64">
                <span class="white--text">{{ getUserInitial }}</span>
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-content class="text-center pa-0">
              <v-list-item-title class="app-mobile-drawer-username">
                {{ getUserName }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider class="app-mobile-drawer-divider"></v-divider>
        <v-list dense nav class="app-mobile-drawer-list">
          <v-list-item
            v-for="item in AllMenuData"
            :id="'mobMenu' + String(item.PageUrl || '').substring(1)"
            :key="item.MenuID"
            link
            class="app-mobile-drawer-item"
            @click="onMobileMenuCLick(item), (drawer = false)"
          >
            <v-list-item-icon class="mobile-menu-icon-wrap">
              <span>
                <img :src="getTopMenuIcon(item)" alt="icon" />
              </span>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="app-mobile-drawer-item-label">{{
                item.DisplayLabel
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
    </v-main>
    <div class="help-desk-container" v-if="helpMenu">
      <div class="help-desk-container-top">
        <!-- <div class="help-desk-container-top-image">
            <v-icon size="40" color="white">mdi-whatsapp</v-icon>
          </div> -->
        <div class="help-desk-container-top-text pl-3">
          <h3>Greetings!</h3>
          <p>Below are links to the Help Guide and Campus Helpdesk</p>
        </div>
        <div class="close-wrapper cursor-pointer" @click="helpMenu = !helpMenu">
          <span><v-icon size="30" color="white">mdi-close</v-icon></span>
        </div>
      </div>
      <div class="help-desk-inner-wrapper">
        <div
          class="whatsap-connector"
          @click="helpDeskTypClicks('Contact Campus Helpdesk')"
        >
          <div class="whatsap-img">
            <img
              src="././assets/e2medu/icons/whatsapp.svg"
              alt="Help"
              height="40px"
              width="40px"
            />
          </div>
          <div class="whatsap-text">
            <h3>Contact Campus Helpdesk</h3>
          </div>
        </div>
        <hr class="mx-8" />

        <div
          class="whatsap-connector mb-4"
          style="background: #ffffff"
          v-if="isClientAdmin() == false"
          @click="helpDeskTypClicks('Platform Guide Video')"
        >
          <div class="whatsap-img">
            <img
              src="././assets/e2medu/icons/help-video.svg"
              alt="Campus Guide"
              height="40px"
              width="40px"
            />
          </div>

          <div class="whatsap-text">
            <h3 style="color: #000">How It Works</h3>
          </div>
        </div>

        <div
          class="whatsap-connector mb-4"
          style="background: #ffffff"
          @click="helpDeskTypClicks('My Virtual Background')"
        >
          <div class="whatsap-img">
            <img
              src="././assets/e2medu/icons/virtual-bg.svg"
              alt="Campus Guide"
              height="40px"
              width="40px"
            />
          </div>

          <div class="whatsap-text">
            <h3 style="color: #000">My Virtual Background</h3>
          </div>
        </div>

        <div
          class="whatsap-connector mb-4"
          style="background: #ffffff"
          @click="helpDeskTypClicks('FAQ')"
        >
          <div class="whatsap-img">
            <img
              src="././assets/e2medu/icons/faq.svg"
              alt="FAQ"
              height="40px"
              width="40px"
            />
          </div>

          <div class="whatsap-text">
            <h3 style="color: #000">FAQ</h3>
          </div>
        </div>

        <!-- <v-list v-for="item in HelpMenuData" :key="item.Id">
          <v-list-item
            @click="helpDeskTypClicks(item.Name)"
            v-if="
              item.IsVisable == 'All'
                ? true
                : $store.state.user[0].userType == 'Attendee'
            "
          >
            <v-list-item-icon
              v-if="
                item.IsVisable == 'All'
                  ? true
                  : $store.state.user[0].userType == 'Attendee'
              "
            >
              <v-avatar size="60px" v-if="item.Name == 'View Campus Guide'">
                <img src="././assets/e2medu/icons/help-video.svg" alt="Help" />
              </v-avatar>
              <v-avatar
                size="60px"
                v-if="item.Name == 'Contact Campus Helpdesk'"
              >

                <v-icon size="35" color="#8a8a8a">mdi-whatsapp</v-icon>
              </v-avatar>
              <v-avatar size="60px" v-if="item.Name == 'My Virtual Background'">
                <img src="././assets/e2medu/icons/virtual-bg.svg" alt="Help" />
              </v-avatar>
            </v-list-item-icon>

            <v-list-item-content
              :class="
                item.IsVisable == 'All'
                  ? 'help-desk-container-options'
                  : $store.state.user[0].userType == 'Attendee'
                  ? 'help-desk-container-options'
                  : ''
              "
              v-if="
                item.IsVisable == 'All'
                  ? true
                  : $store.state.user[0].userType == 'Attendee'
              "
            >
              <v-list-item-title>{{ item.Name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list> -->
      </div>
    </div>
    <v-fab-transition>
      <v-btn
        rounded
        dark
        @click="onHelpDeskClick()"
        fixed
        style="margin-bottom: 10px; margin-right: 13px"
        v-if="allowWhatsapp == 'true'"
        color="#383f97"
        bottom="40"
        right="40"
        class="v-btn--example wtsp-btn"
      >
        <div class="d-flex align-items-center">
          <!-- <v-icon size="25" color="white">mdi-whatsapp</v-icon> -->
          <v-span v-if="allowWhatsapp == 'true'" class="ml-1"
            >Campus Help</v-span
          >
        </div>
      </v-btn>
    </v-fab-transition>

    <div
      class="common-loader"
      v-if="commonLoader"
      style="
        margin: 0px;
        padding: 0px;
        position: fixed;
        right: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        z-index: 30001;
        opacity: 1;
        transform: scale(2);
      "
    >
      <div class="loader">
        <v-progress-circular
          size="30"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
    </div>

    <div
      class="common-loader"
      v-if="commonTextLoader"
      style="
        margin: 0px;
        padding: 0px;
        position: fixed;
        right: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        z-index: 30001;
        opacity: 1;
        transform: scale(2);
      "
    >
      <div class="loader">
        <v-progress-circular
          size="30"
          indeterminate
          color="primary"
        ></v-progress-circular>

        <span style="color: #1976d2 !important; margin-left: 14px">
          Loading...</span
        >
      </div>
    </div>

    <v-dialog
      v-model="dialog"
      id="leaderboaed-dialog"
      persistent
      content-class="leaderboaed-dialog"
      transition="scroll-x-reverse-transition"
      style="min-height: 600px; max-width: 1000px; z-index: 9999"
    >
      <v-card-text
        class="ex-dialog-body px-0"
        style="p-0;font-size:1rem; padding:0; position: relative;"
      >
        <div style="position: absolute; right: 10px; top: 10px; width: 32px;">
          <v-icon style="z-index: 2; color: #fff;" size="32" @click="closeHandler()"
            >close</v-icon
          >
        </div>
        <LeaderBoard
          :key="lbKey"
          ref="atttendeeLB"
          :isModal="true"
          :usersTabInModal="true"
          :usersTabTop3InModal="false"
          :groupsTabInModal="false"
          :myScorecardTabInModal="true"
          :myTotalScoreInModal="false"
          style="min-height: 600px; max-width: 1000px"
        ></LeaderBoard>
      </v-card-text>
    </v-dialog>

    <v-dialog
      v-model="dialogReg"
      persistent
      transition="scroll-x-reverse-transition"
      width="unset"
    >
      <v-card-text
        class="ex-dialog-body px-0 p-0"
        style="
          height: 600px;
          width: 720px;
          font-size: 1rem;
          padding: 0;
          position: relative;
        "
      >
        <div style="position: absolute; right: 10px; top: 0px; width: 30px">
          <v-icon
            id="btnCloseRegDialog"
            style="z-index: 2"
            size="30"
            @click="closeRegDialog()"
            >close</v-icon
          >
        </div>
        <div style="height: 600px; overflow: hidden">
          <iframe
            id="iframeReg"
            :src="regLink"
            frameborder="0"
            height="100%"
            width="100%"
          ></iframe>
          <!--@initVisitorRegForm="initVisitorRegForm"-->
          <RegForm
            v-if="false"
            :key="dialogRegKey"
            :regEventId="eventId"
          ></RegForm>
        </div>
      </v-card-text>
    </v-dialog>
    <div
      v-if="dialogReg"
      id="dialogReg"
      @click="closeRegDialogOnSuccess()"
    ></div>
    <v-dialog
      content-class="client-dialog-briefcase saudi-briefcase-dialog"
      persistent
      scrollable
      v-model="briefcaseDialog"
      max-width="894"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      style="z-index: 9999"
    >
      <v-card class="saudi-briefcase-card">
        <button
          type="button"
          class="saudi-briefcase-close"
          aria-label="Close"
          @click="briefcaseDialog = false"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 24 24"
            fill="none"
          >
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke="#26282b"
              stroke-width="1.5"
            />
            <path
              d="M14.83 9.17 9.17 14.83M14.83 14.83 9.17 9.17"
              stroke="#26282b"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        <v-card-text class="saudi-briefcase-body">
          <briefcase
            @closeOnClick="briefcaseDialog = false"
            v-if="briefcaseDialog"
            class="mx-0"
          ></briefcase>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="playerDialog"
      id="playerDialog"
      persistent
      :fullscreen="dialogSessionId ? true : false"
      content-class="player-dialog"
      transition="scroll-x-reverse-transition"
      :style="
        'z-index: 1100; ' +
        (dialogSessionId ? '' : 'min-height: 600px; max-width: 1000px;')
      "
    >
      <v-card-text
        class="player-dialog-body px-0"
        style="font-size: 1rem; padding: 0; position: relative"
      >
        <div
          v-if="!playerPIPMode && callStarted"
          style="position: absolute; left: 10px; top: 10px; width: 24px"
          class="d-none"
        >
          <v-icon
            style="background: #fff; border-radius: 50%; z-index: 5"
            size="24"
            @click="onClosePlayerDialog"
            >close</v-icon
          >
        </div>
        <!-- <div class="pipright">{{ right }}</div>
        <div class="pipbottom">{{ bottom }}</div> -->
        <div v-show="callStarted" class="btn-pip">
          <!-- <img
            v-if="!playerPIPMode"
            @click="playerPIPMode = true"
            height="30"
            width="30"
            src="./assets/Player/images/pip-in.svg"
          /> -->
          <img
            v-if="playerPIPMode"
            @click="playerPIPMode = false"
            height="30"
            width="30"
            src="./assets/Player/images/pip-out.svg"
          />
        </div>
        <!-- <div style="position: absolute; left: 10px; top: 10px; width: 30px; z-index: 3;cursor: pointer; background:rgba(0, 0, 0, 0.4);">


        </div> -->
        <LiveStageNG
          v-if="playerDialog"
          :key="playerKey"
          :roomId="roomId"
          :dialogSessionId="dialogSessionId"
          :dialogEventId="dialogEventId"
          :dialogEventName="dialogEventName"
          :dialogEventCollectionName="dialogEventCollectionName"
          :dialTime="dialTime"
          :pipMode="playerPIPMode"
          :memberList="roomMemberList"
          @onCallStarted="onCallStarted"
          style=""
        ></LiveStageNG>
      </v-card-text>
    </v-dialog>

    <v-dialog v-model="chatResourceDialog" class="chat-dialog" width="500">
      <v-card>
        <v-card-actions
          :class="
            clientName != ''
              ? 'd-flex justify-content-between'
              : 'd-flex justify-content-end'
          "
        >
          <h3 v-if="clientName != ''">How It Works</h3>
          <div class="close-action">
            <v-icon dark size="20" color="#333" @click="closeResourceDialog()"
              >mdi-close</v-icon
            >
          </div>
        </v-card-actions>
        <div class="open-section p-3" v-if="chatFileType == 'PDF'">
          <iframe height="500px" width="100%" :src="chatFileUrl"> </iframe>
        </div>
        <div
          class="open-section p-3 chat-img-wraper"
          v-else-if="chatFileType == 'IMAGE'"
        >
          <img :src="chatFileUrl" />
        </div>
        <div
          class="open-section p-3 chat-img-wraper"
          v-else-if="chatFileType == 'VIDEO'"
        >
          <iframe
            height="400px"
            width="100%"
            :src="chatFileUrl"
            allowfullscreen
          >
          </iframe>
        </div>
      </v-card>
    </v-dialog>

    <div
      class="modal fade admin-login-modal"
      id="SignUpModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body position-relative">
            <div
              class="admin-login-section-wrap"
              v-if="!showVerificationLinkSentMessage"
            >
              <div>
                <h2>Sign Up</h2>

                <!-- <p>Don't have an account yet? <a href="">sign up</a></p> -->
              </div>
              <div class="d-none">
                <h2>
                  Create<br />
                  your account
                </h2>
                <p>
                  Already have an account? <a href=""><u>sign in</u></a>
                </p>
              </div>
              <div class="social-login-section d-none">
                <div class="single-social" v-if="microsoftLoginEnabled">
                  <img src="./assets/Images/microsoft.png" />
                  <p>Microsoft</p>
                </div>
                <button
                  v-if="
                    googleclientId != null &&
                    googleLoginEnabled &&
                    !showGoogleBtnLoading
                  "
                  v-google-signin-button="googleclientId"
                  class="google-signup-button"
                >
                  Google
                </button>
                <button
                  v-if="
                    googleclientId != null &&
                    googleLoginEnabled &&
                    showGoogleBtnLoading
                  "
                  v-google-signin-button="googleclientId"
                  class="google-signup-button"
                >
                  <i class="fa fa-circle-o-notch fa-spin"></i>
                </button>
                <button
                  v-if="facebookClientId && fbLoginEnabled"
                  v-facebook-login-button="facebookClientId"
                  data-tag="facebookSignin"
                  class="facebook-signup-button"
                >
                  Facebook
                </button>

                <!-- <div class="single-social" @click="facebookSignupClick()">
                  <img src="./assets/Images/facebook-letter-logo.svg" />
                  <p>Facebook</p>
                </div> -->
                <div class="single-social" v-if="linkedInLoginEnabled">
                  <img src="./assets/Images/linked-in.png" />
                  <p>LinkedIn</p>
                </div>
              </div>
              <div class="or-div mt-4 mb-2">
                <p>or continue with</p>
              </div>

              <div class="admin-login-field-wrap">
                <input
                  v-if="!showHideSignInForm"
                  type="submit"
                  value="Sign up with email"
                  @click="showHideSignInForm = true"
                />
              </div>

              <div class="admin-login-field-wrap d-none">
                <label>Email<span>*</span></label>
                <input type="text" placeholder="Enter email" />

                <label>Password<span>*</span></label>
                <input
                  type="password"
                  placeholder="Enter password"
                  autocomplete="new-password"
                />
                <a href="" class="forgot-pwd">Forgot Password?</a>
                <input type="submit" value="Log in" />
              </div>
              <div class="admin-signup-field-wrap" v-if="showHideSignInForm">
                <ul class="d-flex justify-content-between align-items-center">
                  <li class="mr-2">
                    <label>First Name</label>

                    <input
                      type="text"
                      name="firstName"
                      id="firstName"
                      v-model="firstName"
                      onkeydown="return /[a-z]/i.test(event.key)"
                    />
                  </li>
                  <li class="ml-2">
                    <label>Last Name</label>
                    <input
                      type="text"
                      name="lastName"
                      id="lastName"
                      v-model="lastName"
                      onkeydown="return /[a-z]/i.test(event.key)"
                    />
                  </li>
                </ul>

                <label>Email Address</label>
                <input
                  type="email"
                  name="emailId"
                  id="emailId"
                  v-model="emailId"
                />

                <!-- <label>Password</label>
                <input type="password" name="" id="" value="" /> -->

                <!-- <input type="submit" @click="sendEmaiVerification()" :loading="IsSubmitting" /> -->

                <v-btn
                  :loading="IsSubmitting"
                  style="color: #fff; font-size: 16px; width: 100%"
                  color="#1a73e8"
                  @click="sendEmaiVerification"
                >
                  Submit
                </v-btn>
              </div>
              <div
                class="already-reged d-flex justify-content-center align-items-end mt-2"
              >
                <p>
                  Already Registered?
                  <a href="javascript:void(0)" @click="sendToLogin()"
                    >Click here to login</a
                  >
                </p>
              </div>
              <p class="terms-conditions">
                By signing in, I agree to the
                <a href="https://e2m.live/privacy-policy" target="_blank"
                  >privacy policy</a
                >
                and
                <a href="https://e2m.live/terms-of-use" target="_blank"
                  >Terms of service</a
                >.
              </p>
            </div>

            <div class="admin-login-close-button">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div
              class="reg-success-sec my-8"
              v-if="showVerificationLinkSentMessage"
            >
              <div class="reg-success-box-hld">
                <h3>Welcome!</h3>
                <p class="mt-0">
                  Thanks for signing up! We just need you to verify your email
                  address to complete setting up your account.
                </p>
              </div>
              <!-- <div
                class="d-flex justify-content-center align-items-center mt-5"
              >
                <v-btn dark color="#1a73e8"
                  ><v-icon dark color="#fff" size="20px" class="mr-1"
                    >mdi-email-outline</v-icon
                  >
                  Verify My Email</v-btn
                >
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      id="EventSetupBasic"
      class="modal common-modal-wrap"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header px-6 mb-0">
            <h2 class="modal-title">Basic Setup</h2>
            <p class="modal-close" @click="CloseBasicSetup">
              <v-icon size="32">mdi-close</v-icon>
            </p>
          </div>
          <div class="modal-body p-0">
            <EventSetupBasic
              v-if="eventSetupBasicDialog"
              :key="eventSetupBasicKey"
              :event_collectionName="event_collectionName"
              :clientId="clientId"
              :eventId="eventId"
              @OnUpdateBasicSetupSuccess="OnUpdateBasicSetupSuccess"
              @OnCancelBasicSetupSuccess="OnCancelBasicSetupSuccess"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      id="EventSetupMenu"
      class="modal common-modal-wrap"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header px-6 mb-0">
            <h2 class="modal-title">Manage Menu</h2>
            <p class="modal-close" @click="CloseManageMenu">
              <v-icon size="32">mdi-close</v-icon>
            </p>
          </div>
          <div class="modal-body p-0">
            <EventSetupMenu
              v-if="eventSetupMenuDialog"
              :key="eventSetupMenuKey"
              :event_collectionName="event_collectionName"
              :clientId="clientId"
              :eventId="eventId"
              @OnUpdateManageMenuSuccess="OnUpdateManageMenuSuccess"
              @OnCancelManageMenuSuccess="OnCancelManageMenuSuccess"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      id="MyUserProfile"
      class="modal fade adminprofile-editmodal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <MyUserProfile :key="MyUserProfileKey" />
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade eventpublishmodal"
      id="EventPublishModalCenter"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <!-- <div v-if="!showPublishSuccessDialog">
              <div class="publish-top-head position-relative">
                <h2>Choose a domain before publish</h2>
                <span data-dismiss="modal" aria-label="Close"
                  ><v-icon color="#959595" size="25px">mdi-close</v-icon></span
                >
              </div>
              <div class="publisho-option">
                <v-radio-group v-model="radios3" mandatory>
                  <div class="single-publish-options selected-class">
                    <div>
                      <v-radio value="radio-1"></v-radio>
                    </div>
                    <div class="free-site-sec">
                      <div class="position-relative">
                        <input
                          type="text"
                          name=""
                          id=""
                          value="https://e2m.live/mysitename"
                        />
                        <div class="inp-ico">
                          <v-icon color="#959595" size="25px">mdi-earth</v-icon>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="single-publish-options">
                    <div>
                      <v-radio value="radio-2"></v-radio>
                    </div>
                    <div class="free-site-sec">
                      <div class="position-relative">
                        <h4 class="mb-0">Connect your own customized domain</h4>
                      </div>
                    </div>
                  </div>
                </v-radio-group>
                <div
                  class="
                    proceed-buttons
                    d-flex
                    justify-content-center
                    align-items-center
                    final-button
                  "
                >
                  <v-btn
                    depressed
                    large
                    color="#1c1d26"
                    outlined
                    plain
                    width="120px"
                    class="mr-3"
                    data-dismiss="modal"
                    >Cancel</v-btn
                  >

                  <v-btn dark large color="#1a73e8" @click="savePublishSite()"
                    >Save &amp; Continue</v-btn
                  >
                </div>
              </div>
            </div> -->

            <div v-if="showPublishSuccessDialog">
              <div class="congrats-head-top position-relative">
                <h3>Congratulations!</h3>
                <p>Your Event is published now.</p>
                <div
                  v-if="CurrentAdminEvent && CurrentAdminEvent.IsPublished"
                  class="d-flex mt-2 justify-content-center align-items-center"
                >
                  <p>Unpublish</p>
                  <v-switch
                    hide-details
                    class="mt-1 ml-2 mb-0 p-0"
                    @change="changeEventStatusConfirm"
                    v-model="EventIsPublished"
                  />
                </div>
                <span data-dismiss="modal" aria-label="Close"
                  ><v-icon color="#959595" size="25px">mdi-close</v-icon></span
                >
              </div>
              <div class="congrats-head-body free-site-link mt-12">
                <div class="copy-link-area1 position-relative">
                  <div
                    class="position-relative link-feild-wrap"
                    style="flex: 1 1 0"
                  >
                    <div class="inp-ico">
                      <v-icon color="#959595" size="25px">mdi-earth</v-icon>
                    </div>
                    <input
                      type="text"
                      name=""
                      id="publishedreglink"
                      :value="getPublishLink"
                      class="pl-12"
                    />
                    <v-btn @click="copyLinkRegistration">
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </div>
                  <span id="custom-tooltip-reg" class="copy-text">copied!</span>
                </div>

                <a :href="getPublishLink" target="_blank" class="open-in-new"
                  >Open in new window
                  <v-icon color="#1a73e8" size="20px">mdi-open-in-new</v-icon>
                </a>
                <div class="share-section">
                  <p>Share with</p>
                  <ul>
                    <li>
                      <v-icon color="#4b4e63" size="25px">mdi-facebook</v-icon>
                    </li>
                    <li>
                      <v-icon color="#4b4e63" size="25px"
                        >mdi-facebook-messenger</v-icon
                      >
                    </li>
                    <li>
                      <v-icon color="#4b4e63" size="25px">mdi-linkedin</v-icon>
                    </li>
                    <li>
                      <v-icon color="#4b4e63" size="25px">mdi-twitter</v-icon>
                    </li>
                    <li>
                      <v-icon color="#4b4e63" size="25px">mdi-whatsapp</v-icon>
                    </li>
                    <li>
                      <v-icon color="#4b4e63" size="25px">mdi-email</v-icon>
                    </li>
                  </ul>
                </div>
                <div class="share-section store-wrap mt-8">
                  <p>Download the e2m live event app</p>
                  <ul
                    class="m-0 p-0 d-flex justify-content-center align-items-center"
                  >
                    <li>
                      <a
                        href="https://play.google.com/store/apps/details?id=ws.e2m.onair.kotlin&hl=en_IN&gl=US"
                        target="_blank"
                        ><img src="./assets/Images/g-store.png"
                      /></a>
                    </li>
                    <li>
                      <a
                        href="https://apps.apple.com/in/app/e2m-onair/id1516618112"
                        target="_blank"
                        ><img src="./assets/Images/app-store.png"
                      /></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="">
      <v-dialog
        v-if="bannerDialog"
        v-model="bannerDialog"
        scrollable
        transition="scroll-x-reverse-transition"
        max-width="1024"
        content-class="banner-upload-dialog"
        style="z-index: 20001"
      >
        <v-card>
          <div style="position: absolute; right: 10px; top: 15px">
            <v-icon style="z-index: 2" size="32" @click="bannerDialog = false">
              close
            </v-icon>
          </div>
          <v-card-title class="text-h5"> Upload Banner </v-card-title>
          <v-card-text style="max-height: 600px">
            <EventSetupBanner
              :key="bannerDialogKey"
              :event_collectionName="event_collectionName"
              :clientId="clientId"
              :eventId="eventId"
              :paramDesktopBanner="desktopBanner"
              :paramMobileBanner="mobileBanner"
              :paramShareBanner="shareBanner"
              @onSaveBannerSuccess="onSaveBannerSuccess"
              @CancelBannerUpload="CancelBannerUpload"
            ></EventSetupBanner>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <BulkUpload
      v-if="invitationFileUploadDialog"
      :key="resetBulkUploadComponent"
      type="invitee"
    />
    <v-dialog
      v-model="inviteUserDialog"
      transition="dialog-top-transition"
      max-width="850"
      scrollable
    >
      <template>
        <v-card class="invite-mod">
          <div style="position: absolute; right: 10px; top: 15px">
            <v-icon
              style="z-index: 2"
              size="32"
              @click="inviteUserDialog = false"
              >mdi-close</v-icon
            >
          </div>
          <v-card-title><h5>Invite Attendee</h5> </v-card-title>
          <v-card-text>
            <div class="invite-user-head">
              <div
                class="d-flex justify-content-between align-items-center final-button"
              >
                <h5>
                  Add Name, email of a invitee one by one or simply paste bulk
                </h5>
                <v-btn text color="#000" @click="openBulkUploadPopup()"
                  >Upload File
                  <v-icon color="#000" size="25" class="ml-3"
                    >mdi-tray-arrow-up</v-icon
                  ></v-btn
                >
              </div>
              <div class="invite-user-details-entry">
                <textarea cols="12" rows="5" name="" id="" value=""></textarea>
              </div>
              <div
                class="d-flex justify-content-center align-items-center mt-3"
              >
                <v-btn
                  outlined
                  color="#1c1d26"
                  width="100px"
                  class="mr-2 cancel-standard"
                  >Clear</v-btn
                >
                <v-btn dark color="#2376e5" width="100px" class="save-standard"
                  >Add</v-btn
                >
              </div>
            </div>
            <div class="regd-user-list">
              <table>
                <thead>
                  <tr>
                    <th>&nbsp;</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Registration Staus</th>
                  </tr>
                </thead>
                <tbody v-if="invitedAttendees.length > 0">
                  <tr v-for="invitee in invitedAttendees" :key="invitee.email">
                    <td>
                      <v-checkbox
                        v-model="invitee.isChecked"
                        color="#1c1d26"
                      ></v-checkbox>
                    </td>
                    <td>{{ invitee.first_name }} {{ invitee.last_name }}</td>
                    <td>{{ invitee.email }}</td>
                    <td v-if="invitee.status == 0">
                      <div class="user-invite-status pending-status">
                        <p>Pending</p>
                      </div>
                    </td>
                    <td v-else>
                      <div class="user-invite-status approved-status">
                        <p>Approved</p>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td style="width: 100%" colspan="4">
                      <div class="overview-info-msg-box">
                        <h4 class="text-center">
                          Please upload atttende for inviting them to your event
                        </h4>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-card-text>
          <v-card-actions class="p-0">
            <div
              class="d-flex justify-content-between align-items-center invite-action-group"
            >
              <div class="send-email-drop-select">
                <v-select
                  item-text="name"
                  item-value="value"
                  :items="mailtemplateInvitee"
                  label="Select Mail Template"
                  outlined
                  color="#c9d4dd"
                  v-model="selectedInviteeTemplate"
                ></v-select>
              </div>
              <div class="invite-action-buttons">
                <v-btn
                  outlined
                  color="#1c1d26"
                  class="mr-2 cancel-standard"
                  width="100px"
                  @click="inviteUserDialog = false"
                  >Cancel</v-btn
                >

                <v-btn
                  v-if="selectedInviteeTemplate == null"
                  disabled
                  color="#2376e5"
                  class="save-standard"
                  >Send Invitation</v-btn
                >
                <v-btn
                  v-else
                  dark
                  color="#2376e5"
                  class="save-standard"
                  @click="sendBulkInviteMail()"
                  >Send Invitation</v-btn
                >
              </div>
            </div>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <div class="import-progresswrap">
      <v-snackbar
        v-model="showBulkUploadProgress"
        :timeout="timeout"
        color="#e4eefe"
      >
        <div v-if="ShowProgressBarMsg">
          <p class="Prog-msg-style">
            {{ ProgressbarMessage }}
          </p>
        </div>

        <template v-slot:action="{ attrs }">
          <v-btn
            color="#fff"
            fab
            icon
            text
            v-bind="attrs"
            @click="showBulkUploadProgress = false"
            height="25px"
            width="25px"
          >
            <v-icon color="#1a73e8" size="20px">mdi-close</v-icon>
          </v-btn>
        </template>
        <div class="upload-progress-bar">
          <v-progress-linear
            :value="ProgressBarPercent"
            color="#28c76f"
            background-color="#e9f9f0"
            height="6px"
          ></v-progress-linear>
        </div>
      </v-snackbar>
    </div>

    <div
      class="modal fade admin-login-modal"
      id="AdminLoginModalCenter"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body position-relative">
            <div class="admin-login-section-wrap">
              <div>
                <h2>Log in</h2>

                <p>
                  Don't have an account yet?
                  <a
                    href="#"
                    @click="
                      closeLoginPopup();
                      return false;
                    "
                    >sign up</a
                  >
                </p>
              </div>
              <div class="d-none">
                <h2>
                  Create<br />
                  your account
                </h2>
                <p>
                  Already have an account? <a href=""><u>sign in</u></a>
                </p>
              </div>

              <div class="social-login-section d-none">
                <div class="single-social">
                  <img src="./assets/Images/microsoft.png" />
                  <p>Microsoft</p>
                </div>
                <div class="single-social">
                  <img src="./assets/Images/google-login-icon.png" />
                  <p>Google</p>
                </div>
                <div class="single-social">
                  <img src="./assets/Images/linked-in.png" />
                  <p>LinkedIn</p>
                </div>
              </div>
              <div class="or-div mt-4 mb-2">
                <p>or continue with</p>
              </div>
              <div class="admin-login-field-wrap">
                <label>Email<span>*</span></label>
                <input
                  type="text"
                  name="selfserviceemail"
                  id="selfserviceemail"
                  placeholder="Enter email"
                  v-model="selfServiceLoginEmailId"
                />

                <label>Password<span>*</span></label>

                <input
                  type="password"
                  name="selfservicepassword"
                  id="selfservicepassword"
                  placeholder="Enter password"
                  v-model="selfServiceLoginPassword"
                  v-on:keyup.enter="selfServiceuserLogin()"
                />

                <a href="/#recoverpass" class="forgot-pwd d-none"
                  >Forgot Password?</a
                >
                <input
                  type="submit"
                  value="Log in"
                  @click="selfServiceuserLogin()"
                  v-on:keyup.enter="selfServiceuserLogin()"
                />
              </div>
              <div class="admin-signup-field-wrap d-none">
                <ul class="d-flex justify-content-between align-items-center">
                  <li class="mr-2">
                    <label>First Name</label>
                    <input type="text" />
                  </li>
                  <li class="ml-2">
                    <label>Last Name</label>
                    <input type="text" />
                  </li>
                </ul>

                <label>Email Address</label>
                <input type="email" />

                <label>Password</label>
                <input type="password" />

                <input type="submit" value="Continue" />
              </div>
              <p class="terms-conditions">
                By signing in, I agree to the
                <a href="https://e2m.live/privacy-policy" target="_blank"
                  >privacy policy</a
                >
                and
                <a href="https://e2m.live/terms-of-use" target="_blank"
                  >Terms of service</a
                >.
              </p>
            </div>

            <div class="admin-login-close-button">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div id="overlay-test" class="login-attendee">
      <div class="attendee-img-hld mx-auto" id="userInitials">
        {{ userInitials }}
      </div>
      <div class="attendee-img-hld mx-auto d-none" id="user-profile-img">
        <img :src="userImage" class="imguserthumb" v-on:load="loadImage()" />
      </div>

      <div class="welcome-attendee">
        <span class="welcome">Welcome </span>
        <span class="attendee">{{ userFirstName }}!</span>
      </div>
      <div>
        <v-progress-circular
          size="30"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <div
        v-if="reLoginMessageFlg"
        style="display: contents; justify-content: center; align-items: center"
      >
        <span style="color: #1c1c69; font-weight: 500; font-size: 14px"
          >Looks like your session has expired!</span
        >
        <br />
        <span
          style="color: #3248e6; font-size: 13px; font-weight: 500"
          @click="clearState()"
          >Re-login now</span
        >
      </div>
    </div> -->
    <!----take Photo start--->
    <v-dialog v-model="selfiePopup" scrollable max-width="400px">
      <v-card>
        <v-card-title
          >Take a Selfie

          <div style="position: absolute; right: 15px; top: 15px">
            <v-icon
              style="z-index: 2"
              size="20"
              @click="
                selfiePopup = null;
                toggleCamera();
              "
              >close</v-icon
            >
          </div>
        </v-card-title>
        <v-divider class="my-0"></v-divider>
        <v-card-text style="" class="p-0">
          <div class="takePhoto-innerwrap py-4">
            <!-- <div class="camera-sec" v-show="!isPhotoTaken"></div> -->
            <div
              v-if="isCameraOpen"
              v-show="!isLoading"
              class="camera-box position-relative"
              :class="{ flash: isShotPhoto }"
            >
              <div class="timer-wrapper" v-if="showTimer">
                <img src="./assets/Images/timer-white.gif" />
              </div>

              <video
                v-show="!isPhotoTaken"
                ref="camera"
                :width="300"
                :height="225"
                autoplay
              ></video>

              <canvas
                v-show="isPhotoTaken"
                id="photoTaken"
                ref="canvas"
                :width="300"
                :height="225"
              ></canvas>
            </div>

            <div class="takephotost-step text-center" v-if="takeSnapBtn">
              <p>Take A Selfie</p>
              <v-btn
                v-if="snapSelfieBtn"
                class="mx-2"
                fab
                dark
                large
                color="purple"
                @click="startPhotoCountDown()"
              >
                <strong>SNAP </strong>
              </v-btn>
              <v-btn v-else class="mx-2" fab dark large color="grey">
                <strong>SNAP </strong>
              </v-btn>
              <p v-if="selfiePopupWithFileUpload">Or Upload a File</p>

              <v-btn
                v-if="selfiePopupWithFileUpload"
                dark
                color="#1a73e8"
                class="upload-snap-file"
                @click="$refs.upload_chat_files.click()"
                ><v-icon color="#fff" size="22px" class="mr-2"
                  >mdi-tray-arrow-up</v-icon
                >Upload a file</v-btn
              >
              <input
                v-show="false"
                ref="upload_chat_files"
                type="file"
                accept="image/*,.pdf,.doc,.docx"
                @change="uploadChatFiles($event)"
              />
            </div>

            <div
              class="takephotond-step text-center"
              v-if="!takeSnapBtn && isPhotoTaken"
            >
              <p>Looking Good!</p>
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="mx-2"
                    fab
                    dark
                    large
                    color="#ffffff"
                    @click="
                      isPhotoTaken = false;
                      takeSnapBtn = true;
                    "
                  >
                    <v-icon size="25px" color="red"> mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Re-Take</span>
              </v-tooltip>
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="mx-2"
                    fab
                    dark
                    large
                    color="#ffffff"
                    @click="downloadImage"
                  >
                    <v-icon size="25px" color="green"> mdi-check</v-icon>
                  </v-btn>
                </template>
                <span>Perfect</span>
              </v-tooltip>
              <!-- <p>Or Upload Image</p> -->

              <!-- <div v-if="isPhotoTaken && isCameraOpen" class="camera-download">
                <a
                  id="downloadPhoto"
                  download="my-photo.jpg"
                  class="button"
                  role="button"
                  @click="downloadImage"
                >
                  Download
                </a>
              </div> -->
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="loginRegDecision"
      max-width="500px"
      style="z-index: 1051"
    >
      <v-card>
        <div class="login-reg-option-wrap position-relative p-5">
          <v-btn icon @click="loginRegDecision = false"
            ><v-icon color="#333" size="25px">mdi-close</v-icon></v-btn
          >
          <LoginRegDecision :page_params="login_reg_page_params" />
        </div>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showProfileEditPopup"
      width="1000"
      height="800"
      persistent
      scrollable
    >
      <v-card
        class="profile-input-section-popup p-2"
        height="80vh"
        style="overflow: hidden; overflow-y: auto"
      >
        <v-card-title>
          <div
            class="profile-pop-head pb-3 d-flex justify-content-between align-items-center"
          >
            <h3>Edit Profile</h3>
            <div style="position: absolute; right: 10px; top: 10px">
              <v-icon
                style="z-index: 2"
                size="32"
                @click="showProfileEditPopup = false"
                >close</v-icon
              >
            </div>
          </div>
        </v-card-title>
        <v-card-text>
          <EditProfile
            ref="EditProfile"
            @closePopup="showProfileEditPopup = false"
            @editProfileSuccess="editProfileSuccess"
            :key="editProfileKey"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--     
      persistent
      fullscreen="false"
      content-class="player-dialog"
      transition="scroll-x-reverse-transition"
      style="z-index: 1150" -->
    <v-dialog
      v-model="videoPlayerDialog"
      id="videoPlayerDialog"
      content-class="player-dialog"
      transition="scroll-x-reverse-transition"
      persistent
      scrollable
      style="z-index: 1150"
    >
      <v-card-text
        class="player-dialog-body px-0"
        style="font-size: 1rem; padding: 0; position: relative"
      >
        <!-- <LiveStageNG
          v-if="playerDialog"
          :key="playerKey"
          :roomId="roomId"
          :dialogSessionId="dialogSessionId"
          :dialogEventId="dialogEventId"
          :dialogEventName="dialogEventName"
          :dialogEventCollectionName="dialogEventCollectionName"
          :dialTime="dialTime"
          :pipMode="playerPIPMode"
          :memberList="roomMemberList"
          @onCallStarted="onCallStarted"
          style=""
        ></LiveStageNG> -->
        <!-- style="display: none" -->

        <div class="body-content player-wrapper-hld">
          <div class="video-wrapper">
            <VideoPlayer
              id="videoPlayerApp"
              ref="videoPlayer"
              class="vjs-custom-skin"
              style="width: auto !important"
              :disablePictureInPicture="true"
              :options="videoPlayerOptions"
              @ended="onVideoPlayerEnded"
              @timeupdate="onVideoPlayerTimeUpdate"
            ></VideoPlayer>
            <!-- @volumechange="onVideoPlayerVolumeChange($event)"
              @pause="onVideoPauseed"
              @waiting="onVideoPlayerWaiting"
              @lapsed="onVideoPlayerElapsed"
              @play="onVideoPlayerPlay($event)"
              @ready="onVideoPlayerReady($event)" -->
          </div>
        </div>
      </v-card-text>
    </v-dialog>

    <!-- <div
      v-if="displayScreenInfo"
    class="screen-info" style="position:absolute; z-index:1000000000;">aaaaaaaaaaaaaaaaaaaa{{displayScreenInfo}}</div>
    <div
      v-else
    class="screen-info" style="position:absolute; z-index:1000000000;">bbbbbbbbbbbbbb{{displayScreenInfo}}</div> -->
    <ScreenInfo
      class="screen-info"
      style="width: 100%; height: 100%; position: absolute; z-index: 1000000000"
      v-if="displayScreenInfo"
    />
    <!-- <div class="rotate-screen-holder">
      <RotateScreenMsg :key="screenInfoKey" v-if="screenInfoFlag"/>
    </div> -->
    <!--
      style="
        height: 200px;
        width: 300px;
        position: absolute;
        bottom: 0;
        right: 150px;
      " -->
  </v-app>
</template>

<script>
import GoogleSignInButton from "vue-google-signin-button-directive";
import FacebookLoginButton from "vue-facebook-login-button-directive";
import Vue from "vue";
import jQuery from "jquery";
let $ = jQuery;
import EventBus, { ACTIONS } from "./EventBus/EventBus";
//import { mapState } from "vuex";
import db from "./components/firebaseInit";
import URLs from "@/components/URLInit";
import router from "./router";
import store from "./store";
import moment from "moment";
import eventsubscribe from "@/components/EventSubscribe";
import firebase from "firebase";
import "firebase/auth";
import localeswitcher from "@/components/LangDropdown";
import RegForm from "./views/Form";
import analytics from "@/components/Analytics";
import common from "@/common";
//import axios from "axios";
//import firebase from 'firebase';

//import loadingBar from "@/components/loadingbar.vue";
//import ChatPanel from "@/components/ChatPanel";
import ChatPanel2 from "@/components/ChatPanelv2";
import CreateEvent from "@/components/CreateEvent";
import axios from "axios";
import APIs from "@/components/APIInit";
import { bus } from "@/main";
import LeaderBoard from "@/views/LeaderBoard.vue";
import briefcase from "./views/Briefcase.vue";
import LiveStageNG from "@/views/LiveStageNG.vue";
import jwt_decode from "jwt-decode";
//import { accountService } from "@/services";
import EventSetupMenu from "@/views/EventSetupMenu";
import EventSetupBasic from "@/views/EventSetupBasic";
import MyUserProfile from "@/views/MyUserProfile";
import EventSetupBanner from "@/views/EventSetupBanner";
import MobilePreview from "@/views/MobilePreview";
import routeConfig from "@/assets/route-config";
import ShareNetwork from "vue-social-sharing";
import BulkUpload from "@/views/BulkUpload.vue";
//import RotateScreenMsg from "@/components/RotateScreenMsg.vue";
import SelfServiceLeftMenu from "@/components/SelfServiceLeftMenu.vue";
import SelfServiceFooter from "@/components/SelfServiceFooter.vue";
import EventShare from "@/components/EventShare.vue";
import LoginRegDecision from "@/components/LoginRegDecision.vue";
import EditProfile from "@/components/EditProfile.vue";
import ScreenInfo from "@/components/ScreenInfo.vue";
import VideoPlayer from "@/components/VideoPlayer.vue";
Vue.use(ShareNetwork);

var self;
var eventListener;
var attendeeListener;
var versionListener;
var unreadMessageListener;
var notificationListener;
var userLoggedInStatusListener;
var userStatusDatabaseRef;
var dialTimer;
var welcomeVideoTimer;
//var attendeePagePresenceListner;

//var correntTimeMS = new Date().getTime();

const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

export default {
  directives: {
    GoogleSignInButton,
    FacebookLoginButton,
  },
  components: {
    //"loading-bar": loadingBar
    localeswitcher,
    ChatPanel2,
    LeaderBoard,
    briefcase,
    LiveStageNG,
    RegForm,
    CreateEvent,
    EventSetupBasic,
    EventSetupMenu,
    MyUserProfile,
    EventSetupBanner,
    MobilePreview,
    BulkUpload,
    SelfServiceLeftMenu,
    SelfServiceFooter,
    EventShare,
    LoginRegDecision,
    //RotateScreenMsg,
    EditProfile,
    ScreenInfo,
    VideoPlayer,
  },
  name: "App",
  data() {
    return {
      welcomeVideo: null,
      todaysDate: "",
      welcomeVideoSeen: false,
      videoPlayerDialog: false,
      videoPlayerElapsedTime: 0,
      videoPlayerOptions: {
        autoplay: true,
        controls: true,
        controlBar: {
          progressControl: false, // hides the time/progress bar
        },
        loop: false,
        spatialNavigation: {
          enabled: false,
          horizontalSeek: false,
        },
        //"pointer-events": "none",
        // controlBar: {
        //   timeDivider: false,
        //   durationDisplay: true,
        // },
        // poster: 'https://surmon-china.github.io/vue-quill-editor/static/images/surmon-5.jpg'
      },
      displayScreenInfo: false,
      selfServiceMenuKey: 0,
      showLeftMenuBoxes: 5,
      newAttendeePresenceFound: false,
      leftPresenceBubble: 0,
      externalLogoutUrl: "",
      attendeeDetailsPopup: false,
      rightPadding: 80,
      bottomPadding: 80,
      bubbleWidth: 65,
      selectedAttendeeName: "",
      selectedAttendeeTitle: "",
      selectedAttendeeCompany: "",
      selectedAttendeeId: "",
      isChatAndAttendeeTogglePresent: false,
      liveVisitorIndicator: true,
      livePeopleText: true,
      closeLiveAttendeeCount: true,
      attendeeHeadList: [],
      onlineAttendeeList: [],
      allOnlineAttendeeHeadList: [],
      showLobbyBubbleMenu: false,
      offset: true,
      snapSelfieBtn: true,
      disableLanguageOption: false,
      // viewSnack:false,
      showTimer: false,
      takeSnapBtn: true,
      isCameraOpen: false,
      selfiePopup: false,
      selfiePopupWithFileUpload: false,
      isPhotoTaken: false,
      isShotPhoto: false,
      isLoading: false,
      userImage: "",
      userFirstName: "",
      reLoginMessageFlg: false,
      userInitials: null,
      selfServiceLoginEmailId: null,
      selfServiceLoginPassword: null,
      selectedInviteeTemplate: null,
      invitedAttendees: [],
      hideLeftmenuMobile: false,
      ShowProgressBarMsg: false,
      ProgressbarMessage: null,
      selfServiceLoader: false,
      ProgressBarPercent: 0,
      showBulkUploadProgress: false,
      timeout: 500000,
      IsSubmitting: false,
      showGoogleBtnLoading: false,
      EventIsPublished: true,
      inviteUserDialog: false,
      invitationFileUploadDialog: false,
      resetBulkUploadComponent: 0,
      showPublishConfirmDialog: false,
      showPublishSuccessDialog: false,
      fbLoginEnabled: false,
      googleLoginEnabled: false,
      microsoftLoginEnabled: false,
      linkedInLoginEnabled: false,
      eventDetails: {},
      EnableSelfService: false,
      facebookClientId: "2682811168693469",
      resetCreateEvent: 0,
      openCreateEventSidePannel: false,
      firstName: "",
      lastName: "",
      emailId: "",
      showHideSignInForm: false,
      showVerificationLinkSentMessage: false,
      googleclientId: null,
      chatEnabledFromPlugins: false,
      onlineUserList: [],
      popupBlockInfo: false,
      helpMenu: false,
      alertScreenPotraitMsg: false,
      defaultRoomIdForChat: null,
      chatDefaultView: null,
      commonLoader: false,
      commonTextLoader: false,
      playerKey: 0,
      dialogSessionId: "",
      playerDialog: false,
      briefcaseDialog: false,
      chatResourceDialog: false,
      clientName: "",
      chatFileType: null,
      chatFileUrl: null,
      dialog: false,
      lbKey: 0,
      dialogReg: false,
      dialogRegKey: 0,
      regLink: "",
      allowWhatsapp: "false",
      versionInfo: false,
      bodyWith: "width:100%",
      drawer: false,
      shareDrawer: false,
      snackbar: false,
      snackbarMessage: "",
      position: "right",
      snackBarType: "info",
      topBannerColour: "",
      //----------------------------------------
      notificationId: "",
      NotificationTitle: "",
      NotificationMessage: "",
      hideNotificationClicked: false,
      displayYelloPopupNotification: false,
      //-------------------------------------
      bannerRedirectURL: "",
      event_collectionName: "",
      old_event_collectionName: "",
      publicEventCollection: "",
      homeUrl: "/",
      MenuData: [],
      LeftData: [],
      activeLeftMenuId: null,
      HelpMenuData: [
        //    {
        //   Id: 2,
        //   Name: "Contact Campus Helpdesk",
        //   Description: "Click here to contact with Campus Helpdesk",
        //   IsVisable: "All",
        // },
        {
          Id: 1,
          Name: "View Campus Guide",
          Description: "Click here to view the Campus Guide",
          IsVisable: "All",
        },
        {
          Id: 2,
          Name: "My Virtual Background",
          Description: "Click here to get zoom Background",
          IsVisable: "All",
        },
      ],
      ExhibitorSettings: [],
      showNotification: false, //ShowNotification Menu
      validetedURL: false,
      NotificationData: [],
      NotificationIndex: 0,
      correntTimeMS: new Date().getTime(),
      extraTime: 0,
      isDialing: false,
      dialingNotificationId: "",
      videoCallNotification: {},
      dialTimeRemaining: 0,
      IsSubscribed: false,
      GetPopupNotification: false,
      IsBrowserCheck: false,
      ClientIP: "",
      AllMenuData: [],
      productVersion: "",
      releaseNoteURL: "",
      showChatComponent: false,
      enableHiddenChatComponent: false,
      helpChatIcon: false,
      showPreviewLogin: false,
      hideEventHeaderAndMenu: true,
      uid: "",
      roomId: "",
      dialTime: 30,
      playerPIPMode: false,
      callStarted: false,
      alreadyInACallMsg:
        "You are already in a call. Please end the call and try again.",
      roomMemberList: [],
      myLeaderboardScore: 0,
      myLBScoreChangeState: 0,
      totalUnReadMsg: 0,
      showChatIcon: false,
      chatDisplayView: null,
      IsStageviewChatEanbled: false,
      displayScoreOnProfile: false,
      attendeeInfo: {
        myLeaderboardScore: 0,
      },
      userRoleIDs: [],
      myAgendaCount: 0,
      isSpeaker: false,
      eventId: "",
      clientId: "",
      paramEventId: "",
      autoLogin: false,
      isMobileView: false,
      desktopBanner: "",
      mobileBanner: "",
      shareBanner: "",
      currentDomain: null,
      currentRouteName: "",
      previousRouteName: "",
      pageLoadTimeStamp: 0,
      topBar: "",
      //AlwaysVisibleMenuRoutes: ["Reg3", "404"],
      GuestRoutes: [
        "EventShowCase",
        "Events",
        "Eventv3",
        "Reg3",
        "BasicInfo",
        "PaymentStatus",
      ],
      mobileItems: [
        "iPhoneX",
        "iPhoneXR",
        "iPhone 12",
        "Samsung Galaxy S8 Plus",
        "Sansung Galaxy S20 Ultra",
        "iPad Air",
        "iPad Mini",
      ],
      selectedMobile: "iPhone 12",
      mailtemplateInvitee: [{ name: "Invitation Mail", value: "Invitation" }],

      //UserRoutes: ["EventList"],
      //AdminRoutes: ["AdminEvent", "AdminReg", "AdminOverview"],

      EventRoutes: [
        "Lobby",
        "MyProfile",
        "MyProfileV2",
        "Sessions",
        "SpeakersLounge",
        "AttendeeList",
        "SpeakerList",
        "RoundtableList",
        "SponsorList",
        "SponsorsDetailsNew",
        "LiveStage",
        "LiveStageNG",
        "StageView",
        "MyMeetings",
        "ExhibitorsHall",
        "ExhibitorsView",
        "ExpoView",
        "LeaderBoard",
        "Resources",
        "LandingPage",
        "ZoomWeb",
        "ZoomWebVue",
        "PaymentStatus",
      ],
      DefaultClientRoutes: [
        "Home",
        "HomeUAT",
        "About",
        "Programme",
        "Partners",
        "UpcomingEvents",
        "YouthAmbassadors",
      ],
      GuestEventRoutes: ["Eventv3", "PaymentStatus"],
      AdminEventRoutes: [
        "Analytics",
        "AdminSessions",
        "AdminAttendeeList",
        "AdminSpeakerList",
        "AdminRoundtableList",
        "AdminEvent",
        "AdminReg",
        "AdminStageView",
        "EventSetup",
        "EvenBranding",
        "AdminExbitorshall",
      ],
      NoHeaderRoutes: [
        "",
        "Login",
        "eventlogin",
        "Lobby",
        "Event",
        "Reg",
        "videoplayer",
        "loginexternal",
        "OpenEvent",
        "changepass",
        "GeneratePass",
        "AdminDashboard",
        "MainLobby",
        "MainLobbyTasks",
        "MainLobbySessionCal",
        "MainLobbyProfile",
        "MainLobbySpeakers",
        "CourseOverview",
        "MainLobbyExhibitorsHall",
        "MainLobbySponsors",
        "MainLobbySessions",
        "MainLobbyResources",
        "MainLobbyAttendee",
        "VerifyUser",
        "ExpoViewAddEdit",
        "SocialLoginRedrictPage",
      ],
      NoMenuRoutes: [
        "Login",
        "eventlogin",
        "Lobby",
        "OpenEvent",
        "Events",
        "Event",
        "Eventv3",
        "Reg",
        "Reg3",
        "PaymentStatus",
        //"EventList",
        "AdminOverview",
        "videoplayer",
        "loginexternal",
        "changepass",
        "GeneratePass",
        "SocialLoginRedrictPage",
        //ADMINs

        "Analytics",
        "AdminSessions",
        "AdminAttendeeList",
        "AdminSpeakerList",
        "AdminRoundtableList",
        "AdminEvent",
        "AdminReg",
        "EventSetup",
        "EventShowCase",
        "BasicInfo",
        "EvenBranding",
        "AdminExbitorshall",
        // "AdminStageView",
      ],
      // AlwaysHideMenuBarRoutes: [
      //   "Login",
      //   "eventlogin",
      //   "Lobby",
      //   //"EventList",
      //   "videoplayer",
      //   "EventV3",
      //   "OpenEvent",
      //   "Events",
      //   "Eventv3",
      //   "Reg",
      //   "Reg3",
      //   "paymentstatus",
      //   "loginexternal",
      //   "changepass",
      //   "GeneratePass",
      // ],
      AdminEventEditRoutes: [
        "AdminSessions",
        "AdminAttendeeList",
        "AdminSpeakerList",
        "AdminRoundtableList",
        "AdminEvent",
        "Analytics",
        "AdminStageView",
        "EventSetup",
        "EvenBranding",
        "AdminExbitorshall",
      ],
      AdminEventPreviewRoutes: [
        "Sessions",
        "AttendeeList",
        "SpeakerList",
        "RoundtableList",
        "StageView",
        "Eventv3",
      ],
      // AdminRouteMapping: [
      //   {
      //     MenuId: 0,
      //     RouteName: "Eventv3",
      //     RoutePath: "/eventv3",
      //     AdminRouteName: "AdminEvent",
      //     AdminRoutePath: "/admin-event",
      //     IsPublished: true,
      //   },
      //   {
      //     MenuId: 0,
      //     RouteName: "Analytics",
      //     RoutePath: "/analytics",
      //     AdminRouteName: "Analytics",
      //     AdminRoutePath: "/analytics",
      //     IsPublished: true,
      //   },
      //   {
      //     MenuId: 1002,
      //     RouteName: "Sessions",
      //     RoutePath: "/sessions",
      //     AdminRouteName: "AdminSessions",
      //     AdminRoutePath: "/admin-sessions",
      //     IsPublished: true,
      //   },
      //   {
      //     MenuId: 1001,
      //     RouteName: "AttendeeList",
      //     RoutePath: "/attendee",
      //     AdminRouteName: "AdminAttendeeList",
      //     AdminRoutePath: "/admin-attendee",
      //     IsPublished: true,
      //   },
      //   {
      //     MenuId: 1005,
      //     RouteName: "SpeakerList",
      //     RoutePath: "/speakers",
      //     AdminRouteName: "AdminSpeakerList",
      //     AdminRoutePath: "/admin-speakers",
      //     IsPublished: true,
      //   },
      //   {
      //     MenuId: 1030,
      //     RouteName: "StageView",
      //     RoutePath: "/stageview",
      //     AdminRouteName: "AdminStageView",
      //     AdminRoutePath: "/admin-stageview",
      //     IsPublished: true,
      //   },
      // ],
      AdminEvents: [],
      CurrentAdminEvent: null,
      ShareEvent: null,
      previewOpened: true,
      topBannerUploading: true,
      MyUserProfileKey: 0,
      bannerDialog: false,
      bannerDialogKey: 0,
      eventSetupBasicDialog: false,
      eventSetupBasicKey: 0,
      eventSetupMenuDialog: false,
      eventSetupMenuKey: 0,
      mobilePreviewKey: 0,
      mobilePreviewVisible: false,
      siteLink: "https://events.e2m.live",
      pageLink: "https://events.e2m.live",
      eventName: "",
      hostName: "",
      socialShareOptions: [
        {
          Name: "facebook",
          Icon: "https://firebasestorage.googleapis.com/v0/b/e2monair.firebasestorage.app/o/OA_UAT%2FDefaults%2Fimage%2FSocialIcons%2Ffacebook.svg?alt=media",
          Color: "#405c96",
          Label: "Facebook",
        },
        {
          Name: "linkedin",
          Icon: "https://firebasestorage.googleapis.com/v0/b/e2monair.firebasestorage.app/o/OA_UAT%2FDefaults%2Fimage%2FSocialIcons%2Flinkedin.svg?alt=media",
          Color: "#1e7bb3",
          Label: "Linkedin",
        },
        {
          Name: "twitter",
          Icon: "https://firebasestorage.googleapis.com/v0/b/e2monair.firebasestorage.app/o/OA_UAT%2FDefaults%2Fimage%2FSocialIcons%2Ftwitter.svg?alt=media",
          Color: "#35a3f0",
          Label: "Twitter",
        },
        {
          Name: "messenger",
          Icon: "https://firebasestorage.googleapis.com/v0/b/e2monair.firebasestorage.app/o/OA_UAT%2FDefaults%2Fimage%2FSocialIcons%2Fmessenger.svg?alt=media",
          Color: "#2387fc",
          Label: "Messenger",
        },
        {
          Name: "whatsapp",
          Icon: "https://firebasestorage.googleapis.com/v0/b/e2monair.firebasestorage.app/o/OA_UAT%2FDefaults%2Fimage%2FSocialIcons%2Fwhatsapp.svg?alt=media",
          Color: "#5bc34f",
          Label: "WhatsApp",
        },
        {
          Name: "email",
          Icon: "https://firebasestorage.googleapis.com/v0/b/e2monair.firebasestorage.app/o/OA_UAT%2FDefaults%2Fimage%2FSocialIcons%2Femail.svg?alt=media",
          Color: "#848484",
          Label: "Email",
        },
      ],
      localTimeZone: "",
      MenuIDs: [],
      ShowPublicMenu: false,
      PublicMenuList: [
        {
          MenuID: 1,
          PageUrl: "/home",
          IconUrl:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.firebasestorage.app/o/OA_UAT%2FDefaults%2Fimage%2Fmenuicons%2Flight%2Fhome.svg?alt=media",
          DisplayLabel: "Home",
          DisplayLabel_de: "ZUHAUSE",
          DisplayLabel_fr: "DOMICILE",
          DisplayLabel_zh: "家",
        },
        {
          MenuID: 2,
          PageUrl: "/about",
          IconUrl:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.firebasestorage.app/o/OA_UAT%2FDefaults%2Fimage%2Fmenuicons%2Flight%2Fabout-us.svg?alt=media",
          DisplayLabel: "About Us",
          DisplayLabel_de: "Über uns",
          DisplayLabel_fr: "À propos de nous",
          DisplayLabel_zh: "关于我们",
        },
        // {
        //   MenuID: 3,
        //   PageUrl: "/programme",
        //   IconUrl:
        //     "https://firebasestorage.googleapis.com/v0/b/e2monair.firebasestorage.app/o/OA_UAT%2FDefaults%2Fimage%2Fmenuicons%2Flight%2Fprogramme.svg?alt=media",
        //   DisplayLabel: "Programme",
        //   DisplayLabel_de: "Programm",
        //   DisplayLabel_fr: "Programme",
        //   DisplayLabel_zh: "程序",
        // },
        {
          MenuID: 4,
          PageUrl: "/partners",
          IconUrl:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.firebasestorage.app/o/OA_UAT%2FDefaults%2Fimage%2Fmenuicons%2Flight%2Fpartners.svg?alt=media",
          DisplayLabel: "Partners",
          DisplayLabel_de: "Partner",
          DisplayLabel_fr: "Les partenaires",
          DisplayLabel_zh: "伙伴",
        },
        {
          MenuID: 5,
          PageUrl: "/upcomingevents",
          IconUrl:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.firebasestorage.app/o/OA_UAT%2FDefaults%2Fimage%2Fmenuicons%2Flight%2Fupcoming-events.svg?alt=media",
          DisplayLabel: "Upcoming Events",
          DisplayLabel_de: "Kommende Veranstaltungen",
          DisplayLabel_fr: "évènements à venir",
          DisplayLabel_zh: "即将举行的活动",
        },
        {
          MenuID: 6,
          PageUrl: "/youthambassadors",
          IconUrl:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.firebasestorage.app/o/OA_UAT%2FDefaults%2Fimage%2Fmenuicons%2Flight%2Fattendees.png?alt=media",
          DisplayLabel: "Youth Ambassadors",
          DisplayLabel_de: "Jugendbotschafter",
          DisplayLabel_fr: "Jeunes Ambassadeurs",
          DisplayLabel_zh: "青年大使",
        },
      ],
      right: 0,
      bottom: 0,
      pipLeft: 0,
      pipTop: 0,
      offset_data: null,
      loginRegDecision: false,
      login_reg_page_params: "",
      screenInfoFlag: false,
      screenInfoKey: 0,
      iPadLandscapePlayerSupport: false,
      showProfileEditPopup: false,
      editProfileKey: 0,
      app: null,
    };
  },
  computed: {
    videoPlayer() {
      return self.$refs.videoPlayer.player;
    },
    getUserInitial() {
      let result = "";
      if (this.$store.state.user && this.$store.state.user.length > 0) {
        return common.getInitials(this.$store.state.user[0].name);
      }
      return result;
    },
    getUserFirstName() {
      let result = "";
      if (this.$store.state.user && this.$store.state.user.length > 0) {
        result = this.$store.state.user[0].fname;
      }
      return result;
    },
    getUserName() {
      let result = "";
      if (this.$store.state.user && this.$store.state.user.length > 0) {
        result = this.$store.state.user[0].name;
      }
      return result;
    },
    getUserCompany() {
      let result = "";
      if (this.$store.state.user && this.$store.state.user.length > 0) {
        result = this.$store.state.user[0].company;
      }
      return result;
    },
    getUserDesignation() {
      let result = "";
      if (this.$store.state.user && this.$store.state.user.length > 0) {
        result = this.$store.state.user[0].title;
      }
      return result;
    },
    getUserProfilePictureURL() {
      let result = "";
      if (this.$store.state.user && this.$store.state.user.length > 0) {
        result = this.$store.state.user[0].profilepic;
      }
      return result;
    },
    AdminEventsSorted() {
      var eventId = "";
      if (self.CurrentAdminEvent) {
        eventId = self.CurrentAdminEvent.EventId;
      }
      var result1 = self.AdminEvents.filter(function (item) {
        return (
          self.correntTimeMS < item.EventEndDateTimeStamp * 1000 &&
          (!eventId || item.EventId != eventId)
        );
      });
      var result2 = self.AdminEvents.filter(function (item) {
        return (
          self.correntTimeMS >= item.EventEndDateTimeStamp * 1000 &&
          (!eventId || item.EventId != eventId)
        );
      });

      result1 = result1.sort(function (a, b) {
        let v1 = a.EventStartDateTimeStamp;
        let v2 = b.EventStartDateTimeStamp;
        return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
      });
      result2 = result2.sort(function (a, b) {
        let v1 = a.EventStartDateTimeStamp;
        let v2 = b.EventStartDateTimeStamp;
        return v1 > v2 ? -1 : v1 < v2 ? 1 : 0;
      });
      return result1.concat(result2);
    },
    getPublishLink() {
      var customDomain = self.$store.state.customDomain;
      var eventId = self.getEventId();
      return "https://" + customDomain + "/eventv3/" + eventId;
    },
    IsFullScreen() {
      return (
        (self.IsEventRoutes && self.hideEventHeaderAndMenu) || !self.ShowTopBar
      );
    },
    IsEventRoutes() {
      return self.EventRoutes.includes(this.currentRouteName);
    },
    ShowTopBar() {
      // alert("ShowTopBar : "+self.NoHeaderRoutes.includes(this.currentRouteName))
      if (
        self.currentDomain == "campus.edulife.sg" ||
        self.LocalhostDomain() == "campus.edulife.sg"
      ) {
        $("#app").addClass("edu");
        $("body").addClass("edu");
        return false;
      } else {
        $("#app").removeClass("edu");
        $("body").removeClass("edu");
        return !self.NoHeaderRoutes.includes(this.currentRouteName);
      }

      //return true;
      // return [
      //         'login',
      //         'eventlogin',
      //         'lobby',
      //         'events',
      //         'eventlist',
      //         'videoplayer',
      //         'Reg',
      //         '404',
      //         'OpenEvent',
      //         'Event',
      //         'paymentstatus',
      //         'loginexternal',
      //         'changepass',
      //         'GeneratePass',
      //       ].indexOf($route.name) == -1 && !self.hideEventHeaderAndMenu
    },
    ShowAppBar() {
      return true;
      // return ![
      //   "/",
      //   "/eventlogin",
      //   "/lobby",
      //   "/eventlist",
      //   "/evens",
      //   "/videoplayer",
      //   "Reg",
      //   "OpenEvent",
      //   "Event",
      //   "/paymentstatus",
      //   "/loginexternal",
      //   "/changepass",
      //   "/mainlobby",
      //   "/lobby",
      //   "/createpass",
      // ].includes(self.checkLocation) && !self.hideEventHeaderAndMenu;
    },
    ShowBanner() {
      //return !self.AdminEventRoutes.includes(this.currentRouteName);
      return true;
    },
    ShowTopMenuBar() {
      return !self.NoMenuRoutes.includes(self.currentRouteName);
      //return false;
    },
    ShowBannerMenu() {
      // alert(
      //   "ShowBannerMenu:" + self.GuestRoutes.includes(this.currentRouteName)
      // );
      return (
        self.GuestRoutes.includes(self.currentRouteName) ||
        !self.event_collectionName ||
        ((self.currentRouteName == "AdminOverview" ||
          self.currentRouteName == "EventList") &&
          self.event_collectionName)
      );
      //return true;
    },
    IsGuestMenu() {
      return self.GuestRoutes.includes(self.currentRouteName);
    },
    ShowEventMenu() {
      var result = false;
      if (
        (self.EventRoutes.includes(self.currentRouteName) &&
          self.event_collectionName) ||
        self.DefaultClientRoutes.includes(self.currentRouteName)
      ) {
        result = true;
      }
      return result;
    },
    ShowAdminEventMenu() {
      return (
        self.AdminEventRoutes.includes(self.currentRouteName) &&
        self.event_collectionName &&
        self.EnableSelfService
      );
    },
    IsAdminMenu() {
      return (
        self.AdminEventRoutes.includes(self.currentRouteName) &&
        self.EnableSelfService
      );
    },
    HideLeftMenu() {
      return [
        "Lobby",
        "MyProfile",
        "MyProfileV2",
        "StageView",
        "AdminStageView",
        "LiveStage",
        "LiveStageNG",
        "ExpoViewAddEdit",
        //"AdminEvent",
        "Analytics",
      ].includes(self.currentRouteName);
    },
    // ShowAdminPreviewMenu() {
    //   return self.AdminEventRoutes.includes(this.currentRouteName);
    // },

    // ShowTopMenu() {
    //   //alert(self.$route.name)
    //   // alert(self.hideEventHeaderAndMenu)
    //   //var eventAdmin = this.isEventAdmin();
    //   //var routeName = self.$route.name;
    //   return (
    //     !self.AlwaysHideMenuBarRoutes.includes(this.currentRouteName) &&
    //     (!self.hideEventHeaderAndMenu ||
    //       self.AlwaysVisibleMenuRoutes.includes(this.currentRouteName))
    //   );
    // },
    IsAdminEditPage() {
      //var routeList = ["AdminEvent", "AdminReg", "AdminOverview"];
      //alert("IsAdminEditPage: "+this.AdminEventEditRoutes.includes(this.currentRouteName))
      return (
        self.AdminEventEditRoutes.includes(self.currentRouteName) &&
        self.EnableSelfService
      );
    },
    IsAdminPreviewPage() {
      return (
        self.AdminEventPreviewRoutes.includes(self.currentRouteName) &&
        self.EnableSelfService
      );
    },
    IsEventListPage() {
      return [
        "EventShowCase",
        "Events",
        "EventList",
        "AdminOverview",
        "BasicInfo",
      ].includes(self.currentRouteName);
    },
    ShowAnonymous: function () {
      var result = false;
      var userId = self.getSessionUserId();
      if (!userId) {
        result = true;
      }
      return result;
    },
    ShowAdminOptions: function () {
      //alert(self.$route.name);
      var result = false;
      //var routeList = ["Eventv3", "Reg3", "AdminOverview"];
      var userId = self.getSessionUserId();
      var clientAdmin = self.isClientAdmin();
      var eventAdmin = self.isEventAdmin();
      // alert(userId);
      // alert(clientAdmin);
      // alert(eventAdmin);
      //routeList.includes(this.$route.name) &&
      if (self.currentRouteName && userId && (clientAdmin || eventAdmin)) {
        result = true;
      }
      // alert(this.currentRouteName);
      // alert(result);
      return result && self.EnableSelfService;
    },
    HasPreviewPage() {
      var result = false;
      for (var i = 0; i < routeConfig.PreviewEditMap.length; i++) {
        if (
          self.currentRouteName ==
            routeConfig.PreviewEditMap[i].AdminRouteName &&
          routeConfig.PreviewEditMap[i].IsPublished &&
          routeConfig.PreviewEditMap[i].RouteName !=
            routeConfig.PreviewEditMap[i].AdminRouteName
        ) {
          result = true;
          break;
        }
      }
      return result;
    },
    PreviewOrEditLink() {
      var result = "";
      for (var i = 0; i < routeConfig.PreviewEditMap.length; i++) {
        if (
          self.currentRouteName == routeConfig.PreviewEditMap[i].RouteName &&
          routeConfig.PreviewEditMap[i].IsPublished
        ) {
          result = routeConfig.PreviewEditMap[i].AdminRoutePath;
          // if (!["AdminEvent", "Eventv3"].includes(this.currentRouteName) && result.includes("{{EventId}}")) {
          //   result = result.replace("{{EventId}}", self.eventId);
          // }
          break;
        } else if (
          this.currentRouteName ==
            routeConfig.PreviewEditMap[i].AdminRouteName &&
          routeConfig.PreviewEditMap[i].IsPublished
        ) {
          result = routeConfig.PreviewEditMap[i].RoutePath;
          // if (!["AdminEvent", "Eventv3"].includes(this.currentRouteName) && result.includes("{{EventId}}")) {
          //   result = result.replace("{{EventId}}", self.eventId);
          // }
          break;
        }
      }
      switch (this.currentRouteName) {
        case "AdminSessions": {
          break;
        }
        case "AdminAttendeeList": {
          break;
        }
        case "AdminSpeakerList": {
          break;
        }
        case "Sessions": {
          break;
        }
        case "AttendeeList": {
          break;
        }
        case "SpeakerList": {
          break;
        }
        case "AdminEvent": {
          let eventId = this.$route.params.e;
          result += "/" + eventId;
          break;
        }
        case "Eventv3": {
          let eventId = this.$route.params.e;
          result += "/" + eventId;
          break;
        }
      }
      return result;
    },
    ShowQuickEventSelection() {
      var isSameEvent = false;
      var isAdmin = self.isClientAdmin() || self.isEventAdmin();
      //alert(isAdmin)
      //alert(this.currentRouteName)
      if (["Eventv3", "AdminEvent"].includes(this.currentRouteName)) {
        var eventId = this.$route.params.e;
        if (eventId && !isAdmin) {
          if (self.GuestRoutes.includes(this.currentRouteName)) {
            isAdmin = self.hasEventAdminRole(eventId);
          }
        }
        isSameEvent = !self.eventId || eventId == self.eventId;
      } else {
        isSameEvent = true;
      }
      return isAdmin && isSameEvent && this.EnableSelfService;
    },
    checkRoutePage: function () {
      return (
        !this.$route.name.includes("MainLobby") &&
        !this.$route.name.includes("Lobby")
      );
    },
    checkLocation: function () {
      if (this && this.$route) {
        self.enableTawk(this.$route.name);
      }
      if (this.$route.path && this.$route.path.includes("mainlobby")) {
        return "/mainlobby";
      } else if (this.$route.path && this.$route.path.includes("lobby")) {
        return "/lobby";
      } else return this.$route.path;
    },
    filteredNotificatioData() {
      //alert("filteredNotificatioData: "+self.uid);
      //var dialingFlag = false;
      var filteredData = self.NotificationData.filter(function (value) {
        // var returnFlag = false;
        // if(!dialingFlag)
        // {
        //   dialingFlag=true;
        //   returnFlag = true;
        // } && returnFlag
        return value.isSeen == "0";
      });
      //filteredData.sort(function (a, b) {
      //  let val1 = parseInt(a.Index);
      //  let val2 = parseInt(b.Index);
      //  if (val1 < val2) {
      //    return 1;
      //  }
      //  if (val1 > val2) {
      //    return -1;
      //  }
      //  return 0;
      //});
      return filteredData;
    },
    Userlists() {
      var firstName = "";
      var pPic = "";

      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj != undefined && obj !== null) {
        if (obj.user != undefined && obj.user != null) {
          if (obj.user.length > 0) {
            if (obj.user[0].fname !== undefined) {
              firstName = obj.user[0].fname;
            }
            if (obj.user[0].profilepic !== undefined) {
              pPic = obj.user[0].profilepic;
            }
          }
        }
      }
      return {
        userName: firstName,
        userImage: this.getCDNUrl(pPic),
      };
    },
    showLeftMenu() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      return obj.loading;
    },
    getMenuFont() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj == undefined || obj === null) {
        return "";
      }
      if (obj.EventBranding == undefined || obj.EventBranding == null) {
        return "";
      }
      if (obj.EventBranding.length > 0) {
        return obj.EventBranding[0].fontBar == undefined
          ? ""
          : obj.EventBranding[0].fontBar;
      } else {
        return "";
      }
    },
    formatMyLeaderboardScore() {
      var result = self.myLeaderboardScore;
      if (self.myLeaderboardScore > 999) {
        var r = self.myLeaderboardScore % 1000;
        result = parseInt(self.myLeaderboardScore / 1000);
        if (result > 9) {
          r = result % 10;
          result = 9;
        }
        result = result + "k";
        if (r > 0) {
          result = result + "+";
        }
      }
      return result;
    },
    BannerURL() {
      var result = "";
      if (self.isMobileView) {
        if (self.mobileBanner) {
          result = self.mobileBanner;
        } else {
          result = self.desktopBanner;
        }
      } else {
        result = self.desktopBanner;
      }
      return result;
    },
    IsExpoPage() {
      var result = false;
      if (
        ["ExhibitorsHall", "ExhibitorsView"].includes(self.currentRouteName)
      ) {
        result = true;
      }
      return result;
    },
  },
  watch: {
    "$route.fullPath": function () {
      this.updateLeftMenuActive();
    },
    LeftData: function () {
      this.updateLeftMenuActive();
    },
    playerPIPMode(val) {
      if (val) {
        $("body").addClass("pip");
        //$(".v-application").addClass("pip");
        //$(".player-dialog").closest(".v-dialog__content").addClass("pip");
        $(".player-dialog").addClass("pip");
        $(".player.pip .v-dialog__content").attr("draggable", "true");
        $(".player.pip .v-dialog__content").attr("id", "pipDialog");
        $("#ag-user-" + self.uid).addClass("me");
        //$("body").addClass("drag-container");
        if (self.callStarted) {
          bus.$emit("switchToTileView");
        }
        self.initPlayerPIPDragListener();
      } else {
        $("#pipDialog").removeAttr("draggable");
        $("#pipDialog").removeAttr("id");
        //$("body").removeClass("drag-container");
        //$(".player-dialog").closest(".v-dialog__content").removeClass("pip");
        $(".player-dialog").removeClass("pip");
        //$(".v-application").removeClass("pip");
        $("body").removeClass("pip");
        $("#ag-user-" + self.uid).removeClass("me");
      }
    },
    playerPIPMode1(val) {
      if (val) {
        $("body").addClass("pip");
        $(".player-dialog").addClass("pip");
        $(".player-dialog").attr("draggable", "true");
        $("#ag-user-" + self.uid).addClass("me");
        //$(".player.pip .v-dialog__content").attr("draggable","true");
        $(".player.pip .v-dialog__content").addClass("drag-container");
        // $(".player-dialog")
        //   .closest(".v-dialog__content")
        //   .addClass("drag-container");
        self.listenPlayerDragDrop();
      } else {
        $(".player-dialog").removeAttr("draggable", "true");
        $(".player.pip .v-dialog__content").removeClass("drag-container");
        $(".player-dialog").removeClass("pip");
        $("body").removeClass("pip");
        $("#ag-user-" + self.uid).removeClass("me");
        // $(".player-dialog")
        //   .closest(".v-dialog__content")
        //   .removeClass("drag-container");
      }
    },
    isDialing(val) {
      if (val) {
        //alert("start");
        if (self.dialingNotificationId && self.dialTimeRemaining > 0) {
          if (dialTimer) {
            clearInterval(dialTimer);
            dialTimer = null;
          }
          setTimeout(() => {
            let el = document.querySelector("#pushNotification");
            let audio = document.querySelector("audio");
            if (el && !audio) {
              audio = document.createElement("audio");
              audio.setAttribute("id", "ringAudio");
              audio.setAttribute("class", "ag-audio");
              audio.setAttribute("loop", "");
              audio.setAttribute("autoplay", "");
              audio.setAttribute(
                "src",
                "https://firebasestorage.googleapis.com/v0/b/e2monair.firebasestorage.app/o/OA_UAT%2FAudio%2Fring.mp3?alt=media"
              );
              el.appendChild(audio);
            }
            dialTimer = setInterval(function () {
              self.dialTimeRemaining--;
              if (self.dialTimeRemaining == 0) {
                // clearInterval(dialTimer);
                // dialTimer = null;
                self.isDialing = false;
                self.dialingNotificationId = "";
              }
            }, 1000);
          }, 100);
        }
      } else {
        //alert("stop");
        if (dialTimer) {
          clearInterval(dialTimer);
          dialTimer = null;
        }
        let audio = document.querySelector("audio");
        if (audio) {
          audio.parentNode.removeChild(audio);
        }
      }
    },
    hideEventHeaderAndMenu(val) {
      self.toggleMenuAndHeder(val);
    },
    locale() {
      this.$router.replace({ params: { lang: this.locale } }).catch(() => {});
    },
    IsSubscribed(val) {
      self.$store.commit("GetPopupNotification", val);
    },
    $route(to, from) {
      //self.screenInfoFlag = false;
      //alert(from);
      //alert(from.fullPath);
      //alert(from.name)
      self.showLobbyBubbleMenu = false;
      if (to.name == "Lobby" && self.event_collectionName) {
        self.showLobbyBubbleMenu = true;
      }
      if (self.playerDialog) {
        if (["LiveStage", "LiveStageNG", "StageView"].includes(to.name)) {
          router.push(from.fullPath);
          //self.showSnackbar(self.alreadyInACallMsg, "info", "top");
          if (from.fullPath != "/mainlobby/session_cal") {
            self.showSnackbar(self.alreadyInACallMsg, "info", "top");
          }
        }
      } else {
        self.displayScreenInfo = self.needToShowScreenInfo(
          to.name,
          to.fullPath
        );
        // if (self.verifySupportedDevice(to.name, to.fullPath)) {
        //   // if (from.name) {
        //   //   store.commit("setRouteName", from.name);
        //   // }
        //   //router.push("/screeninfo");
        // }
      }
      if (
        self.iPadLandscapePlayerSupport &&
        !["", "/", "ScreenInfo"].includes(to.name)
      ) {
        store.commit("setRouteName", to.fullPath);
      }

      document.body.scrollTop = document.documentElement.scrollTop = 0;

      this.currentRouteName = "";
      if (to.name) {
        this.currentRouteName = to.name;
      }
      // var isClientBanner = this.IsEventListPage;
      // self.desktopBanner = self.getDesktopBanner(isClientBanner);
      // self.mobileBanner = self.getMobleBanner(isClientBanner);
      // self.shareBanner = self.getSocialShareBanner(isClientBanner);
      this.SetBannerURL();
      this.ValidateUser();
      //alert(this.currentRouteName);
      self.enableTawk(to.name);
      console.log(from);
      console.log("to=========", to);
      console.log("from=========", from);
      if (to.fullPath == "/eventoverview/#cevent") {
        self.CreateEventPopup();
      }

      // alert(this.currentRouteName);

      // if (screen.width > 768) {
      //   self.alertScreenPotraitMsg = false;
      // } else {
      //   self.alertScreenPotraitMsg = true;
      // }
      if (
        [
          "Login",
          "Lobby",
          "EventList",
          "videoplayer",
          "Reg",
          "404",
          "OpenEvent",
          "ChangePass",
          "GeneratePass",
          "LiveStage",
          "SocialLoginRedrictPage",
        ].indexOf(to.name)
      ) {
        this.bodyWith = "width:100%";
      } else if (this.LeftData > 0) {
        self.getWidth();
        setTimeout(() => {
          self.getWidth();
        }, 3000);
      }
      // this.getWidth();
      //alert(to.name);

      if (to.name == "EventList") {
        this.$store.state.historyEvent = "";
      }

      //to.name == "ScreenInfo" ||
      if (
        to.name == "Login" ||
        to.name == "EventList" ||
        to.name == "ChangePass" ||
        to.name == "GeneratePass" ||
        to.name == "404" ||
        to.name == "OpenEvent" ||
        to.name == "JoinCMS" ||
        to.name == "Event" ||
        to.name == "Reg" ||
        to.name == "LoginExternal" ||
        to.name == "SocialLoginRedrictPage" ||
        to.name == "Eventv3" ||
        to.name == "Reg3" ||
        to.name == "PaymentStatus"
      ) {
        this.bodyWith = "width:100%";
        this.showChatComponent = false;
        this.setMetaInfos();
        // if (eventListener) {
        //   eventListener();
        //   eventListener = null;
        // }
      } else {
        if (!self.isVisitor()) {
          this.showChatComponent = true;
        }
        if (
          [
            "LiveStage",
            "LiveStageNG",
            // "Home",
            // "About",
            // "Programme",
            // "Partners",
            // "UpcomingEvents",
            // "YouthAmbassadors",
          ].includes(to.name)
        ) {
          this.showChatComponent = false;
        }
        if (
          self.currentRouteName == "StageView" &&
          !self.IsStageviewChatEanbled
        ) {
          this.showChatComponent = false;
        }

        if (to.name.includes("MainLobby")) {
          this.helpMenu = true;
          //this.popupBlockInfo = true;
          this.showChatComponent = false;
        }

        this.getTotalUnReadCounts();
        //this.fetchEventInfo();
        this.setMetaInfos();

        setTimeout(() => {
          bus.$emit("activeUsersList", self.onlineUserList);
        }, 5000);

        self.event_collectionName = this.$store.state.eventcollectionname;
        self.old_event_collectionName = this.$store.state.eventcollectionname;

        //self.AddEventAnalytics({ pageName: to.fullPath, action: "", actionType: "view", actionLabel: "" });
        var user = self.getSessionUserProfile();
        if (user) {
          let eventName = self.getEventName();
          analytics.AddUserView(
            self.event_collectionName,
            eventName,
            location.pathname,
            "",
            "view",
            "",
            user.UserId,
            user.Name,
            user.Email
          );
        }
        setTimeout(() => {
          self.getWidth();
        }, 3000);
      }

      if (self.$store.state.publicEventCollection) {
        self.publicEventCollection = self.$store.state.publicEventCollection;
      }

      var uid = self.getSessionUserId();
      if (
        [
          "Home",
          "HomeUAT",
          "About",
          "Programme",
          "Partners",
          "UpcomingEvents",
          "YouthAmbassadors",
        ].includes(to.name) &&
        (!uid ||
          !self.event_collectionName ||
          self.event_collectionName != self.publicEventCollection)
      ) {
        this.showChatComponent = false;
      }

      if (self.ShowEventMenu || self.ShowAdminEventMenu) {
        this.fetchEventInfo();

        if (eventListener) {
          self.getChatSettings();
        }
        if (this.currentRouteName) {
          var currenTimeStamp = "IsActive"; //new Date().getTime();
          var attachDisconnect = false;
          if (!this.previousRouteName) {
            attachDisconnect = true;
          }
          if (!this.pageLoadTimeStamp) {
            this.pageLoadTimeStamp = currenTimeStamp;
          }

          self.insertPageWiseUserPresence(
            this.currentRouteName,
            this.previousRouteName,
            true,
            this.pageLoadTimeStamp,
            this.pageLoadTimeStamp,
            attachDisconnect
          );
          this.previousRouteName = this.currentRouteName
            ? this.currentRouteName
            : "";

          self.getPageLvlUserPresence(this.currentRouteName);
        }
      } else {
        if (eventListener) {
          eventListener();
          eventListener = null;
          self.setMyPresence(true);
          if (userStatusDatabaseRef) {
            userStatusDatabaseRef.onDisconnect().cancel();
            userStatusDatabaseRef = null;
          }
        } else {
          firebase
            .database()
            .ref(self.event_collectionName)
            .child("Presence")
            .child(self.uid)
            .once("value", (snapshot) => {
              console.log("snap called=======");
              if (snapshot.exists()) {
                if (snapshot.val() < 0) {
                  firebase
                    .database()
                    .ref(self.event_collectionName + "/Presence")
                    .update({ [self.uid]: 0 })
                    .then(function () {
                      //alert("SUCCESS");
                      //self.event_collectionName = "";
                    });
                }
              }
            })
            .catch((error) => {
              console.error(error);
            });
        }
      }
      // if (["EventList","AdminOverview", "EventShowCase", "Events", "OpenEvent"].includes(to.name)){
      //   alert( "go to setMyPresence ");
      //   self.setMyPresence(true);
      // }
      if (!self.event_collectionName && self.publicEventCollection) {
        //self.getMenuDetails();
      }
      self.todaysDate = new Date().toISOString().slice(0, 10).replace(/-/g, "");
      self.validateAndShowVideoPlayer();
    },
    myLeaderboardScore(oldVal, newVal) {
      if (oldVal != newVal) {
        //self.myLBScoreChangeState = 2;
        //setTimeout(() => {
        //  self.myLBScoreChangeState = 1;
        //  setTimeout(() => {
        //    self.myLBScoreChangeState = 0;
        //  }, 1000);
        //}, 1000);
      }
    },
    "$store.state.EnableSelfService"(val) {
      if (val && val == true) {
        this.EnableSelfService = true;
      } else {
        this.EnableSelfService = false;
      }
    },
    "$store.state.eventid"(val) {
      console.log(val);
    },
    "$store.state.eventcollectionname"(val, oldVal) {
      //alert(oldVal + " to " + val);
      console.log(oldVal + " to " + val);
      var attendeeId = "";
      if (
        self.$store.state.eventcollectionname &&
        self.$store.state.user &&
        self.$store.state.user.length > 0 &&
        self.$store.state.user[0].id
      ) {
        attendeeId = self.$store.state.user[0].id;
      }
      self.uid = attendeeId;
      self.initAttendeeListener(val, attendeeId);
      self.displayNotification(val, attendeeId);
      self.getLeaderBoardSettings(val);
      self.eventId = self.getEventId();
      self.eventName = self.getEventName();
      self.ShareEvent = self.getCurrentEvent();
      self.GetAdminEventList();
    },
    "$store.state.publicEventCollection"(val) {
      self.publicEventCollection = val;
      //self.getMenuDetails();
    },
    isSpeaker(val) {
      if (val) {
        self.getMyAgendaCount();
      }
    },
    "$store.state.client"() {
      //alert("store.state.client")
      self.clientId = self.getClientId();
      //alert("store.state.client: "+self.clientId)
    },
    "$store.state.user"() {
      var attendeeId = "";
      if (
        self.$store.state.user &&
        self.$store.state.user.length > 0 &&
        self.$store.state.user[0].id
      ) {
        attendeeId = self.$store.state.user[0].id;
      }
      self.uid = attendeeId;
      self.checkUserLoggedInStatus(attendeeId);
    },
    currentRouteName(val) {
      self.paramEventId = "";
      if (val == "Eventv3" || val == "PaymentStatus") {
        if (this.$route.params.e) {
          self.paramEventId = this.$route.params.e;
        }
      }
    },
  },
  beforeCreate() {
    //self.toggleMenuAndHeder(true);
  },
  created() {
    self = this;
    const params = new URLSearchParams(window.location.search);
    const app = params.get("app");
    console.log(app); // "true"
    if (app == "true") {
      self.app = "true";
    }
    this.EnableSelfService = this.IsSelfServiceEnabled();
    //if (!self.getClientId()) {
    const HOSTURL = process.env.VUE_APP_LOCALHOST_URL_EDU;
    var hosturl;

    if (location.host.toLowerCase().indexOf("localhost") >= 0) {
      //self.extraTime = 10000000;
      hosturl = HOSTURL ? HOSTURL : self.LocalhostDomain();
    } else {
      hosturl = HOSTURL ? HOSTURL : location.host;
    }

    self.getBrandingJsonIfCloudfrontNotPresent(hosturl);
    //}
    if (self.$route.name) {
      self.currentRouteName = self.$route.name;
    }
    // else {
    //   self.currentRouteName = self.GetCurrentRouteNameByPath();
    // }
    if (this.updateLeftMenuActive) {
      this.updateLeftMenuActive();
    }
    self.googleclientId = APIs.googleSignInClientId;
    console.log("created---url==2===", location.host);
    self.isMobileView = self.isMobile();
    self.currentDomain = location.host;

    $(window).resize(function () {
      self.isMobileView = self.isMobile();
    });
    // alert(self.isMobileView);
    self.SetBannerURL();
    //self.toggleMenuAndHeder(self.hideEventHeaderAndMenu);
    if (this.$route) {
      self.enableTawk(self.$route.name);
    }
    this.$store.dispatch("changeLocale", this.$store.state.locale);
    this.allowWhatsapp = this.$t("client.allowWhatsapp");

    bus.$on("resetSelfServiceLeftMenu", () => {
      this.GetAdminEventList();
      this.selfServiceMenuKey += 1;
    });

    bus.$on("myProfileLeaderboardScore", (val) => {
      self.myLeaderboardScore = val;
    });
    bus.$on("EnableHelpChat", (routeName, clientId) => {
      self.enableTawk(routeName, clientId);
    });

    bus.$on("inititalVideoChat", (data) => {
      self.startVideoChat(data);
    });
    bus.$on("videoChatNoAnswer", (data) => {
      self.VideoChatNoAnswer(data);
      self.VideoChatMissed(data);
    });
    bus.$on("closeVideoChat", (roomId) => {
      self.closePlayerDialog(roomId);
    });
    bus.$on("openPlayerDialog", (data) => {
      self.openPlayerDialog(data);
    });
    bus.$on("switchToPIPView", () => {
      self.switchToPIPView();
    });

    bus.$on("openBasicSetup", () => {
      self.OpenBasicSetup();
    });

    bus.$on("openSigninPopup", () => {
      self.DisplaySignInPopup();
    });

    bus.$on("toggleLoader", (val) => {
      self.commonLoader = val;
    });
    bus.$on("toggleSelfServiceEventCreateLoader", (val) => {
      self.selfServiceLoader = val;
    });

    bus.$on("toggleTextLoader", (val) => {
      self.commonTextLoader = val;
    });

    bus.$on("chatResources", (data) => {
      self.chatFileType = data.type;
      self.chatFileUrl = data.url;
      self.clientName = data.clientName ? data.clientName : "";
      self.chatResourceDialog = true;
    });

    bus.$on("openRegistrationDialog", (eventId) => {
      self.eventId = eventId;
      self.eventName = self.getEventName();
      self.openRegDialog(eventId);
    });
    bus.$on("closeRegistrationDialog", () => {
      //alert("app");
      self.closeRegDialog();
      //self.$router.push("/");
      //self.clearstate();
      //location.reload();
    });

    bus.$on("clearState", (preventRedirection) => {
      self.clearstate(preventRedirection);
    });

    // bus.$on("LoadEventDetails", () => {
    //   self.LoadEvent();

    //   // const HOSTURL = process.env.VUE_APP_LOCALHOST_URL_EDU;
    //   // var hosturl;
    //   // if (location.host.toLowerCase().indexOf("localhost") >= 0) {
    //   //   hosturl = HOSTURL ? HOSTURL : self.LocalhostDomain();
    //   // } else {
    //   //   hosturl = HOSTURL ? HOSTURL : location.host;
    //   // }
    //   // self.getBrandingJsonIfCloudfrontNotPresent(hosturl);
    // });
    bus.$on("OpenCreateEvent", () => {
      self.CreateEventPopup();
    });
    bus.$on("SetGuestBannerURL", (eventBranding) => {
      self.SetGuestBannerURL(eventBranding);
    });
    bus.$on("ShowSocialShare", (shareEvent) => {
      self.ShowSocialShare(shareEvent);
    });
    bus.$on("changeEventStatusConfirm", () => {
      self.changeEventStatusConfirm();
    });
    bus.$on("goToPreviewPage", () => {
      var previewLink = self.PreviewOrEditLink;
      if (previewLink) {
        router.push(previewLink);
      }
    });
    bus.$on("openLoginRegDecision", (page_params) => {
      self.login_reg_page_params = page_params;
      self.loginRegDecision = true;
    });
    bus.$on("closeLoginRegDecision", () => {
      self.loginRegDecision = false;
      self.login_reg_page_params = null;
    });
    bus.$on("showProfileEditPopup", () => {
      self.editProfileKey++;
      self.showProfileEditPopup = true;
    });
    bus.$on("openSelfiePopup", (fileUpload) => {
      self.selfiePopup = true;
      self.selfiePopupWithFileUpload = fileUpload;
      self.toggleCamera();
    });
    bus.$on("readChatSettings", () => {
      self.getChatSettings();
    });
    bus.$on("enableHiddenChat", () => {
      self.enableHiddenChatComponent = true;
    });

    // bus.$on("setUserWelcomeLoader", (data) => {
    //   if (data.showUserWelcomeLoader) {
    //     self.userInitials = data.userInitials;
    //     self.userImage = data.userImage;
    //     self.userFirstName = data.userFirstName;
    //     //self.reLoginMessageFlg = data.reLoginMessageFlg;
    //     document.getElementById("overlay-test").style.display = "flex";
    //   } else if (data.reLoginMessageFlg) {
    //     self.reLoginMessageFlg = data.reLoginMessageFlg;
    //   } else {
    //     document.getElementById("overlay-test").style.display = "none";
    //   }
    // });

    setInterval(function () {
      self.correntTimeMS = parseInt(new Date().getTime() / 1000) * 1000;

      //console.clear();
      if (self.correntTimeMS % 60000 == 0) {
        //console.clear();
      }
    }, 1000);

    window.addEventListener("focus", function () {
      //  document.title = 'focused';
      self.insertPageWiseUserPresence(
        self.currentRouteName,
        "",
        true,
        self.pageLoadTimeStamp,
        ""
      );
    });

    window.addEventListener("blur", function () {
      //  document.title = 'not focused';
      self.insertPageWiseUserPresence(
        self.currentRouteName,
        "",
        false,
        self.pageLoadTimeStamp,
        ""
      );
    });
    window.addEventListener("mouseup", function (e) {
      var popup = $(".bubble-head-presence-details");
      if (
        !$(".attendee-presence").is(e.target) &&
        !popup.is(e.target) &&
        popup.has(e.target).length == 0
      ) {
        popup.hide();
        self.attendeeDetailsPopup = false;
      }
    });
  },
  updated() {
    self.onTopBannerLoad();
  },
  destroyed() {
    //window.removeEventListener("resize", this.BrowserSizeCheck);
  },
  mounted() {
    setTimeout(() => {
      // self.showVideoPlayer();
    }, 5000);
    //if (self.iPadLandscapePlayerSupport) {
    $(window).resize(function () {
      if (
        ["LiveStage", "LiveStageNG", "StageView"].includes(self.$route.name)
      ) {
        //self.verifySupportedDevice(self.$route.name, self.$route.fullPath);
        self.displayScreenInfo = self.needToShowScreenInfo(
          self.$route.name,
          self.$route.fullPath
        );
      }
    });
    //}
    //self.initPlayerPIPDragListener();

    // $(window).resize(function () {
    //   if ($(window).width() >= 768 && $(window).width() < 1024) {
    //   self.viewSnack=true;
    //   }
    //   else{
    //     self.viewSnack=false;
    //   }
    // });

    self.localTimeZone = common.getTimeZoneName();
    if (self.$route.name) {
      self.currentRouteName = self.$route.name;
    }
    if (location.host.toLowerCase().indexOf("localhost") == -1) {
      //this.pageLink = location.href;
      var eid = self.getEventId();
      if (eid) {
        self.pageLink = location.origin + "/eventv3/";
        self.ShareEvent = self.getCurrentEvent();
      }
      ///eventv3/E1639074934324
    }

    self.GetAdminEventList();
    let CookieAccessToken = this.getCookie("eduStudentToken");

    if (self.currentDomain == "campus.edulife.sg") {
      if (this.$store.state.token && this.$store.state.staySignedIn) {
        console.log("if rememer me");
      } else if (CookieAccessToken) {
        console.log("from edu life site");
      } else if (this.$route.query.teacherremakrs == "true") {
        location.href =
          "https://edulife.sg/?teacherremakrs=true&cid=" +
          this.$route.query.cid +
          "&eid=" +
          this.$route.query.eid +
          "&sid=" +
          this.$route.query.sid +
          '"';
      } else {
        if (this.$route.path == "/") {
          location.href = "https://edulife.sg";
        } else if (this.$route.path == "/admin") {
          console.log("show login>>>>>>>>>>>");
        }
      }
    }

    self.getChatSettings();
    self.InitAnalytics();
    if (this.$store.getters.getPreviewLoginFlag == true) {
      this.showPreviewLogin = true;
    } else {
      this.showPreviewLogin = false;
    }

    if (this.$store.state.DefaultLoginLandingPage == "/clientLobby") {
      if (this.$store.state.EventBranding[0].topBar) {
        this.topBannerColour = this.$store.state.EventBranding[0].topBar;
      }
      if (this.$store.state.EventBranding[0].fontBar) {
        $("#headerMenuParent").css(
          "color",
          this.$store.state.EventBranding[0].fontBar
        );
      }
      this.loadMenuClientLevel();
    }
    EventBus.$on(ACTIONS.SNACKBAR, ({ message, type, position }) => {
      if (message == "hide") {
        this.snackbar = false;
      } else {
        this.snackbarMessage = message;
        this.snackbar = true;
        this.snackBarType = type;
        this.position = position;
      }
    });
    // setTimeout(() => {
    //   var elmnt = document.getElementById("imgBanner");
    //   //alert("imgBanner:" + elmnt.clientHeight);
    //   var numericH = elmnt
    //     ? elmnt.clientHeight.toString().replace("px", "").trim()
    //     : "";
    //   $(":root").css("--banner-height", parseInt(numericH + "px"));
    // }, 5000);
    self.productVersion = document.querySelector(
      'meta[name="version"]'
    ).content;
    self.releaseNoteURL = URLs ? URLs.ReleaseNote : "";

    if (self.$store.state.eventcollectionname) {
      self.event_collectionName = self.$store.state.eventcollectionname;
    }
    if (self.$store.state.publicEventCollection) {
      self.publicEventCollection = self.$store.state.publicEventCollection;
    }
    if (
      self.$store.state.user &&
      self.$store.state.user.length > 0 &&
      self.$store.state.user[0].id
    ) {
      self.uid = self.$store.state.user[0].id;
    }

    if (self.currentRouteName && self.currentRouteName != "Login") {
      self.ValidateUser();
    }
    //self.LoadEvent();
    //self.getMenuDetails();

    store.commit("setNotification", self.showNotification);
    self.CheckSubscribitionForWebPush();
    //self.displayNotification();

    //*******************************Dont remove this..............................

    var elmnt1 = document.getElementById("imgBanner");
    console.log(elmnt1 && elmnt1.clientHeight ? elmnt1.clientHeight : "");
    try {
      if (versionListener) {
        versionListener();
      }
      versionListener = db
        .collection("OA_UAT")
        .doc("Version")
        .onSnapshot((doc) => {
          let versions = doc.data();
          if (!self.$store.state.version) {
            self.$store.commit("setVersion", versions.WebApp);
          } else {
            if (self.$store.state.version == versions.WebApp) {
              console.log("No versions Changed");
            } else {
              this.versionInfo = true;
              console.log("new Version = " + versions.WebApp);
              self.$store.commit("setVersion", versions.WebApp);
            }
          }
        });
    } catch (e) {
      console.log("No Version Data Found");
    }
    $(window).resize(function () {
      self.getWidth();
    });
    if (self.event_collectionName && self.uid) {
      self.initAttendeeListener(self.event_collectionName, self.uid);
      self.displayNotification(self.event_collectionName, self.uid);
    }
    if (self.event_collectionName) {
      self.getLeaderBoardSettings(self.event_collectionName);
    }
    if (self.uid) {
      self.checkUserLoggedInStatus(self.uid);
    }

    console.log("bulk progress>>>>>", self.$store.state.bulkUploadProgress);

    //     let listenerRef = ls.getSessionValueByKey("ProgressBarListenerLink");
    // let ImportRefreshLink = ls.getSessionValueByKey("ImportRefreshLink");
    // let ProgressbarMessage = ls.getSessionValueByKey("ProgressbarMessage");
    // if (listenerRef) {
    //   con.eventDB.doc(listenerRef).onSnapshot(function (doc) {
    //     let total_executed =
    //       Number(doc.data().Duplicate) +
    //       Number(doc.data().Success) +
    //       Number(doc.data().Failed);
    //     vm.ProgressBarPercent =
    //       (total_executed / Number(doc.data().Total)) * 100;
    //     vm.ShowProgressBar = true;
    //     vm.ProgressbarMessage = `${ProgressbarMessage} is in progress... ${total_executed}/${
    //       doc.data().Total
    //     } completed`;
    //     vm.ShowProgressBarMsg = true;
    //     if (total_executed == Number(doc.data().Total)) {
    //       ls.removeSessionValueByKey("ProgressbarMessage");
    //       ls.removeSessionValueByKey("ProgressBarListenerLink");
    //       ls.removeSessionValueByKey("ImportRefreshLink");
    //       vm.ShowProgressBar = false;
    //       vm.ProgressBarPercent = 0;
    //       vm.ProgressbarMessage = `${ProgressbarMessage} completed. <a href="javascript:location.href='/event/${ImportRefreshLink}'">View Now</a`;
    //     }
    //   });
    // }
    self.startBulkProgress();
    if (screen.height >= 680 && screen.height <= 768) {
      this.showLeftMenuBoxes = 3;
    } else if (screen.height >= 769 && screen.height <= 1000) {
      this.showLeftMenuBoxes = 4;
    } else if (screen.height >= 1001) {
      this.showLeftMenuBoxes = 5;
    }
  },
  methods: {
    isAuditoriumMenu(item) {
      const key = String(
        (item &&
          [
            item.MenuID,
            item.PageUrl,
            item.DisplayLabel,
            item.DisplayLabel_fr,
            item.DisplayLabel_zh,
            item.DisplayLabel_de,
            item.DisplayLabel_es,
          ]
            .filter(Boolean)
            .join(" ")) ||
          ""
      ).toLowerCase();
      return /\b1030\b|auditorium|live stage|stageview/.test(key);
    },
    getTopMenuIcon(item) {
      if (this.isAuditoriumMenu(item)) {
        return require("@/assets/Images/auditorium.svg");
      }
      return item.IconUrl;
    },
    getSideMenuIcon(item) {
      const key = String(
        (item && (item.PageUrl || item.DisplayLabel)) || ""
      ).toLowerCase();
      if (/attend|people|delegate|networking lounge/.test(key))
        return require("@/assets/Images/side-menu/people.svg");
      if (/resource|document|file|info|handout|brochure/.test(key))
        return require("@/assets/Images/side-menu/document.svg");
      if (/agenda|schedule|session|calendar|program/.test(key))
        return require("@/assets/Images/side-menu/calendar.svg");
      if (/meet|handshake|connect|appointment|1[-:]?1/.test(key))
        return require("@/assets/Images/side-menu/handshake.svg");
      return item && item.IconUrl ? item.IconUrl : "";
    },
    OpenOneToOneChat(AttendeeId, Name) {
      var roomList = [];
      var data = {};
      data.AttendeeId = AttendeeId;
      data.Name = Name;
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var loggedInUserId = obj.user[0].id;
      var listRef = db
        .collection(self.event_collectionName)
        .doc("group-chat")
        .collection("chat-rooms")
        .where("userIdList", "array-contains", loggedInUserId);
      listRef.get().then((querySnapshot) => {
        roomList = [];
        querySnapshot.forEach((doc) => {
          if (
            doc.data().userIdList &&
            doc.data().userIdList.length == 2 &&
            doc.data().userIdList.includes(data.AttendeeId)
          ) {
            roomList.push({
              roomId: doc.data().id,
              roomName: doc.data().name ? doc.data().name.trim() : "",
              createdBy: doc.data().createdByUserId,
              roomMembers: doc.data().userIdList,
              lastMessage: doc.data().lastMsg,
              createdDateTime: doc.data().createdDateTime.seconds,
              lastActiveTime: doc.data().lastActivityDtm.seconds,
              iconUrl: self.getCDNUrl(doc.data().iconUrl),
            });
          }
        });
        if (roomList.length > 0) {
          roomList.map((room) => {
            if (
              room.roomMembers.length == 2 &&
              room.roomMembers.includes(data.AttendeeId)
            ) {
              data.roomId = room.roomId;
              data.roomName = room.roomName;
              data.createdBy = room.createdBy;
              data.roomMembers = room.roomMembers;
              data.lastMessage = room.lastMessage;
              data.createdDateTime = room.createdDateTime;
              data.lastActiveTime = room.lastActiveTime;
              data.iconUrl = room.iconUrl;
              bus.$emit("toggleLoader", true);
              bus.$emit("openExpoIndividualChat", data);
            } else {
              bus.$emit("toggleLoader", true);
              bus.$emit("openExpoIndividualChat", data);
            }
          });
        } else {
          bus.$emit("toggleLoader", true);
          bus.$emit("openExpoIndividualChat", data);
        }
      });
    },
    showAttendeePopup(attendeeData, index) {
      console.log(attendeeData);
      if (index == 0) {
        self.leftPresenceBubble = 2;
      } else if (index >= 1) {
        self.leftPresenceBubble = 2;
        self.leftPresenceBubble = self.leftPresenceBubble + 30 * index;
      }

      self.selectedAttendeeName = attendeeData.name;
      self.selectedAttendeeId = attendeeData.id;
      self.selectedAttendeeTitle = attendeeData.title;
      self.selectedAttendeeCompany = attendeeData.company;
      self.attendeeDetailsPopup = true;
    },
    openChatPannelWithPresence() {
      $("#notification").modal("hide");

      if (self.isChatAndAttendeeTogglePresent) {
        setTimeout(() => {
          bus.$emit("openChatViewMore");
        }, 700);
      } else {
        if (self.defaultRoomIdForChat) {
          bus.$emit("openPredefinedChat", self.defaultRoomIdForChat);
        }
      }
    },
    getPageLvlUserPresence(pageName) {
      self.livePeopleText = true;
      var firstLoad = true;

      // if (attendeePagePresenceListner) {
      //   attendeePagePresenceListner.onDisconnect().cancel();
      //   attendeePagePresenceListner = null;

      // }

      setTimeout(() => {
        $(".presence-fade-out").addClass("fadeout-text1");
        //self.livePeopleText = true
        // setTimeout(() => {
        //
        // }, 1000);
      }, 5000);

      firebase
        .database()
        .ref(self.$store.state.eventcollectionname)
        .child("pages")
        .on("value", (snapshot) => {
          if (snapshot.exists()) {
            const presencedata = snapshot.val();
            self.onlineAttendeeList = [];
            for (var page in presencedata) {
              if (page == pageName) {
                var userCounter = self.attendeeHeadList.length;
                self.attendeeHeadList = [];
                self.allOnlineAttendeeHeadList = [];
                var value = presencedata[page];

                for (var attendees in value) {
                  if (value[attendees].presence) {
                    if (!self.attendeeHeadList.includes(attendees)) {
                      if (self.uid != attendees) {
                        value[attendees].profile.NameInitial =
                          common.getInitials(value[attendees].profile.name);
                        value[attendees].profile.IsPopUpOpen = false;

                        self.allOnlineAttendeeHeadList.push(
                          value[attendees].profile
                        );
                        self.attendeeHeadList.push(attendees);
                      }
                    }
                  }
                }
              }

              var value1 = presencedata[page];

              for (var attendees1 in value1) {
                if (value1[attendees1].presence) {
                  if (!self.onlineAttendeeList.includes(attendees1)) {
                    if (self.uid != attendees1) {
                      self.onlineAttendeeList.push(attendees);
                    }
                  }
                }
              }
            }
            if (userCounter > self.attendeeHeadList.length && !firstLoad) {
              //  alert("insideeeeeeeeee")

              self.newAttendeePresenceFound = true;
              setTimeout(() => {
                self.newAttendeePresenceFound = false;
              }, 5000);
            }

            if (firstLoad) {
              firstLoad = false;
            }

            // if(data[pageName] == pageName){
            //   console.log("match if>>>>>");
            //    console.log("match if>>>>>",data);
            // }

            // for (var attendee in data) {
            //   data[attendee].profile.NameInitial = common.getInitials(
            //     data[attendee].profile.name
            //   );
            //   if(attendee && !self.attendeeHeadList.includes(attendee)){

            //     console.log("pushed>>>>",data[attendee].profile);
            //     self.attendeeHeadList.push(attendee);
            //   }
            // }
          } else {
            console.log("presence else");
          }
        });
    },
    setMeta() {
      $("meta[name='twitter:image']").attr(
        "content",
        self.$store.getters.getSocialShareImage
      );
      $("meta[property='og:image']").attr(
        "content",
        self.$store.getters.getSocialShareImage
      );
      $("meta[itemprop='image']").attr(
        "content",
        self.$store.getters.getSocialShareImage
      );
      $("meta[property='og:url']").attr("content", location.host);
      if (
        self.$store.getters.getClient &&
        self.$store.getters.getClient.length > 0
      ) {
        $("meta[name='description']").attr(
          "content",
          self.$store.getters.getClient[0].name
        );
        $("meta[name='keywords']").attr(
          "content",
          self.$store.getters.getClient[0].name
        );
        $("meta[itemprop='name']").attr(
          "content",
          self.$store.getters.getClient[0].name
        );
        $("meta[itemprop='description']").attr(
          "content",
          self.$store.getters.getClient[0].name
        );
        $("meta[property='og:title']").attr(
          "content",
          self.$store.getters.getClient[0].name
        );
        $("meta[property='og:description']").attr(
          "content",
          self.$store.getters.getClient[0].name
        );
        $("meta[name='twitter:title']").attr(
          "content",
          self.$store.getters.getClient[0].name
        );
        $("meta[name='twitter:description']").attr(
          "content",
          self.$store.getters.getClient[0].name
        );
      }
    },
    uploadChatFiles(e) {
      self.isCameraOpen = true;
      self.selfiePopup = null;
      self.toggleCamera();
      self.takeSnapBtn = true;
      bus.$emit("uploadChatFiles", e);
    },
    onTopBannerLoad() {
      // Measure the full rendered header (#divHeader = v-app-bar) so
      // --banner-height reflects whatever the header currently contains:
      // banner image + head-top-wrap navigation row + v-toolbar extension.
      // Falls back to the legacy banner + divBannerTop sum if the app-bar
      // is not yet rendered (e.g. pages where ShowTopBar is false).
      var bannerHeight = 0;
      var header = document.getElementById("divHeader");
      if (header && header.offsetHeight > 0) {
        bannerHeight = header.offsetHeight;
      } else {
        var obj = document.getElementById("routerlnkBanner");
        if (obj) bannerHeight += obj.offsetHeight;
        obj = document.getElementById("divBannerTop");
        if (obj) bannerHeight += obj.offsetHeight;
      }

      if (bannerHeight > 0) {
        $(":root").css("--banner-height", bannerHeight + "px");
      } else {
        $(":root").css("--banner-height", "0px");
      }

      // Observe header size changes so the body container offset stays
      // in sync when the banner / nav row reflow on viewport resize or
      // dynamic content swap (e.g. banner image loading later).
      if (header && !self._headerResizeObserver && window.ResizeObserver) {
        try {
          self._headerResizeObserver = new ResizeObserver(() => {
            var h = header.offsetHeight;
            if (h > 0) $(":root").css("--banner-height", h + "px");
          });
          self._headerResizeObserver.observe(header);
        } catch (e) {
          // ResizeObserver not available - rely on Vue updated() hook.
        }
      }
    },
    initPlayerPIPDragListener() {
      var pipLeft = screen.width - 348;
      var pipTop = screen.height - 273 - 102;
      self.pipLeft = pipLeft;
      self.pipTop = pipTop;
      $(":root").css("--player-left", pipLeft + "px");
      $(":root").css("--player-top", pipTop + "px");

      var dm = document.getElementById("pipDialog");
      dm.addEventListener("dragstart", self.playerPIPDragStart, false);
      document.body.addEventListener("dragover", self.playerPIPDragOver, false);
      document.body.addEventListener("drop", self.playerPIPDragDrop, false);
    },
    playerPIPDragStart(event) {
      console.log("playerPIPDragStart");
      var style = window.getComputedStyle(event.target, null);
      self.offset_data =
        parseInt(style.getPropertyValue("left"), 10) -
        event.clientX +
        "," +
        (parseInt(style.getPropertyValue("top"), 10) - event.clientY);
      event.dataTransfer.setData("text/plain", self.offset_data);

      $(".player.pip .v-overlay").addClass("over");
      $(".player.pip .v-dialog__content").addClass("over");
      $(".player.pip .v-overlay.v-overlay--active").addClass("over");
    },
    playerPIPDragOver(event) {
      console.log("playerPIPDragOver");
      var offset;
      try {
        offset = event.dataTransfer.getData("text/plain").split(",");
      } catch (e) {
        //return;
        offset = self.offset_data.split(",");
      }
      //var dm = document.getElementById('pipDialog');
      // dm.style.left = (event.clientX + parseInt(offset[0],10)) + 'px';
      // dm.style.top = (event.clientY + parseInt(offset[1],10)) + 'px';
      // var flag = false;
      // if (!flag) {
      //   $(":root").css("--player-left", (event.clientX + parseInt(offset[0],10)) + 'px');
      //   $(":root").css("--player-top", (event.clientY + parseInt(offset[1],10)) + 'px');
      //   return;
      // }
      var pipLeft = event.clientX + parseInt(offset[0], 10);
      var pipTop = event.clientY + parseInt(offset[1], 10);

      if (isNaN(pipLeft)) {
        pipLeft = self.pipLeft;
      }
      if (isNaN(pipTop)) {
        pipTop = self.pipTop;
      }

      if (isNaN(pipLeft) || isNaN(pipTop)) {
        //alert(pipLeft);
        return;
      }

      if (pipLeft > screen.width - 348) {
        pipLeft = screen.width - 348;
      } else if (pipLeft < 80) {
        pipLeft = 80;
      }
      if (pipTop > screen.height - 273 - 102) {
        pipTop = screen.height - 273 - 102;
      } else if (pipTop < 102) {
        pipTop = 102;
      }
      self.pipLeft = pipLeft;
      self.pipTop = pipTop;
      $(":root").css("--player-left", parseInt(pipLeft) + "px");
      $(":root").css("--player-top", parseInt(pipTop) + "px");

      $(".player.pip .v-overlay.v-overlay--active").removeClass("over");
      $(".player.pip .v-dialog__content").removeClass("over");
      $(".player.pip .v-overlay").removeClass("over");

      event.preventDefault();
      return false;
    },
    playerPIPDragDrop(event) {
      console.log("playerPIPDragDrop");
      var offset;
      try {
        offset = event.dataTransfer.getData("text/plain").split(",");
      } catch (e) {
        //return;
        offset = self.offset_data.split(",");
      }
      //var dm = document.getElementById('pipDialog');
      // dm.style.left = (event.clientX + parseInt(offset[0],10)) + 'px';
      // dm.style.top = (event.clientY + parseInt(offset[1],10)) + 'px';
      // var flag = false;
      // if (!flag) {
      //   $(":root").css("--player-left", (event.clientX + parseInt(offset[0],10)) + 'px');
      //   $(":root").css("--player-top", (event.clientY + parseInt(offset[1],10)) + 'px');
      //   return;
      // }

      var pipLeft = event.clientX + parseInt(offset[0], 10);
      var pipTop = event.clientY + parseInt(offset[1], 10);
      if (isNaN(pipLeft)) {
        pipLeft = self.pipLeft;
      }
      if (isNaN(pipTop)) {
        pipTop = self.pipTop;
      }

      if (isNaN(pipLeft) || isNaN(pipTop)) {
        //alert(pipLeft);
        return;
      }

      if (pipLeft > screen.width - 348) {
        pipLeft = screen.width - 348;
      } else if (pipLeft < 80) {
        pipLeft = 80;
      }
      if (pipTop > screen.height - 273 - 102) {
        pipTop = screen.height - 273 - 102;
      } else if (pipTop < 102) {
        pipTop = 102;
      }
      self.pipLeft = pipLeft;
      self.pipTop = pipTop;

      $(":root").css("--player-left", parseInt(pipLeft) + "px");
      $(":root").css("--player-top", parseInt(pipTop) + "px");

      $(".player.pip .v-overlay.v-overlay--active").removeClass("over");
      $(".player.pip .v-dialog__content").removeClass("over");
      $(".player.pip .v-overlay").removeClass("over");

      event.preventDefault();
      return false;
    },

    startPhotoCountDown() {
      self.showTimer = true;

      setTimeout(() => {
        self.showTimer = false;
        self.takePhoto();
        self.takeSnapBtn = false;
      }, 3000);
    },
    toggleCamera() {
      if (this.isCameraOpen) {
        this.isCameraOpen = false;
        this.isPhotoTaken = false;
        this.isShotPhoto = false;
        this.stopCameraStream();
      } else {
        this.isCameraOpen = true;
        this.createCameraElement();
      }
    },

    createCameraElement() {
      this.isLoading = true;

      const constraints = (window.constraints = {
        audio: false,
        video: true,
        //  width: { exact: 200 },
        //  height: { exact: 200 }
      });

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          this.snapSelfieBtn = true;
          this.isLoading = false;
          this.$refs.camera.srcObject = stream;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
          this.snapSelfieBtn = false;
          alert(
            "May be there is a permission issue or you don't have a camera."
          );
        });
    },

    stopCameraStream() {
      if (this.$refs.camera.srcObject) {
        let tracks = this.$refs.camera.srcObject.getTracks();

        tracks.forEach((track) => {
          track.stop();
        });
      }
    },

    takePhoto() {
      if (!this.isPhotoTaken) {
        this.isShotPhoto = true;

        const FLASH_TIMEOUT = 50;

        setTimeout(() => {
          this.isShotPhoto = false;
        }, FLASH_TIMEOUT);
      }

      this.isPhotoTaken = !this.isPhotoTaken;

      const context = this.$refs.canvas.getContext("2d");

      console.log("context>>>>>>", context);
      console.log("camera>>>>>>", this.$refs.camera);

      context.drawImage(this.$refs.camera, 0, 0, 300, 225);
    },

    downloadImage() {
      // const download = document.getElementById("downloadPhoto");

      const canvas = document
        .getElementById("photoTaken")
        .toDataURL("image/png");

      const blob = b64toBlob(canvas.split(",")[1], "image/png");
      const blobUrl = URL.createObjectURL(blob);
      self.isCameraOpen = true;
      self.selfiePopup = null;
      self.toggleCamera();
      self.takeSnapBtn = true;
      bus.$emit("sendSelfieImage", blob, blobUrl);

      //download.setAttribute("href", canvas);
    },

    loadImage() {
      $("#userInitials").hide();
      $("#user-profile-img").removeClass("d-none");
    },

    selfServiceuserLogin() {
      $("#SignUpModal").modal("hide");
      $("#AdminLoginModalCenter").modal("hide");
      self.FirebaseLoginWithAuthCommon(
        self.selfServiceLoginEmailId,
        self.selfServiceLoginPassword
      );
    },
    closeLoginPopup() {
      $("#AdminLoginModalCenter").modal("hide");
    },
    sendToForgotPassword() {
      router.push("/#recoverpass");
    },
    sendBulkInviteMail() {
      console.log("mail>>>>>>", self.invitedAttendees);

      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${self.getSessionToken()}`,
      };

      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: self.$store.state.client[0].id,
          eventId: self.$store.state.eventid,
        },
        data: self.invitedAttendees,
      };

      axios
        .post(APIs.SendInviteeBulkMail, requestData, { headers: headers })
        .then(function (res) {
          if (res.data.status == 0) {
            console.log("res-----", res);
            // if (res.data.rows.length > 0) {
            //   //res.data.rows.isChecked = false;

            //   self.invitedAttendees = res.data.rows;
            // }
            // if (self.invitedAttendees.length > 0) {
            //   self.invitedAttendees.map((invitee) => {
            //     invitee.isChecked = false;
            //   });
            // }
          }
        })
        .catch(() => {
          console.log("error");
        });
    },
    openBulkUploadPopup() {
      self.invitationFileUploadDialog = true;
      self.resetBulkUploadComponent += 1;
    },
    startBulkProgress() {
      let listenerRef =
        store.getters.getBlukUploadProgress.ProgressBarListenerLink;
      let ImportRefreshLink =
        store.getters.getBlukUploadProgress.ImportRefreshLink;

      let ProgressbarMessage =
        store.getters.getBlukUploadProgress.ProgressbarMessage;

      if (listenerRef) {
        db.doc(listenerRef).onSnapshot(function (doc) {
          let total_executed =
            Number(doc.data().Duplicate) +
            Number(doc.data().Success) +
            Number(doc.data().Failed);

          self.ProgressBarPercent =
            (total_executed / Number(doc.data().Total)) * 100;
          self.showBulkUploadProgress = true;
          self.ProgressbarMessage = `${ProgressbarMessage} is in progress... ${total_executed}/${
            doc.data().Total
          } completed`;
          self.ShowProgressBarMsg = true;

          if (total_executed == Number(doc.data().Total)) {
            store.commit("setBulkUploadProgress", {});

            self.showBulkUploadProgress = false;
            self.ProgressBarPercent = 0;
            self.ProgressbarMessage = `${ProgressbarMessage} completed. <a href="javascript:location.href='/event/${ImportRefreshLink}'">View Now</a`;
            location.reload();
          }
        });
      }
    },
    ShowMobilePreview() {
      self.mobilePreviewVisible = true;
      self.mobilePreviewKey++;

      $("#mobile-preview").slideToggle();
    },
    HideMobilePreview() {
      self.mobilePreviewVisible = false;
      $("#mobile-preview").hide();
    },
    ShowSocialShare(shareEvent) {
      if (shareEvent) {
        self.ShareEvent = shareEvent;
      } else {
        self.ShareEvent = self.getCurrentEvent();
      }
      if (self.ShareEvent) {
        self.pageLink = location.origin + "/eventv3/" + self.ShareEvent.EventId;
        // self.eventId = eventId;
        // self.eventName = self.getEventName();
      }
      self.eventName = self.getEventName();
      $("#social-share").slideToggle();
    },
    HideSocialShare() {
      $("#social-share").hide();
    },
    sendToLogin() {
      $("#AdminLoginModalCenter").modal("show");
      // $("#SignUpModal").modal("hide");
      // router.push({ name: "Login" });
    },
    copyLinkRegistration() {
      var ct = document.getElementById("publishedreglink");
      ct.select();
      ct.setSelectionRange(0, 99999);
      document.getElementById("custom-tooltip-reg").style.display = "inline";
      document.execCommand("copy");
      setTimeout(function () {
        document.getElementById("custom-tooltip-reg").style.display = "none";
      }, 1000);
    },
    openInviteDialog() {
      self.inviteUserDialog = true;

      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${self.getSessionToken()}`,
      };

      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: self.$store.state.client[0].id,
          eventId: self.$store.state.eventid,
        },
        data: self.regFormConfig,
      };

      axios
        .post(APIs.GetAllInvitees, requestData, { headers: headers })
        .then(function (res) {
          if (res.data.status == 0) {
            console.log("res-----", res);
            if (res.data.rows.length > 0) {
              //res.data.rows.isChecked = false;

              self.invitedAttendees = res.data.rows;
            }
            if (self.invitedAttendees.length > 0) {
              self.invitedAttendees.map((invitee) => {
                invitee.isChecked = false;
              });
            }
          }
        })
        .catch(() => {
          console.log("error");
        });
    },
    changeEventStatusConfirm() {
      self.EventIsPublished = !self.CurrentAdminEvent.IsPublished;
      self.showPublishConfirmDialog = true;
    },
    cancelEventStatusConfirm() {
      self.EventIsPublished = self.CurrentAdminEvent.IsPublished;
      self.showPublishConfirmDialog = false;
    },
    changeEventStatus() {
      //API CALL
      //if success
      self.showPublishConfirmDialog = false;
      bus.$emit("toggleLoader", true);

      if (self.CurrentAdminEvent) {
        let dataObj = new Object();
        dataObj.IsPublished = !self.CurrentAdminEvent.IsPublished;
        let headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${self.getSessionToken()}`,
        };
        let requestData = {
          key: {
            instanceId: "OA_UAT",
            clientId: self.CurrentAdminEvent.ClientId,
            eventId: self.CurrentAdminEvent.EventId,
          },
          data: dataObj,
        };
        axios
          .post(APIs.SaveEventAPI, requestData, { headers: headers })
          .then(function (res) {
            bus.$emit("toggleLoader", false);
            if (res.data.status == 200) {
              self.CurrentAdminEvent.IsPublished = dataObj.IsPublished;
              self.EventIsPublished = dataObj.IsPublished;

              let currentEvent = self.$store.state.historyEvent;
              currentEvent.IsPublished = dataObj.IsPublished;
              self.$store.state.historyEvent = currentEvent;

              let events = store.getters.getMappedEvent;
              for (var i = 0; i < events.length; i++) {
                if (events[i].EventId == self.CurrentAdminEvent.EventId) {
                  events[i].IsPublished = dataObj.IsPublished;
                  break;
                }
              }
              store.commit("setMappedEvent", events);

              self.showSnackbar("Data updated", "success", "top");
              self.setBrandingJson([
                { key: "EventInfo", obj: dataObj },
                //{ key: "HostInfo", obj: HostInfo },
              ]);
              if (dataObj.IsPublished) {
                self.openPublishDialog();
              } else {
                self.closePublishDialog();
              }
            } else {
              self.showSnackbar("Data not updated!", "error", "top");
            }
          })
          .catch(() => {
            bus.$emit("toggleLoader", false);
            self.showSnackbar("Something went wrong!", "error", "top");
          });
      }
    },
    setBrandingJson(mainKey, subKeyValObj = null) {
      let dataArr = [];
      if (Array.isArray(mainKey)) {
        for (let item of mainKey) {
          dataArr.push({
            mainKey: item.key,
            subKeys: Object.keys(item.obj),
            subKeyValObj: item.obj,
          });
        }
      } else {
        let subKeys = Object.keys(subKeyValObj);
        dataArr.push({
          mainKey: mainKey,
          subKeys: subKeys,
          subKeyValObj: subKeyValObj,
        });
      }
      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${self.getSessionToken()}`,
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: self.clientId,
          eventId: self.eventId,
        },
        data: dataArr,
      };
      axios.post(APIs.SaveEventBrandingJson, requestData, { headers: headers });
    },
    openPublishDialog() {
      self.showPublishSuccessDialog = true;
      $("#EventPublishModalCenter").modal("show");
    },
    closePublishDialog() {
      self.showPublishSuccessDialog = false;
      $("#EventPublishModalCenter").modal("hide");
    },
    onSaveBannerSuccess() {
      self.bannerDialog = false;
    },
    CancelBannerUpload() {
      self.bannerDialog = false;
    },
    OpenBasicSetup() {
      router.push({ name: "EventSetup" });
      // self.eventSetupBasicDialog = true;
      // self.eventSetupBasicKey++;
      // $("#EventSetupBasic").modal("show");
    },
    CloseBasicSetup() {
      self.eventSetupBasicDialog = false;
      self.eventSetupBasicKey++;
      $("#EventSetupBasic").modal("hide");
    },
    OnUpdateBasicSetupSuccess() {
      self.CloseBasicSetup();
    },
    OnCancelBasicSetupSuccess() {
      self.CloseBasicSetup();
    },
    OpenManageMenu() {
      self.eventSetupMenuDialog = true;
      self.eventSetupMenuKey++;
      $("#EventSetupMenu").modal("show");
    },
    CloseManageMenu() {
      self.eventSetupMenuDialog = false;
      self.eventSetupMenuKey++;
      $("#EventSetupMenu").modal("hide");
    },
    OnUpdateManageMenuSuccess() {
      self.CloseManageMenu();
    },
    OnCancelManageMenuSuccess() {
      self.CloseManageMenu();
    },
    OpenMyUserProfile() {
      this.MyUserProfileKey += 1;
      $("#MyUserProfile").modal("show");
    },
    OpenChangeBanner() {
      //alert(self.clientId);
      self.clientId = self.getClientId();
      this.bannerDialogKey += 1;
      this.bannerDialog = true;
      var all = document.getElementsByClassName(".v-dialog__content");
      for (var i = 0; i < all.length; i++) {
        all[i].style.zIndex = "9999999 !important";
      }
    },
    onTopBannerFileChange(e) {
      var incomplete = true;
      if (incomplete) {
        return;
      }
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      self.topBannerUploading = true;
      for (var i = 0; i < files.length; i++) {
        var file = files[i];
        var metadata = {
          contentType: file.type,
        };

        const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          // invalid file type code goes here.
          //alert("Only gif,jpeg & png file allowed.");
          self.showSnackbar(
            "Only gif,jpeg & png file allowed.",
            "error",
            "top"
          );
          self.topBannerUploading = false;
          return false;
        }

        firebase
          .storage()
          .ref()
          .child(
            self.eventcollectionname +
              "/Stage/" +
              file.name +
              "_" +
              new Date().getTime()
          )
          .put(file, metadata)
          .then(function (snapshot) {
            snapshot.ref
              .getDownloadURL()
              .then(function (imgURL) {
                self.topBannerUploading = false;
                self.desktopBanner = imgURL;
                //self.SaveStageViewSettings(1);
              })
              .then(() => {
                self.topBannerUploading = false;
                //alert("Successfully updated the record");
                self.showSnackbar(
                  "Banner uploaded successfully.",
                  "info",
                  "top"
                );
              })
              .catch((error) => {
                self.topBannerUploading = false;
                // console.error(
                //   "There was an error editing the record: " + error
                // );
                self.showSnackbar(
                  "There was an error uploading banner: " + error,
                  "error",
                  "top"
                );
              });
          })
          .catch(function (error) {
            self.topBannerUploading = false;
            self.showSnackbar("Upload failed: " + error, "error", "top");
          });
      }
    },
    OpenAdminEventsPopup() {
      $("#adminEventsPopup").modal("show");
    },
    GetCurrentRouteNameByPath() {
      var routs = [];
      this.$router.options.routes.forEach((route) => {
        if (route.meta && route.meta.isAdminPage) {
          routs.push({
            name: route.name,
            path: route.path,
          });
        }
      });
      //alert(routs.length);
      return routs.name;
    },
    OnFacebookAuthSuccess(idToken) {
      // Receive the idToken and make your magic with the backend

      self.registerUserForEventAdminSocialSignups(
        idToken.accessToken,
        "Facebook"
      );
    },
    OnFacebookAuthFail(error) {
      console.log(error);
    },
    OnChangeCurrentEvent(AdminEvent) {
      $("#adminEventsPopup").modal("hide");
      self.CurrentAdminEvent = AdminEvent;
      self.ChangeCurrentEvent(AdminEvent.ClientId, AdminEvent.EventId, true);
    },
    setMetaInfos() {
      try {
        if (self.$store.state.eventcollectionname) {
          if (this.eventDetails) {
            if (document.querySelector('meta[name="twitter:image"]')) {
              document
                .querySelector('meta[name="twitter:image"]')
                .setAttribute(
                  "content",
                  this.eventDetails.EventBannerShare
                    ? this.eventDetails.EventBannerShare
                    : ""
                );
            }

            // if (document.querySelector('meta[property="og:image"]')) {
            //   document
            //     .querySelector('meta[property="og:image"]')
            //     .setAttribute(
            //       "content",
            //       this.eventDetails.EventBannerShare
            //         ? this.eventDetails.EventBannerShare
            //         : ""
            //     );
            // }
            if (document.querySelector('meta[name="title"]')) {
              document
                .querySelector('meta[name="title"]')
                .setAttribute(
                  "content",
                  this.eventDetails.EventFullName
                    ? this.eventDetails.EventFullName
                    : ""
                );
            }
            if (document.querySelector('meta[name="description"]')) {
              document
                .querySelector('meta[name="description"]')
                .setAttribute(
                  "content",
                  this.eventDetails.Description
                    ? this.eventDetails.Description
                    : ""
                );
            }

            if (document.querySelector('meta[name="keywords"]')) {
              document
                .querySelector('meta[name="keywords"]')
                .setAttribute(
                  "content",
                  this.eventDetails.EventShortName
                    ? this.eventDetails.EventShortName
                    : ""
                );
            }

            if (document.querySelector('meta[name="twitter:site"]')) {
              document
                .querySelector('meta[name="twitter:site"]')
                .setAttribute("content", location.host ? location.host : "");
            }

            if (document.querySelector('meta[name="twitter:title"]')) {
              document
                .querySelector('meta[name="twitter:title"]')
                .setAttribute(
                  "content",
                  this.eventDetails.EventFullName
                    ? this.eventDetails.EventFullName
                    : ""
                );
            }

            if (document.querySelector('meta[name="twitter:description"]')) {
              document
                .querySelector('meta[name="twitter:description"]')
                .setAttribute(
                  "content",
                  this.eventDetails.Description
                    ? this.eventDetails.Description
                    : ""
                );
            }

            if (document.querySelector('meta[property="og:site_name"]')) {
              document
                .querySelector('meta[property="og:site_name"]')
                .setAttribute(
                  "content",
                  this.eventDetails.EventFullName
                    ? this.eventDetails.EventFullName
                    : ""
                );
            }

            if (document.querySelector('meta[property="og:title"]')) {
              document
                .querySelector('meta[property="og:title"]')
                .setAttribute(
                  "content",
                  this.eventDetails.EventFullName
                    ? this.eventDetails.EventFullName
                    : ""
                );
            }

            if (document.querySelector('meta[property="og:description"]')) {
              document
                .querySelector('meta[property="og:description"]')
                .setAttribute(
                  "content",
                  this.eventDetails.Description
                    ? this.eventDetails.Description
                    : ""
                );
            }

            // if (document.querySelector('meta[name="og:image"]')) {
            //   document
            //     .querySelector('meta[name="og:image"]')
            //     .setAttribute("content", this.eventDetails.Description?this.eventDetails.Description:"");
            // }
          }

          if (document.querySelector('meta[property="og:url"]')) {
            document
              .querySelector('meta[property="og:url"]')
              .setAttribute("content", location.host);
          }
        } else {
          console.log("social else", this.$store.getters.getSocialShareImage);
          if (
            this.$store.getters.getClient &&
            this.$store.getters.getClient.length > 0 &&
            this.$store.getters.getClient[0].name
          ) {
            document
              .querySelector('meta[name="title"]')
              .setAttribute("content", this.$store.getters.getClient[0].name);
            document
              .querySelector('meta[name="description"]')
              .setAttribute("content", this.$store.getters.getClient[0].name);
            document
              .querySelector('meta[name="keywords"]')
              .setAttribute("content", this.$store.getters.getClient[0].name);

            document
              .querySelector('meta[name="twitter:site"]')
              .setAttribute("content", location.host);
            document
              .querySelector('meta[name="twitter:title"]')
              .setAttribute("content", this.$store.getters.getClient[0].name);
            document
              .querySelector('meta[name="twitter:description"]')
              .setAttribute("content", this.$store.getters.getClient[0].name);

            document
              .querySelector('meta[property="og:site_name"]')
              .setAttribute("content", this.$store.getters.getClient[0].name);

            document
              .querySelector('meta[property="og:title"]')
              .setAttribute("content", this.$store.getters.getClient[0].name);

            document
              .querySelector('meta[property="og:description"]')
              .setAttribute("content", this.$store.getters.getClient[0].name);

            document
              .querySelector('meta[property="og:url"]')
              .setAttribute("content", location.host);

            // $("meta[property='twitter:image']").attr(
            //   "content",
            //   "https://firebasestorage.googleapis.com/v0/b/e2monair.firebasestorage.app/o/OA_UAT_C1647457916091E1647459328886%2FBranding%2F1200x628_1648047221285.png?alt=media&token=11736efa-9e11-4a97-bc35-34934e788d43"
            // );
            // document
            // .querySelector("meta[name='twitter:image']")
            // .setAttribute(
            //   "content",
            //   this.$store.getters.getSocialShareImage
            // );

            // if (document.querySelector('meta[name="twitter:image"]')) {
            //   document
            //     .querySelector('meta[name="twitter:image"]')
            //     .setAttribute(
            //       "content",
            //       this.$store.getters.getSocialShareImage
            //     );
            // }

            // if (document.querySelector('meta[name="og:image"]')) {
            //   document
            //     .querySelector('meta[name="og:image"]')
            //     .setAttribute(
            //       "content",
            //       this.$store.getters.getSocialShareImage
            //         ? this.$store.getters.getSocialShareImage
            //         : ""
            //     );
            // }
          }
        }
      } catch (e) {
        console.log("No Version Data Found");
      }
    },
    getMenuUrl(menuId, url) {
      var result = url;
      var filterMenu = routeConfig.PreviewEditMap.filter(function (item) {
        return item.MenuId == menuId && item.IsPublished;
      });
      if (filterMenu.length) {
        if (self.IsAdminPreviewPage) {
          result = filterMenu[0].RoutePath;
        } else if (self.IsAdminEditPage) {
          result = filterMenu[0].AdminRoutePath;
        }
      }
      return result;
    },
    getNavDisplayLabel(item) {
      var locale = self.$store.state.locale;
      var label =
        locale == "German" && item.DisplayLabel_de
          ? item.DisplayLabel_de
          : locale == "French" && item.DisplayLabel_fr
          ? item.DisplayLabel_fr
          : locale == "Chinese" && item.DisplayLabel_zh
          ? item.DisplayLabel_zh
          : locale == "Spanish" && item.DisplayLabel_es
          ? item.DisplayLabel_es
          : item.DisplayLabel;
      var url = String(item.PageUrl || "").toLowerCase();
      if (
        (!locale || locale == "English") &&
        url.indexOf("exhibit") !== -1 &&
        typeof label == "string" &&
        label.toLowerCase() == "exhibit hall"
      ) {
        return "Exhibits";
      }
      return label;
    },
    getBrandingJsonIfCloudfrontNotPresent(hostName) {
      var path = APIs.googleSoragePath;
      axios
        .get(
          path + "OA_UAT%2FClients%2FHosts%2F" + hostName + ".json?alt=media"
        )
        .then((res) => {
          if (res.data) {
            if (
              res.data.defaultEvent &&
              res.data.defaultEvent.EventBannerShare
            ) {
              store.commit(
                "setEventocialShareImage",
                res.data.defaultEvent.EventBannerShare
                  ? res.data.defaultEvent.EventBannerShare
                  : ""
              );
            }
            if (res.data.CustomDomain) {
              store.commit("setCustomDomain", res.data.CustomDomain);
            }
            self.fbLoginEnabled = res.data.SocialAuths[0].Facebook
              ? res.data.SocialAuths[0].Facebook
              : false;
            self.googleLoginEnabled = res.data.SocialAuths[0].Google
              ? res.data.SocialAuths[0].Google
              : false;
            self.microsoftLoginEnabled = res.data.SocialAuths[0].Microsoft
              ? res.data.SocialAuths[0].Microsoft
              : false;
            self.linkedInLoginEnabled = res.data.SocialAuths[0].LinkedIn
              ? res.data.SocialAuths[0].LinkedIn
              : false;
            self.clientId = res.data.ClientId;
            store.commit(
              "setEnableSelfService",
              res.data.EnableSelfService ? true : false
            );
            store.commit("addClientID", {
              id: res.data.ClientId,
              name: res.data.ClientName,
            });
            store.commit("addAuth", {
              Microsoft: res.data.SocialAuths[0].Microsoft
                ? res.data.SocialAuths[0].Microsoft
                : false,
              google: res.data.SocialAuths[0].Google
                ? res.data.SocialAuths[0].Google
                : false,
              linkedin: res.data.SocialAuths[0].LinkedIn
                ? res.data.SocialAuths[0].LinkedIn
                : false,
            });
            store.commit("addBranding", {
              bg: self.getCDNUrl(res.data.LoginAssets.bg2732x2048),
              logo: self.getCDNUrl(res.data.LoginAssets.logo),
              favicon: self.getCDNUrl(res.data.Favicon),
              bg2: self.getCDNUrl(res.data.EventListAssets.bg2048x2732),
              banner: self.getCDNUrl(res.data.EventListAssets.banner2048x88),
              bodyTextColor: self.getCDNUrl(res.data.LoginAssets.bodyTextColor),
              mobileBanner: self.getCDNUrl(
                res.data.EventListAssets.banner750x103
              ),
            });
            if (res.data.DefaultLandingPage == "customlanding") {
              if (
                res.data.defaultEvent &&
                res.data.defaultEvent.EventCollectionName
              ) {
                if (
                  self.$store.state.publicEventCollection !=
                  res.data.defaultEvent.EventCollectionName
                ) {
                  store.commit(
                    "setPublicEventCollection",
                    res.data.defaultEvent.EventCollectionName
                  );
                  if (location.pathname.toLowerCase().includes("/home")) {
                    setTimeout(() => {
                      //alert("App - bus.$emit(CheckBrandingForPublicPage);")
                      bus.$emit("CheckBrandingForPublicPage");
                      self.SetBannerURL();
                      self.LoadEvent();
                      setTimeout(() => {
                        self.getMenuDetails();
                      }, 1000);
                    }, 1000);
                  }
                }
              }
            } else {
              store.commit("setPublicEventCollection", "");
            }
            self.setMeta();
            db.collection("OA_UAT/ClientList/Clients")
              .doc(self.clientId)
              .get()
              .then(function (doc) {
                if (doc.exists) {
                  if (doc.data().DisableLanguageOption == true) {
                    self.disableLanguageOption = true;
                  }
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
        })
        .catch((error) => {
          console.log("getBrandingJson: " + error);
        });
    },
    sendEmaiVerification() {
      self.IsSubmitting = true;

      var requestData = {};
      let headers = {
        "content-type": "application/json",
      };

      requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: self.getClientId(),
        },

        data: {
          FirstName: this.firstName,
          LastName: this.lastName,
          Email: this.emailId,
        },
      };
      axios
        .post(APIs.userEmailVerification, JSON.stringify(requestData), {
          headers: headers,
        })
        .then((responseData) => {
          self.IsSubmitting = false;
          if (responseData.data.status == 0) {
            this.showVerificationLinkSentMessage = true;
            self.showHideSignInForm = false;
          }
        })
        .catch((error) => {
          self.IsSubmitting = false;
          console.log("Error:" + error);
        });
    },
    DisplaySignInPopup() {
      self.showVerificationLinkSentMessage = false;
      self.firstName = "";
      self.lastName = "";
      self.emailId = "";
      $("#SignUpModal").modal("show");
    },
    CreateEventPopup() {
      self.openCreateEventSidePannel = true;
      self.resetCreateEvent += 1;
      var currentPath = location.href.replace(location.origin, "");
      self.$router.push(currentPath + "#create-new-event");
    },
    OnGoogleAuthSuccess(idToken) {
      // Receive the idToken and make your magic with the backend
      self.showGoogleBtnLoading = true;
      self.registerUserForEventAdminSocialSignups(idToken, "Google");
    },
    OnGoogleAuthFail(error) {
      self.showGoogleBtnLoading = false;
      console.log(error);
    },
    registerUserForEventAdminSocialSignups(token, provider) {
      var requestData = {};
      let headers = {
        "content-type": "application/json",
      };

      requestData = {
        token: token,
        provider: provider,
        clientId: self.getClientId(),
      };
      axios
        .post(APIs.userEventAdminRegister, JSON.stringify(requestData), {
          headers: headers,
        })
        .then((responseData) => {
          if (responseData.data.status == 0) {
            var data = responseData.data.data;

            firebase
              .auth()
              .signInWithCustomToken(responseData.data.customToken)
              .then(function (res) {
                res.user
                  .getIdToken(true)
                  .then((idToken) => {
                    var decoded = jwt_decode(idToken);

                    document.cookie = "token=";
                    document.cookie = "token=" + idToken + ";";
                    self.$store.commit("addToken", idToken);
                    self.$store.commit("setCurrentLoggedInTime", decoded.exp);

                    document.cookie = "staysigned=";
                    document.cookie = "userrole=";
                    document.cookie = "userid=";

                    ////////// After token and cookies set send to event////////////////////
                    store.commit("setLoginType", "Login");

                    var eventCount = 0;

                    store.commit("addEventCount", eventCount);

                    var userData = data;
                    var userRoles = userData.UserRoles;
                    var roles = [];

                    if (userRoles != undefined) {
                      userRoles.forEach(function (role) {
                        roles.push(role.RoleID);
                      });
                    }

                    store.state.userRole = userRoles;

                    store.commit("addAttendeeID", userData.UserId);
                    var UserType = "Attendee";
                    if (userData.RegistrationTypes != undefined)
                      for (var reg in userData.RegistrationTypes) {
                        if (
                          userData.RegistrationTypes[reg].RegistrationType ==
                          "Speaker"
                        ) {
                          UserType = "Speaker";
                        }
                      }

                    store.commit("addUser", {
                      id: userData.UserId,
                      Email: userData.Email,
                      name: userData.Name,
                      fname: userData.FirstName,
                      lname: userData.LastName,
                      profilepic: userData.ProfilePictureURL,
                      company: userData.Company,
                      title: userData.Designation,
                      phone: userData.Phone,
                      roles: roles,
                      userType: UserType,
                    });
                    console.log(
                      `before push Success Execution time:`,
                      new Date()
                    );
                    self.showGoogleBtnLoading = false;
                    $("#SignUpModal").modal("hide");
                    router.push({ name: "BasicInfo" });
                  })
                  .catch((err) => {
                    self.showGoogleBtnLoading = false;
                    console.log("err=====", err);
                  });
              })
              .catch(function (e) {
                console.log(e);
              });
          } else if (responseData.data.status == -10) {
            self.showGoogleBtnLoading = false;
            self.verificationExpiry = true;
          } else if (responseData.data.status == -11) {
            self.showGoogleBtnLoading = false;
            self.verificationExpiry = true;
          } else if (responseData.data.status == -35) {
            self.showGoogleBtnLoading = false;
            self.showSnackbar(
              "You are already registered. Redirecting to login screen..",
              "success",
              "bottom"
            );
            $("#SignUpModal").modal("hide");
            setTimeout(() => {
              router.push("/#cevent");
            }, 2000);
          }
        })
        .catch((error) => {
          //self.showSnackbar("hide");

          router.push("/#cevent");

          self.showGoogleBtnLoading = false;
          console.log("Error:" + error);
        });
    },
    Logout() {
      self.CurrentAdminEvent = null;
      var preventRedirection = false;
      if (self.IsGuestMenu) {
        preventRedirection = true;
      }
      //bus.$emit("clearState", preventRedirection);
      self.clearstate(preventRedirection);
    },
    GetAdminEventList() {
      self.AdminEvents = self.GetAdminEvents();
      self.CurrentAdminEvent = null;
      self.eventId = self.getEventId();
      self.eventName = self.getEventName();
      if (self.eventId) {
        for (var i = 0; i < self.AdminEvents.length; i++) {
          if (
            self.correntTimeMS >=
            self.AdminEvents[i].EventEndDateTimeStamp * 1000
          ) {
            self.AdminEvents[i].IsPastEvent = true;
          }
          if (self.eventId == self.AdminEvents[i].EventId) {
            self.CurrentAdminEvent = self.AdminEvents[i];
            //break;
          }
        }
      }
    },
    closeResourceDialog() {
      self.chatResourceDialog = false;
      self.chatFileUrl = null;
    },
    readAttendeeOnlineStatus() {
      if (self.$store.state.eventcollectionname) {
        var starCountRef = firebase
          .database()
          .ref(self.$store.state.eventcollectionname + "/Presence");
        starCountRef.on("value", (snapshot) => {
          //alert("readAttendeeOnlineStatus");
          self.onlineUserList = [];
          const data = snapshot.val();
          for (const key in data) {
            if (`${data[key]}` > 0) {
              self.onlineUserList.push(`${key}`);
            }
          }
          if (self.showChatComponent) {
            bus.$emit("activeUsersList", self.onlineUserList);
          }
        });
      }
    },
    setMyPresence(outsideEventScope) {
      var isActive = false;
      if (self.$store.state.eventcollectionname) {
        isActive = true;
      }
      if (outsideEventScope) {
        isActive = false;
      }
      if (self.uid != "") {
        if (isActive) {
          userStatusDatabaseRef = firebase
            .database()
            .ref(self.$store.state.eventcollectionname + "/Presence");

          var isOfflineForDatabase = {
            [self.uid]: firebase.database.ServerValue.increment(-1),
          };
          var isOnlineForDatabase = {
            [self.uid]: firebase.database.ServerValue.increment(1),
          };
          firebase
            .database()
            .ref(".info/connected")
            .on("value", function (snapshot) {
              if (snapshot.val() == false) {
                return;
              }
              userStatusDatabaseRef
                .onDisconnect()
                .update(isOfflineForDatabase)
                .then(function () {
                  userStatusDatabaseRef
                    .update(isOnlineForDatabase)
                    .then(function () {
                      // alert("onConnect");
                    });
                });
            });
          // .catch(function (error) {
          //   console.log(error);
          // });
        } else {
          //alert(self.deviceId);

          if (self.old_event_collectionName != "") {
            var userStatusDatabaseRef1 = firebase
              .database()
              .ref(self.old_event_collectionName + "/Presence");
            var isOfflineForDatabase1 = {
              [self.uid]: firebase.database.ServerValue.increment(-1),
            };

            userStatusDatabaseRef1
              .update(isOfflineForDatabase1)
              .then(function () {
                self.old_event_collectionName = "";
              });
            // .catch(function (error) {
            //   console.log(error);
            // });
          }
        }
      }
    },
    SetBannerURL() {
      var isClientBanner =
        this.IsEventListPage ||
        self.DefaultClientRoutes.includes(self.currentRouteName);
      var readFromCloudJSON = false;
      self.eventId = self.getEventId();
      var urlEventId = self.getEventId();
      if (!isClientBanner && self.$route.params && self.$route.params.e) {
        urlEventId = self.$route.params.e;
        if (urlEventId && self.eventId != urlEventId) {
          readFromCloudJSON = true;
        }
      }

      if (!readFromCloudJSON) {
        self.desktopBanner = self.getDesktopBanner(isClientBanner);
        self.mobileBanner = self.getMobleBanner(isClientBanner);
        self.shareBanner = self.getSocialShareBanner(isClientBanner);
      }
    },
    SetGuestBannerURL(eventBranding) {
      //alert("SetGuestBannerURL: "+eventBranding)
      if (eventBranding) {
        if (eventBranding.desktopBanner) {
          self.desktopBanner = eventBranding.desktopBanner;
        }
        if (eventBranding.mobileBanner) {
          self.mobileBanner = eventBranding.mobileBanner;
        }
        if (eventBranding.shareBanner) {
          self.shareBanner = eventBranding.shareBanner;
        }
      }
    },
    clearstateEdu() {
      if (this.$store.state.isSSO) {
        document.cookie = "AT=;domain=.edulife.sg;";
        this.$store.commit("addIsSSO", false);
        location.href = "https://edulife.sg/home?logout";
      }
      let hashVal = store.state.IsAccessCodeLogin
        ? `#${store.state.eventid}`
        : "";
      var userType = this.$store.state.user[0].userType;
      store.commit("ClearState", this);
      document.cookie = "vuid=; path=/;domain=.e2m.live;secure=true";
      document.cookie = "staysigned=";
      document.cookie = "userrole=";
      document.cookie = "userid=";

      //document.cookie.removeCookie("vuid");
      //firebase authentican log out---------------
      firebase
        .auth()
        .signOut()
        .then(
          function () {
            console.log("Signed Out");
          },
          function (error) {
            console.error("Sign Out Error", error);
          }
        );
      //firebase authentican log out---------------
      if (userType == "Attendee") {
        location.href = "https://edulife.sg/home?logout";
      } else if (!self.autoLogin) {
        location.href = `/${hashVal}`;
      }
      self.autoLogin = false;
    },
    openGuideline() {
      var data = {};
      data = {};
      data.url =
        "https://firebasestorage.googleapis.com/v0/b/e2medu.appspot.com/o/OA_UAT%2FC1591205467009%2FPop-up%20Blocker%20Guide.pdf?alt=media";
      data.type = "PDF";

      bus.$emit("chatResources", data);
    },
    checkUserLoggedInStatus(attendeeId) {
      if (userLoggedInStatusListener) {
        userLoggedInStatusListener();
        userLoggedInStatusListener = null;
      }
      if (attendeeId) {
        userLoggedInStatusListener = db
          .collection("OA_UAT")
          .doc("AuditTrail")
          .collection("Users")
          .doc(attendeeId)
          .onSnapshot(
            (doc) => {
              var data = doc.data();
              if (
                data &&
                data.online == false &&
                location.host.includes("edulife")
              ) {
                self.clearstateEdu();
              }
            },
            (error) => {
              console.log(error);
            }
          );
      }
    },
    downloadResourceFile(url, fileName) {
      axios({
        method: "get",
        url: url,
        responseType: "arraybuffer",
      })
        .then((response) => {
          this.forceFileDownload(response, fileName);
        })
        .catch(() => console.log("error occured"));
    },
    forceFileDownload(response, fileName) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    getFileNameFromUrl(downloadUrl) {
      let url = decodeURIComponent(downloadUrl);
      let arr = url.split("?");
      let arr2 = arr[0].split("/");
      let name = arr2[arr2.length - 1];
      return name;
    },
    helpDeskTypClicks(types) {
      var data = {};
      if (types == "Platform Guide Video") {
        if (this.$store.state.user[0].userType == "Attendee") {
          data = {};
          data.url =
            "https://firebasestorage.googleapis.com/v0/b/e2medu.appspot.com/o/OA_UAT%2FC1591205467009%2FEdulife%20Tour%20(1).mp4?alt=media&token=b47a0619-6da1-4cc3-8fb0-864413bce2ba";
          data.type = "VIDEO";
          data.clientName = "edu";
          bus.$emit("chatResources", data);
        } else {
          data = {};
          data.url =
            "https://firebasestorage.googleapis.com/v0/b/e2medu.appspot.com/o/OA_UAT%2FC1591205467009%2FEdulife_%20%20Mentor%20Journey%20(1).pdf?alt=media&token=d8c460d9-e7fd-4ffd-9c78-2d3d438decbe";
          data.type = "PDF";
          data.clientName = "edu";
          bus.$emit("chatResources", data);
        }
      } else if (types == "Contact Campus Helpdesk") {
        self.routeToWhatsApp();
      } else if (types == "FAQ") {
        self.openGuideline();
      } else {
        var fileName;
        if (this.$store.state.user[0].userType == "Attendee") {
          window.open(
            "https://firebasestorage.googleapis.com/v0/b/e2medu.appspot.com/o/OA_UAT%2FC1591205467009%2Fzoom-bg-students.jpg?alt=media"
          );
          fileName = self.getFileNameFromUrl(
            "https://firebasestorage.googleapis.com/v0/b/e2medu.appspot.com/o/OA_UAT%2FC1591205467009%2Fzoom-bg-students.jpg?alt=media"
          );
          self.downloadResourceFile(
            "https://firebasestorage.googleapis.com/v0/b/e2medu.appspot.com/o/OA_UAT%2FC1591205467009%2Fzoom-bg-students.jpg?alt=media",
            fileName
          );
        } else {
          window.open(
            "https://firebasestorage.googleapis.com/v0/b/e2medu.appspot.com/o/OA_UAT%2FC1591205467009%2FZoom%20Virtual%20background%20(1).pdf?alt=media"
          );
          fileName = self.getFileNameFromUrl(
            "https://firebasestorage.googleapis.com/v0/b/e2medu.appspot.com/o/OA_UAT%2FC1591205467009%2FZoom%20Virtual%20background%20(1).pdf?alt=media"
          );
          self.downloadResourceFile(
            "https://firebasestorage.googleapis.com/v0/b/e2medu.appspot.com/o/OA_UAT%2FC1591205467009%2FZoom%20Virtual%20background%20(1).pdf?alt=media",
            fileName
          );
        }
      }
    },
    toggleMenuAndHeder(val) {
      if (val) {
        this.$nextTick(() => {
          $("#app").addClass("full-screen");
          $("#topmenu").addClass("d-none");
          $("#leftMenuParent").addClass("d-none");
        });
      } else {
        this.$nextTick(() => {
          $("#app").removeClass("full-screen");
          $("#topmenu").removeClass("d-none");
          $("#leftMenuParent").removeClass("d-none");
        });
      }
    },

    closeRegDialogOnSuccess() {
      //alert("app: " + self.eventId);
      self.autoLogin = true;
      //var email = self.getCookie("alEmail");
      var email = $("#dialogReg").attr("data-val");
      //alert(email);
      var eid = self.eventId;
      //alert(eid);
      self.clearstate();
      self.closeRegDialog();
      //setTimeout(() => {
      store.commit("setALEmail", email);

      //document.cookie = "alEmail=" + email;

      //self.$router.push("/");
      //self.$router.push("/#" + self.eventId);
      location.href = "/#" + eid;
      //location.reload();
      //}, 1000);
    },
    async getChatSettings() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (
        obj.eventcollectionname != undefined &&
        obj.eventcollectionname != ""
      ) {
        await db
          .collection(obj.eventcollectionname)
          .doc("Settings")
          .collection("chat")
          .doc("ChatGroupSettings")
          .get()
          .then(async (doc) => {
            if (doc.exists) {
              var docs = doc.data();
              self.chatDefaultView = docs.DefaultView ? docs.DefaultView : null;
              self.chatDisplayView = docs.ShowChatFloatingButton;
              self.IsStageviewChatEanbled = docs.IsStageviewChatEanbled;
              self.isChatAndAttendeeTogglePresent =
                docs.ShowToggleForAttendeeOrChat
                  ? docs.ShowToggleForAttendeeOrChat
                  : false;
              if (
                self.currentRouteName == "StageView" ||
                self.currentRouteName == "Lobby"
              ) {
                if (docs.IsStageviewChatEanbled) {
                  self.showChatComponent = true;
                  store.commit("setStageViewChat", true);
                  if (docs.LobbyChatRoomName) {
                    bus.$emit(
                      "ifChatLeftEnabled",
                      true,
                      docs.LobbyChatRoomName
                    );
                  } else {
                    bus.$emit("ifChatLeftEnabled", true);
                  }

                  // self.$store.commit("setStageViewChat", true);
                } else {
                  self.showChatComponent = false;
                  store.commit("setStageViewChat", false);
                  bus.$emit("ifChatLeftEnabled", false);
                  // self.$store.commit("setStageViewChat", false);
                }
              } else {
                bus.$emit("ifChatLeftEnabled", false);
              }
            }
          });
      }
    },
    validateAndShowVideoPlayer() {
      if (!self.todaysDate) {
        self.todaysDate = new Date()
          .toISOString()
          .slice(0, 10)
          .replace(/-/g, "");
      }
      console.log("validateAndShowVideoPlayer: ", self.currentRouteName);
      self.welcomeVideoSeen =
        this.getCookie("welcomeVideoSeen" + self.todaysDate) == "true";
      // console.log("welcomeVideoSeen: ", self.welcomeVideoSeen);
      if (
        !self.welcomeVideo ||
        !self.welcomeVideo.IsPublished ||
        self.welcomeVideoSeen
      ) {
        // alert("aaaaaaaaa");
        return;
      }
      if (
        welcomeVideoTimer &&
        [
          "EventList",
          "Lobby",
          "StageView",
          "AdminStageView",
          "LiveStage",
          "LiveStageNG",
        ].includes(self.currentRouteName)
      ) {
        // alert("Welcome Video is off");
        clearInterval(welcomeVideoTimer);
        welcomeVideoTimer = null;
      } else if (
        !welcomeVideoTimer &&
        ![
          "EventList",
          "Lobby",
          "StageView",
          "AdminStageView",
          "LiveStage",
          "LiveStageNG",
        ].includes(self.currentRouteName) &&
        !self.videoPlayerDialog
      ) {
        var welcomeVideoStartTime = self.welcomeVideo.StartTime.seconds * 1000;
        var welcomeVideoEndTime = self.welcomeVideo.EndTime.seconds * 1000;
        var currentTime = new Date().getTime();
        if (currentTime > welcomeVideoEndTime) {
          return;
        }
        welcomeVideoStartTime = welcomeVideoStartTime - currentTime;
        if (welcomeVideoStartTime < 0) {
          welcomeVideoStartTime = 0;
        }
        console.log("setInterval");
        // welcomeVideoStartTime=100;
        // setTimeout(() => {
        welcomeVideoTimer = setInterval(() => {
          // alert("Welcome Video is starting");
          console.log("setInterval - showVideoPlayer");
          self.showVideoPlayer(self.welcomeVideo);
          self.welcomeVideoSeen = true;
          setTimeout(() => {
            // alert("Starting video click");
            $("#startVideo").click();
            if (welcomeVideoTimer) {
              // alert("Welcome Video is off");
              clearInterval(welcomeVideoTimer);
              welcomeVideoTimer = null;
            }
          }, 100);
        }, welcomeVideoStartTime);
        // }, 5000);
      }
    },
    showVideoPlayer(welcomeVideo) {
      console.log("showVideoPlayer");
      var playList = [];
      // source = [
      //   {
      //     url: "https://firebasestorage.googleapis.com/v0/b/e2monair.firebasestorage.app/o/OA_UAT_C1649103310659E1753782549628%2F2.%20New%20welcome%20to%20Arabia%20Video%20STA_1920x1080_H.mp4?alt=media&token=872c4d66-c7ef-4966-ad0f-f7cf7c69fd25",
      //     type: "video/mp4",
      //   },
      //   {
      //     url: "https://firebasestorage.googleapis.com/v0/b/e2monair.firebasestorage.app/o/OA_UAT_C1649103310659E1753782549628%2F2.%20New%20welcome%20to%20Arabia%20Video%20STA_1920x1080_H.mp4?alt=media&token=872c4d66-c7ef-4966-ad0f-f7cf7c69fd25",
      //     type: "video/mp4",
      //   },
      // ];
      var source = [];
      if (welcomeVideo && welcomeVideo.PlayList) {
        source = welcomeVideo.PlayList || [];
        source.forEach(function (item) {
          var type = "application/x-mpegurl";
          type = "video/mp4";
          if (item.url && item.IsPublished) {
            if (item.type) {
              type = item.type;
            } else {
              if (item.url && item.url.toLowerCase().endsWith(".mp4")) {
                type = "video/mp4";
              }
            }
            //alert(item);
            playList.push({
              sources: [
                {
                  src: item.url,
                  type: type,
                },
              ],
              // poster: "http://media.w3.org/2010/05/sintel/poster.png",
            });
          }
        });
        if (playList.length > 0) {
          self.videoPlayerDialog = true;
          self.$nextTick(() => {
            var videoPlayerElapsedTime =
              this.getCookie("videoPlayerElapsedTime" + self.todaysDate) || "0";
            videoPlayerElapsedTime = parseInt(videoPlayerElapsedTime);
            // console.log("videoPlayerElapsedTime: ", videoPlayerElapsedTime);
            // self.welcomeVideoSeen = this.getCookie(
            //   "welcomeVideoSeen" + self.todaysDate
            // );
            // console.log("welcomeVideoSeen: ", self.welcomeVideoSeen);
            self.videoPlayer.playlist(playList);
            self.videoPlayer.playlist.autoadvance(0);
            // self.videoPlayer.currentTime(0);
            videoPlayerElapsedTime -= 5;
            if (videoPlayerElapsedTime < 0) {
              videoPlayerElapsedTime = 0;
            }
            self.videoPlayer.currentTime(videoPlayerElapsedTime);
            self.videoPlayer.play();
            // self.videoPlayer.playlist(playList);
          });
        }
      }
    },
    onVideoPlayerEnded(player) {
      self.videoPlayerDialog = false;
      if (player) {
        document.cookie = "welcomeVideoSeen" + self.todaysDate + "=true";
      }
      try {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          /* Firefox */
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          /* Chrome, Safari and Opera */
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          /* IE/Edge */
          document.msExitFullscreen();
        }
      } catch (e) {
        console.log(e);
      }
      if (self.welcomeVideo.RedirectOnEnd) {
        router.push(self.welcomeVideo.RedirectToUrl || "/sessions");
      }
    },
    onVideoPlayerTimeUpdate(player) {
      // alert("onVideoPlayerTimeUpdate");
      let time = Math.floor(player.currentTime());
      if (time > self.videoPlayerElapsedTime) {
        self.videoPlayerElapsedTime = time;
        console.log(self.videoPlayerElapsedTime);
        document.cookie =
          "videoPlayerElapsedTime" +
          self.todaysDate +
          "=" +
          self.videoPlayerElapsedTime;

        // End Video Play
        // var welcomeVideoStartTime = self.welcomeVideo.StartTime.seconds * 1000;
        var welcomeVideoEndTime = self.welcomeVideo.EndTime.seconds * 1000;
        var currentTime = new Date().getTime();
        if (currentTime > welcomeVideoEndTime) {
          self.videoPlayer.pause();
          self.onVideoPlayerEnded({});
        }
      }
    },
    onVideoPaused() {
      // alert("onVideoPaused");
    },
    onVideoPlayerWaiting() {
      // alert("onVideoPlayerWaiting");
    },
    onVideoPlayerElapsed() {
      // alert("onVideoPlayerElapsed");
    },
    switchToPIPView() {
      self.playerPIPMode = true;
    },
    onClosePlayerDialog(doNotAsk, name) {
      if (doNotAsk) {
        self.showSnackbar(
          name +
            " is not able to accept this video call right now, please try again later",
          "info",
          "top"
        );
      }
      bus.$emit("onCloseVideoChat", doNotAsk);
    },
    closePlayerDialog() {
      self.playerPIPMode = false;
      self.playerDialog = false;
      self.dialingNotificationId = "";
      self.playerKey += 1;
      $("#app").removeClass("player");
      $("body").removeClass("player");
    },
    onCallStarted(callStarted) {
      self.callStarted = callStarted;
    },
    startVideoChat(data) {
      if (self.playerDialog) {
        self.showSnackbar(self.alreadyInACallMsg, "info", "top");
        return;
      }
      self.playerPIPMode = false;
      if (data && data.roomId && data.memberIDs) {
        self.isDialing = false;
        self.playerKey += 1;
        self.roomId = data.roomId;
        self.roomMemberList = data.memberIDs;
        self.playerDialog = true;
        self.dialingNotificationId = "";
        if (data.sendChat || data.sendNotification) {
          var clientId = self.getClientId();
          var eventId = self.getEventId();
          var user = self.getSessionUserProfile();
          if (clientId && eventId && user) {
            if (data.sendChat) {
              self.SendChatMessage(
                data.roomId,
                data.memberIDs,
                clientId,
                eventId,
                user
              );
            }
            if (data.sendNotification) {
              self.SendChatNotification(
                data.roomId,
                data.memberIDs,
                data.attendees,
                clientId,
                eventId,
                user
              );
            }
          }
        }
        //         setTimeout(() => {
        //           alert("sssssss")
        //           //document.addEventListener('DOMContentLoaded', (event) => {
        // //console.log(event);
        //   let items = document.querySelectorAll('.drag-container .player-dialog');
        //   alert(items.length);
        //   items.forEach(function(item) {
        //     item.addEventListener('dragstart', self.handleDragStart);
        //     item.addEventListener('dragover', self.handleDragOver);
        //     item.addEventListener('dragenter', self.handleDragEnter);
        //     item.addEventListener('dragleave', self.handleDragLeave);
        //     item.addEventListener('dragend', self.handleDragEnd);
        //     item.addEventListener('drop', self.handleDrop);
        //   });
        // //});
        //         }, 20000);
      }
    },
    openPlayerDialog(data) {
      if (self.playerDialog) {
        self.showSnackbar(self.alreadyInACallMsg, "info", "top");
        return;
      }
      self.playerPIPMode = false;
      if (data && data.sessionId) {
        self.isDialing = false;
        self.playerKey += 1;
        //self.roomId = data.roomId;
        self.dialogSessionId = data.sessionId;
        self.dialogEventId = data.eventId;
        self.dialogEventName = data.eventName;
        self.dialogEventCollectionName = data.eventCollectionName;
        //self.roomMemberList = data.memberIDs;
        self.playerDialog = true;
        self.dialingNotificationId = "";
        if (self.dialogSessionId) {
          $("#topmenu").hide();
        }
        if (data.sendChat || data.sendNotification) {
          var clientId = self.getClientId();
          var eventId = self.getEventId();
          var user = self.getSessionUserProfile();
          if (clientId && eventId && user) {
            if (data.sendChat) {
              self.SendChatMessage(
                data.roomId,
                data.memberIDs,
                clientId,
                eventId,
                user
              );
            }
            if (data.sendNotification) {
              self.SendChatNotification(
                data.roomId,
                data.memberIDs,
                data.attendees,
                clientId,
                eventId,
                user
              );
            }
          }
        }
      }
    },

    listenPlayerDragDrop() {
      $(":root").css("--player-right", 0 + "px");
      $(":root").css("--player-bottom", 0 + "px");
      let items = document.querySelectorAll(".drag-container .player-dialog");
      if (items.length > 0) {
        items[0].addEventListener("dragstart", self.handleDragStart);
        //items[0].addEventListener("dragover", self.handleDragOver);
        items[0].addEventListener("dragend", self.handleDragEnd);
      }
      // items.forEach(function(item) {
      //   item.addEventListener('dragstart', self.handleDragStart);
      //   item.addEventListener('dragover', self.handleDragOver);
      //   item.addEventListener('dragenter', self.handleDragEnter);
      //   item.addEventListener('dragleave', self.handleDragLeave);
      //   item.addEventListener('dragend', self.handleDragEnd);
      //   item.addEventListener('drop', self.handleDrop);
      // });
    },

    handleDragStart(e) {
      console.log(e);
      //this.style.opacity = '0.4';
      $(".player.pip .v-overlay").addClass("over");
      $(".player.pip .v-dialog__content").addClass("over");
      $(".player.pip .v-overlay.v-overlay--active").addClass("over");
      // e.dataTransfer.setData("text", "ev.target.id");
      // e.dataTransfer.effectAllowed = "move";
      //e.dataTransfer.setData('text/html', this.innerHTML);
    },

    handleDragEnd(e) {
      // alert("height: "+screen.height);
      // alert("screenY: "+e.screenY );
      // alert("width: "+screen.width);
      // alert("screenX: "+e.screenX);
      var right = screen.width - e.screenX - 150;
      var bottom = screen.height - e.screenY - 112;
      self.right = 0;
      self.bottom = 0;
      if (right > screen.width - 300 - 105) {
        right = screen.width - 300 - 105;
      }
      if (right < 0) {
        right = 0;
      }
      if (bottom > screen.height - 225 - 245) {
        bottom = screen.height - 225 - 245;
      }
      if (bottom < 0) {
        bottom = 0;
      }
      self.right = right;
      self.bottom = bottom;
      $(":root").css("--player-right", parseInt(right) + "px");
      $(":root").css("--player-bottom", parseInt(bottom) + "px");
      // let items = document.querySelectorAll('.drag-container .player-dialog');

      // items.forEach(function (item) {
      //   item.classList.remove('over');
      // });
      $(".player.pip .v-overlay.v-overlay--active").removeClass("over");
      $(".player.pip .v-dialog__content").removeClass("over");
      $(".player.pip .v-overlay").removeClass("over");
    },

    handleDragOver(e) {
      // $(":root").css(
      //   "--player-right",
      //   parseInt(screen.width - e.screenX - 150) + "px"
      // );
      // $(":root").css(
      //   "--player-bottom",
      //   parseInt(screen.height - e.screenY - 112) + "px"
      // );
      e.preventDefault();
      return false;
    },

    handleDragEnter(e) {
      //alert("handleDragEnter")
      console.log(e);
      //this.classList.add('over');
      //$(".player.pip .v-overlay").addClass('over');
    },

    handleDragLeave(e) {
      console.log(e);
      //this.classList.remove('over');
      //$(".player.pip .v-overlay").removeClass('over');
    },

    VideoChatDecline(data) {
      if (data && data.sender && data.sender.AttendeeId && data.actionType) {
        var clientId = self.getClientId();
        var eventId = self.getEventId();
        var user = self.getSessionUserProfile();
        if (clientId && eventId && user) {
          var chatMsg = "";
          if (data.actionType == 1) {
            chatMsg =
              user.FirstName +
              " is not able to accept this video call right now, please try again later";
          } else if (data.actionType == 2) {
            chatMsg =
              user.FirstName +
              " is not available right now, please try again later.";
          }
          let headers = {
            "content-type": "application/json",
            Authorization: "Bearer " + self.getSessionToken(),
          };
          let requestData = {
            key: {
              instanceId: "OA_UAT",
              clientId: clientId,
              eventId: eventId,
            },
            data: {
              roomId: data.roomId,
              msgType: "EVENT-NOTIFICATION",
              msgText: chatMsg,
              senderId: user.UserId,
              senderName: user.Name,
              senderPhotoUrl: user.ProfileImageURL,
              fileUrl: "",
              parentMsgId: "",
            },
          };
          axios
            .post(APIs.postMessage, requestData, {
              headers: headers,
            })
            .then((responseData) => {
              self.hideLoader();
              //alert("SendMeetingPush Success");
              console.log(responseData);
            })
            .catch((error) => {
              //alert("SendMeetingPush Failure");
              console.log("Start RT: " + error);
            });

          var attendees = [];
          if (data.actionType == 1) {
            attendees.push({
              AttendeeId: data.sender.AttendeeId,
              Name: data.sender.Name,
              ProfilePictureURL: data.sender.ProfilePictureURL,
              Tags: common.getInitials(data.sender.Name),
            });
          } else if (data.actionType == 2) {
            attendees.push({
              AttendeeId: data.sender.AttendeeId,
              Name: data.sender.Name,
              ProfilePictureURL: data.sender.ProfilePictureURL,
              Tags: common.getInitials(data.sender.Name),
            });
          }
          headers = {
            "content-type": "application/json",
            Authorization: "Bearer " + self.getSessionToken(),
          };
          requestData = {
            key: {
              instanceId: "OA_UAT",
              clientId: clientId,
              eventId: eventId,
              channelId: "",
              //meetingId: roomId,
              meetingType:
                data.actionType == 1
                  ? "VideoCalling/CallDeclined"
                  : data.actionType == 2
                  ? "VideoCalling/CallNoAnswer"
                  : data.actionType == 3
                  ? "VideoCalling/CallMissed"
                  : "",
            },
            data: attendees,
          };
          axios
            .post(APIs.SendMeetingPush, requestData, {
              headers: headers,
            })
            .then((responseData) => {
              //vm.hideLoader();
              //alert("Send Chat Push Success");
              console.log(responseData);
            })
            .catch((error) => {
              //alert("Send Chat Push Failure");
              console.log("Start RT: " + error);
            });
        }
      }
    },
    VideoChatNoAnswer(data) {
      if (data && data.sender && data.sender.AttendeeId && data.actionType) {
        var clientId = self.getClientId();
        var eventId = self.getEventId();
        var user = self.getSessionUserProfile();
        if (clientId && eventId && user) {
          // var chatMsg = "";
          // if (data.actionType == 1) {
          //   chatMsg =
          //     user.FirstName +
          //     " is not able to accept this video call right now, please try again later";
          // } else if (data.actionType == 2) {
          //   chatMsg =
          //     user.FirstName +
          //     " is not available right now, please try again later.";
          // }
          // let headers = {
          //   "content-type": "application/json",
          //   Authorization: "Bearer " + self.getSessionToken(),
          // };
          // let requestData = {
          //   key: {
          //     instanceId: "OA_UAT",
          //     clientId: clientId,
          //     eventId: eventId,
          //   },
          //   data: {
          //     roomId: data.roomId,
          //     msgType: "EVENT-NOTIFICATION",
          //     msgText: chatMsg,
          //     senderId: user.UserId,
          //     senderName: user.Name,
          //     senderPhotoUrl: user.ProfileImageURL,
          //     fileUrl: "",
          //     parentMsgId: "",
          //   },
          // };
          // axios
          //   .post(APIs.postMessage, requestData, {
          //     headers: headers,
          //   })
          //   .then((responseData) => {
          //     self.hideLoader();
          //     //alert("SendMeetingPush Success");
          //     console.log(responseData);
          //   })
          //   .catch((error) => {
          //     //alert("SendMeetingPush Failure");
          //     console.log("Start RT: " + error);
          //   });

          var attendees = [
            {
              AttendeeId: data.sender.AttendeeId,
              Name: data.sender.Name,
              ProfilePictureURL: data.sender.ProfilePictureURL,
              Tags: common.getInitials(data.sender.Name),
            },
          ];
          var headers = {
            "content-type": "application/json",
            Authorization: "Bearer " + self.getSessionToken(),
          };
          var requestData = {
            key: {
              instanceId: "OA_UAT",
              clientId: clientId,
              eventId: eventId,
              channelId: "",
              //meetingId: roomId,
              meetingType: "VideoCalling/CallNoAnswer",
            },
            data: attendees,
          };
          axios
            .post(APIs.SendMeetingPush, requestData, {
              headers: headers,
            })
            .then((responseData) => {
              //vm.hideLoader();
              //alert("Send Chat Push Success");
              console.log(responseData);
            })
            .catch((error) => {
              //alert("Send Chat Push Failure");
              console.log("Start RT: " + error);
            });
        }
      }
    },
    VideoChatMissed(data) {
      if (data && data.sender && data.sender.AttendeeId && data.actionType) {
        var clientId = self.getClientId();
        var eventId = self.getEventId();
        var user = self.getSessionUserProfile();
        if (clientId && eventId && user) {
          // var chatMsg = "";
          // if (data.actionType == 1) {
          //   chatMsg =
          //     user.FirstName +
          //     " is not able to accept this video call right now, please try again later";
          // } else if (data.actionType == 2) {
          //   chatMsg =
          //     user.FirstName +
          //     " is not available right now, please try again later.";
          // }
          // let headers = {
          //   "content-type": "application/json",
          //   Authorization: "Bearer " + self.getSessionToken(),
          // };
          // let requestData = {
          //   key: {
          //     instanceId: "OA_UAT",
          //     clientId: clientId,
          //     eventId: eventId,
          //   },
          //   data: {
          //     roomId: data.roomId,
          //     msgType: "EVENT-NOTIFICATION",
          //     msgText: chatMsg,
          //     senderId: user.UserId,
          //     senderName: user.Name,
          //     senderPhotoUrl: user.ProfileImageURL,
          //     fileUrl: "",
          //     parentMsgId: "",
          //   },
          // };
          // axios
          //   .post(APIs.postMessage, requestData, {
          //     headers: headers,
          //   })
          //   .then((responseData) => {
          //     self.hideLoader();
          //     //alert("SendMeetingPush Success");
          //     console.log(responseData);
          //   })
          //   .catch((error) => {
          //     //alert("SendMeetingPush Failure");
          //     console.log("Start RT: " + error);
          //   });

          var attendees = [
            {
              AttendeeId: data.sender.AttendeeId,
              Name: data.sender.Name,
              ProfilePictureURL: data.sender.ProfilePictureURL,
              Tags: common.getInitials(data.sender.Name),
            },
          ];
          var headers = {
            "content-type": "application/json",
            Authorization: "Bearer " + self.getSessionToken(),
          };
          var requestData = {
            key: {
              instanceId: "OA_UAT",
              clientId: clientId,
              eventId: eventId,
              channelId: "",
              //meetingId: roomId,
              meetingType: "VideoCalling/CallMissed",
            },
            data: attendees,
          };
          axios
            .post(APIs.SendMeetingPush, requestData, {
              headers: headers,
            })
            .then((responseData) => {
              //vm.hideLoader();
              //alert("Send Chat Push Success");
              console.log(responseData);
            })
            .catch((error) => {
              //alert("Send Chat Push Failure");
              console.log("Start RT: " + error);
            });
        }
      }
    },
    SendChatMessage(roomId, membersList, clientId, eventId, user) {
      console.log(membersList);
      var requestData = {};
      let headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + self.getSessionToken(),
      };
      requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: clientId,
          eventId: eventId,
        },
        data: {
          roomId: roomId,
          msgType: "VideoCall",
          msgText: "Wants to start a video chat with you",
          senderId: user.UserId,
          senderName: user.Name,
          senderPhotoUrl: user.ProfileImageURL,
          parentMsgId: "",
          fileUrl: "",
        },
      };
      axios
        .post(APIs.postMessage, JSON.stringify(requestData), {
          headers: headers,
        })
        .then((responseData) => {
          //alert(responseData.data.status);
          if (responseData.data.status == 0) {
            // setTimeout(() => {
            //   self.scrollChatToBottom();
            // }, 200);
          }
        })
        .catch((error) => {
          console.log("Error:" + error);
        });
    },
    SendChatNotification(
      roomId,
      membersList,
      attendees,
      clientId,
      eventId,
      user
    ) {
      if (
        membersList &&
        membersList.length == 2 &&
        membersList.includes(user.UserId)
      ) {
        //var notificationId = user.UserId + "_" + new Date().getTime();
        // //     pushNotificationIcon = "/images/started.png";
        //     pushNotificationIcon = "/images/success.png";
        if (attendees.length > 0) {
          for (var i = 0; i < attendees.length; i++) {
            attendees[i].Type = "VideoCalling/CallStarted";
          }
        }
        let headers = {
          "content-type": "application/json",
          Authorization: "Bearer " + self.getSessionToken(),
        };
        let requestData = {
          key: {
            instanceId: "OA_UAT",
            clientId: clientId,
            eventId: eventId,
            channelId: "",
            meetingId: roomId,
            meetingType: "VideoCalling/CallStarted",
          },
          data: attendees,
        };
        axios
          .post(APIs.SendMeetingPush, requestData, {
            headers: headers,
          })
          .then((responseData) => {
            //vm.hideLoader();
            //alert("Send Chat Push Success");
            console.log(responseData);
          })
          .catch((error) => {
            //alert("Send Chat Push Failure");
            console.log("Start RT: " + error);
          });
      }
    },
    openBriefcase() {
      this.briefcaseDialog = true;
    },
    clickToOpenChat() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj.eventcollectionname != undefined) {
        db.collection(obj.eventcollectionname)
          .doc("Settings")
          .collection("chat")
          .doc("ChatGroupSettings")
          .get()
          .then((doc) => {
            if (doc.exists) {
              var docs = doc.data();
              if (docs.DefaultView == "Social Wall") {
                if (self.defaultRoomIdForChat != null) {
                  this.commonLoader = true;
                  bus.$emit("openPredefinedChat", self.defaultRoomIdForChat);
                }
              } else {
                bus.$emit("openChat");
              }
            }
          });
      }
    },
    getTotalUnReadCounts() {
      var obj = JSON.parse(window.localStorage["my-app"]);
      if (unreadMessageListener) {
        unreadMessageListener();
        unreadMessageListener = null;
      }
      if (obj.eventcollectionname != null && obj.eventcollectionname != "") {
        unreadMessageListener = db
          .collection(obj.eventcollectionname)
          .doc("group-chat")
          .collection("map-user-chatroom")
          .doc(obj.user[0].id)
          .collection("unread-counts")
          .onSnapshot((querySnapshot) => {
            if (querySnapshot.docs.length > 0) {
              var totalMsgCount = 0;
              self.totalUnReadMsg = 0;
              querySnapshot.forEach((doc) => {
                totalMsgCount += doc.data().unreadCount;
              });
              self.totalUnReadMsg = totalMsgCount;
            } else {
              self.totalUnReadMsg = 0;
            }
          });
      }
    },
    openLBModal() {
      self.lbKey++;
      self.dialog = true;
      //var ComponentClass = Vue.extend(LeaderBoard);
      //var instance = new ComponentClass({
      //  propsData: {
      //    isModal: true,
      //    usersTabInModal: true,
      //    usersTabTop3InModal: true,
      //    groupsTabInModal: true,
      //    myScorecardTabInModal: true,
      //    myTotalScoreInModal: true,
      //  },
      //});
      //instance.$mount();
    },
    closeHandler() {
      self.dialog = false;
    },
    openRegDialog(eventId) {
      self.dialogReg = true;
      self.dialogRegKey++;
      self.eventId = eventId;
      self.eventName = self.getEventName();
      self.regLink = location.origin + "/reg/" + eventId + "/visitor";
      //document
      //  .getElementById("iframeReg")
      //  .contentDocument.location.reload(true);
    },
    closeRegDialog() {
      self.dialogReg = false;
      //alert("self.dialogReg:" + self.dialogReg);
      self.regLink = "";
    },
    onHelpDeskClick() {
      if (self.$store.state.user[0].Email == "") {
        self.routeToWhatsApp();
      } else {
        self.helpMenu = !self.helpMenu;
      }
    },

    routeToWhatsApp() {
      var yourNumber;
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      db.collection("OA_UAT/ClientList/Clients")
        .doc(obj.client[0].id)
        .collection("Features")
        .doc("PostLoginOptions")
        .get()
        .then(function (doc) {
          if (doc.exists) {
            yourNumber = doc.data().WhatsAppNumber
              ? doc.data().WhatsAppNumber
              : "+65 81849058";
            if (yourNumber) {
              window.open("https://api.whatsapp.com/send?phone=" + yourNumber);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    goToCMS() {
      var apiUrl = APIs.FirebaseAuthApi;
      if (apiUrl.includes("uat")) {
        window.open("https://uatonaircms.e2m.live/", "_blank").focus();
      } else if (apiUrl.includes("stage")) {
        window.open("https://onaircmsstage.e2m.live/", "_blank").focus();
      } else if (apiUrl.includes("prd")) {
        window.open("https://onaircms.e2m.live/", "_blank").focus();
      }
    },
    refreshPage() {
      window.location.reload();
    },
    turnOnHelp() {
      if (window.Tawk_API) {
        if (window.Tawk_API.isChatMaximized()) {
          window.Tawk_API.minimize();
        } else {
          if (this.$store.state.user && this.$store.state.user.length > 0) {
            let name = this.$store.state.user[0].fname.trim();
            let email = this.$store.state.user[0].Email.trim();

            if (window.Tawk_API && window.Tawk_API.setAttributes) {
              window.Tawk_API.setAttributes({
                name: name,
                email: email,
              });
            }

            window.Tawk_API.maximize();
          }
        }
      }
    },
    switchEvent() {
      let path = { path: "/eventlist" };
      if (this.$store.state.DefaultLoginLandingPage == "/clientLobby") {
        path.query = { DefaultLoginLandingPage: "/clientLobby" };
      }
      this.$router.push(path);
    },
    loadMenuClientLevel() {
      let self = this;
      // self.MenuData = [];
      // self.AllMenuData = [];
      // self.LeftData = [];
      // self.MenuData.splice(0, self.MenuData.length);
      this.$store.state.AdditionalMenu.forEach((value) => {
        if (value.GroupID != 99) {
          var str1 = value.Name;
          var mainmenuURL;
          if (
            value.Name == "Sessions" &&
            self.$store.state.eventDefaultSessionPage == "/session_cal"
          )
            mainmenuURL = "/session_cal";
          else if (
            value.Name == "Resources" &&
            self.$store.state.eventDefaultSessionPage == "/session_cal"
          )
            mainmenuURL = "/tasks";
          else mainmenuURL = value.PageUrl;
          if (mainmenuURL === "") {
            mainmenuURL = "#" + str1;
          }
          if (str1[str1.length - 1] == ".") str1 = str1.slice(0, -1);
          var subMenu;
          if (value.SubMenu === undefined) {
            subMenu = [];
          } else {
            var str2 = subMenu.Name;
            if (str2[str2.length - 1] == ".") str2 = str2.slice(0, -1);
            subMenu.push({
              rowDivId: "row" + str1,
              Name: subMenu.Name,
              IconUrl: self.getCDNUrl(subMenu.IconUrl),
              PageUrl: subMenu.PageUrl,
            });
          }
          if (![1011, 1024].includes(value.MenuID)) {
            if (value.PageUrl !== "") {
              self.MenuData.push({
                MenuID: value.MenuID,
                IconUrl: self.getCDNUrl(value.IconUrl),
                PageUrl: mainmenuURL,
                ExternalPageUrl: value.ExternalPageUrl,
                RoomId: value.RoomId == undefined ? "" : value.RoomId,
                DisplayLabel: value.DisplayLabel,
                DisplayLabel_fr:
                  value.DisplayLabel_fr == undefined
                    ? ""
                    : value.DisplayLabel_fr,
                DisplayLabel_zh:
                  value.DisplayLabel_zh == undefined
                    ? ""
                    : value.DisplayLabel_zh,
                DisplayLabel_de:
                  value.DisplayLabel_de == undefined
                    ? ""
                    : value.DisplayLabel_de,
                DisplayLabel_es:
                  value.DisplayLabel_es == undefined
                    ? ""
                    : value.DisplayLabel_es,
                SubMenu: subMenu,
                tab: "",
              });
              self.AllMenuData.push({
                MenuID: value.MenuID,
                IconUrl: self.getCDNUrl(value.IconUrl),
                PageUrl: mainmenuURL,
                ExternalPageUrl: value.ExternalPageUrl,
                DisplayLabel: value.DisplayLabel,
                DisplayLabel_fr:
                  value.DisplayLabel_fr == undefined
                    ? ""
                    : value.DisplayLabel_fr,
                DisplayLabel_zh:
                  value.DisplayLabel_zh == undefined
                    ? ""
                    : value.DisplayLabel_zh,
                DisplayLabel_de:
                  value.DisplayLabel_de == undefined
                    ? ""
                    : value.DisplayLabel_de,
                DisplayLabel_es:
                  value.DisplayLabel_es == undefined
                    ? ""
                    : value.DisplayLabel_es,
                SubMenu: subMenu,
                RoomId: value.RoomId == undefined ? "" : value.RoomId,
                tab: "",
              });
            } else {
              //alert("B" + mainmenuURL);
              self.MenuData.push({
                MenuID: value.MenuID,
                IconUrl: self.getCDNUrl(value.IconUrl),
                PageUrl: mainmenuURL,
                ExternalPageUrl: value.ExternalPageUrl,
                DisplayLabel: value.DisplayLabel,
                DisplayLabel_fr:
                  value.DisplayLabel_fr == undefined
                    ? ""
                    : value.DisplayLabel_fr,
                DisplayLabel_zh:
                  value.DisplayLabel_zh == undefined
                    ? ""
                    : value.DisplayLabel_zh,
                DisplayLabel_de:
                  value.DisplayLabel_de == undefined
                    ? ""
                    : value.DisplayLabel_de,
                DisplayLabel_es:
                  value.DisplayLabel_es == undefined
                    ? ""
                    : value.DisplayLabel_es,
                SubMenu: subMenu,
                RoomId: value.RoomId == undefined ? "" : value.RoomId,
                tab: "data-toggle:'tab'",
              });
              self.AllMenuData.push({
                MenuID: value.MenuID,
                IconUrl: self.getCDNUrl(value.IconUrl),
                PageUrl: mainmenuURL,
                ExternalPageUrl: value.ExternalPageUrl,
                DisplayLabel: value.DisplayLabel,
                DisplayLabel_fr:
                  value.DisplayLabel_fr == undefined
                    ? ""
                    : value.DisplayLabel_fr,
                DisplayLabel_zh:
                  value.DisplayLabel_zh == undefined
                    ? ""
                    : value.DisplayLabel_zh,
                DisplayLabel_de:
                  value.DisplayLabel_de == undefined
                    ? ""
                    : value.DisplayLabel_de,
                DisplayLabel_es:
                  value.DisplayLabel_es == undefined
                    ? ""
                    : value.DisplayLabel_es,
                SubMenu: subMenu,
                RoomId: value.RoomId == undefined ? "" : value.RoomId,
                tab: "data-toggle:'tab'",
              });
            }
          }
        }
      });
    },
    getWidth() {
      this.$nextTick(() => {
        // let width = document.getElementById("leftmenu")
        //   ? document.getElementById("leftmenu").offsetWidth
        //   : 0;
        if (screen.width >= 768 && screen.width <= 1260) {
          this.bodyWith = `width:100%`;
          self.hideLeftmenuMobile = true;
        } else {
          //this.bodyWith = `width:calc(100% - ${width}px) !important`;
          this.bodyWith = `width:100% !important`;
          self.hideLeftmenuMobile = false;
        }
      });
    },
    onHideNotification() {
      self.hideNotificationClicked = true;
      self.hideNotification();
    },
    hideNotification() {
      self.displayYelloPopupNotification = false;
      self.updateMeetingNotification(self.notificationId);
    },
    loadBannerRedirectUrl: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      let self = this;
      //-----------ujiya spl bannerRedirect-----------------------
      self.bannerRedirectURL = "";
      if (document.getElementById("routerlnkBanner")) {
        document.getElementById("routerlnkBanner").href = "#";
        document.getElementById("routerlnkBanner").target = "";

        if (obj.EventBannerRedirect !== undefined) {
          if (obj.EventBannerRedirect.length > 0) {
            console.log(
              "EventBannerRedirect store - " + obj.EventBannerRedirect
            );
            self.bannerRedirectURL = obj.EventBannerRedirect;
            document.getElementById("routerlnkBanner").href =
              obj.EventBannerRedirect;

            document.getElementById("routerlnkBanner").target = "_blank";
          }
        }
      }
      //----------------------------------------------------------
    },

    CheckSubscribitionForWebPush: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));

      var currentToken = obj.loggedInDeviceToken;

      if (obj !== undefined) {
        if (obj.user !== undefined) {
          if (obj.user.length > 0) {
            if (obj.user[0].id !== undefined) {
              var NotificationListId = obj.user[0].id;

              if (obj.eventcollectionname !== "") {
                var docRef = db
                  .collection(obj.eventcollectionname)
                  .doc("SubscribersList")
                  .collection("Subscriptions")
                  .doc(NotificationListId);

                docRef
                  .get()
                  .then(function (doc) {
                    if (doc.exists) {
                      var dvce = doc.data().Devices;
                      for (var i = 0; i < dvce.length; i++) {
                        if (dvce[i].DeviceToken == currentToken) {
                          self.IsSubscribed = dvce[i].IsOptIn;
                          break;
                        }
                      }
                    }
                    self.$store.commit(
                      "GetPopupNotification",
                      self.IsSubscribed
                    );
                  })
                  .catch(function (error) {
                    console.log("Error :", error);
                  });
              }
            }
          }
        }
      }
    },
    SubscribeForWebPush() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));

      if (obj.eventcollectionname !== "") {
        var ChkSubscribed = eventsubscribe.SubscribeUser(
          obj.eventcollectionname,
          obj.user[0].Email,
          obj.user[0].id,
          obj.ShowNotification
        );

        if (ChkSubscribed) {
          $("#btnSubscribe").hide();
          $("#btnUnsubscribe").show();
        } else {
          $("#btnSubscribe").show();
          $("#btnUnsubscribe").hide();
        }

        // //if (confirm("Do you want to subscribe for web push notifications?")) {
        // //}
        // var obj = JSON.parse(window.localStorage.getItem("my-app"));

        // var NotificationListId = obj.user[0].id;

        // var docRef = db
        //   .collection(obj.eventcollectionname)
        //   .doc("NotificationList")
        //   .collection("Notifications")
        //   .doc(NotificationListId);

        // docRef
        //   .get()
        //   .then(function (doc) {
        //     if (doc.exists) {
        //
        //       self.IsSubscribed = false;
        //       $("#btnSubscribe").hide();
        //       $("#btnUnsubscribe").show();
        //     } else {
        //
        //       if (
        //         confirm("Do you want to subscribe for web push notifications?")
        //       ) {
        //
        //         eventsubscribe.SubscribeUser(
        //           obj.eventcollectionname,
        //           obj.user[0].Email,
        //           obj.user[0].id
        //         );
        //
        //         alert("You are subscribed for the notification.")
        //          self.IsSubscribed = true;
        //          $("#btnSubscribe").hide();
        //          $("#btnUnsubscribe").show();
        //       }
        //     }
        //   })
        //   .catch(function (error) {
        //     console.log("Error :", error);
        //   });

        // if (ChkSubscribed) {
        //   $("#btnSubscribe").hide();
        //   $("#btnUnsubscribe").show();
        // } else {
        //   $("#btnSubscribe").show();
        //   $("#btnUnsubscribe").hide();
        // }
      }
    },
    UnSubscribeForWebPush() {
      //alert("UnSubscribeForWebPush");
      var obj = JSON.parse(window.localStorage.getItem("my-app"));

      if (obj.eventcollectionname !== "") {
        var currentToken = obj.loggedInDeviceToken;
        var NotificationListId = obj.user[0].id;

        var MdocRef = db
          .collection(obj.eventcollectionname)
          .doc("SubscribersList")
          .collection("Subscriptions")
          .doc(NotificationListId);

        //---------------------- FCM un subscribe---------------------------------------------------

        var xAPIkey =
          "AAAAG8IFqjo:APA91bFOKr3FfPU-5AvL7MT3iKTVoibWIiCKGGRW03nXEmfqbyKfdgN_13R9sTV44JgXWsAN-tR4YGN-6UNcPn04otBHPoeC6ST3mf57aouf9BAjKlwv-X79cs4QTBEW7jbCbo1hqV4W";

        console.log("token to unsubscribe:- " + currentToken);
        //alert("token to unsubscribe:- " + currentToken);
        // let docObjdevce = new Object({
        //   DeviceToken: currentToken,
        //   DeviceType: "Web",
        //   userAgent: navigator.userAgent,
        //   IsOptIn: false,
        // });
        //+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

        MdocRef.get().then(function (doc) {
          if (doc.exists) {
            var dvce = doc.data().Devices;

            if (dvce.length > 1) {
              if (
                confirm(
                  "Do you want to unsubscribe from all the other devices?"
                )
              ) {
                for (var i = 0; i < dvce.length; i++) {
                  dvce[i].IsOptIn = false;
                }
              } else {
                for (var k = 0; k < dvce.length; k++) {
                  if (dvce[k].DeviceToken == currentToken) {
                    dvce[k].IsOptIn = false;
                    break;
                  }
                }
              }
            } else {
              if (
                confirm(
                  "Do you want to unsubscribe from web push notifications?"
                )
              ) {
                for (var j = 0; j < dvce.length; j++) {
                  dvce[j].IsOptIn = false;
                }
              }
            }

            MdocRef.update({
              Devices: dvce,
            })
              .then(function () {
                self.IsSubscribed = false;
                self.$store.commit("GetPopupNotification", self.IsSubscribed);
                var postData = "";
                var apiUrl = "https://iid.googleapis.com/iid/v1:batchRemove";
                postData = {
                  to: "/topics/" + obj.eventcollectionname, //OA_UAT_C1591904892446E1591907102804"
                  registration_tokens: [currentToken], // ["fbjUumBgWipwmL0DlVOJ7_:APA91bGBvwqHwvoLE_hg2lLt1Y3O45aq_5F4WngCWM5oRkXLLBtjso7_xYu8PmIstjyCkb27pPFBLiWfhTLy-3iwb_whqRu2BE-wmuy8BN3Ae7U24df9BCUtieqnp3ImfPaAt_R-6EwD",],
                };
                console.log(JSON.stringify(postData));

                let headers = {
                  "Content-Type": "application/json",
                  Authorization: "key=" + xAPIkey,
                };
                axios
                  .post(apiUrl, JSON.stringify(postData), {
                    headers: headers,
                  })
                  .then((response) => {
                    self.IsSubscribed = false;
                    console.log("Document successfully deleted!");
                    alert("You are unsubscribed from the notification.");
                    console.log(response.data.status);
                  })
                  .catch((error) => {
                    console.log(error);
                  });

                $("#btnSubscribe").show();
                $("#btnUnsubscribe").hide();
              })
              .catch(function (error) {
                console.log("Error removing document: " + error);
                $("#btnSubscribe").show();
                $("#btnUnsubscribe").hide();
              });
          }
        });
      }
    },
    OpenMyMeetings: function (NotificationId) {
      self.updateMeetingNotification(NotificationId);
      router.push("/mymeetings");
    },
    updateMeetingNotification: function (NotificationId) {
      self.isDialing = false;
      self.dialingNotificationId = "";
      var obj = JSON.parse(window.localStorage.getItem("my-app"));

      if (obj.eventcollectionname !== "") {
        var docMSRef = db
          .collection(obj.eventcollectionname)
          .doc("AttendeeList")
          .collection("Attendees")
          .doc(obj.user[0].id)
          .collection("Notifications")
          .doc(NotificationId);

        docMSRef
          .get()
          .then(function (doc) {
            if (doc.exists) {
              docMSRef
                .update({
                  isSeen: "1",
                  LastModifiedDate: new Date(),
                })
                .then(function () {
                  //
                  console.error("Updated Notifications");
                  //self.displayNotification();
                  $("#notification").modal("hide");
                })
                .catch(function (error) {
                  console.error("Error updating Notifications: ", error);
                });
            }
          })
          .catch(function (error) {
            console.log("Error saving Notifications:", error);
          });
      }
    },
    displayMyNotifications() {
      //if (self.NotificationData.length > 0) {
      $("#notification").modal("show");
      self.markAsReadAllNotification();
      //}
    },
    markAsReadAllNotification: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));

      if (obj.eventcollectionname !== "") {
        db.collection(obj.eventcollectionname)
          .doc("AttendeeList")
          .collection("Attendees")
          .doc(obj.user[0].id)
          .collection("Notifications")
          .where("isSeen", "==", "0")
          .get()
          .then(function (querySnapshot) {
            querySnapshot.docs.forEach(function (doc) {
              let notificationId = doc.id;
              db.collection(obj.eventcollectionname)
                .doc("AttendeeList")
                .collection("Attendees")
                .doc(obj.user[0].id)
                .collection("Notifications")
                .doc(notificationId)
                .update({
                  isSeen: "1",
                  LastModifiedDate: new Date(),
                })
                .then(function () {
                  //
                  //console.error("Updated Notifications");
                  //self.displayNotification();
                  //$("#notification").modal("hide");
                })
                .catch(function (error) {
                  console.error("Error updating Notifications: ", error);
                });
            });
          })
          .catch(function (error) {
            console.log("Error saving Notifications:", error);
          });
      }
    },
    declineJoinMeeting: function (NotificationId) {
      var filteredData = self.NotificationData.filter(function (item) {
        return item.NotificationId == NotificationId;
      });
      if (filteredData.length > 0 && filteredData[0].Sender) {
        var notification = filteredData[0];
        let headers = {
          "content-type": "application/json",
          Authorization: "Bearer " + self.getSessionToken(),
        };
        let requestData = {
          key: {
            instanceId: "OA_UAT",
            clientId: self.$store.state.client[0].id,
            eventId: self.$store.state.eventid,
            channelId: "",
            meetingId: notification.MeetingId,
            meetingType: "One2OneMeeting/MeetingDeclined",
          },
          data: [
            {
              AttendeeId: notification.Sender.AttendeeId,
              Name: notification.Sender.Name,
              ProfilePictureURL: notification.Sender.ProfilePictureURL,
            },
          ],
        };
        axios
          .post(APIs.SendMeetingPush, requestData, {
            headers: headers,
          })
          .then((responseData) => {
            //self.hideLoader();
            //alert("SendMeetingPush Success");
            console.log(responseData);
          })
          .catch((error) => {
            //alert("SendMeetingPush Failure");
            console.log("Start RT: " + error);
          });
      }
    },
    displayNotification: function (eventCollection, attendeeId) {
      if (notificationListener) {
        notificationListener();
        notificationListener = null;
      }
      self.NotificationData = [];
      if (eventCollection && attendeeId) {
        var obj = JSON.parse(window.localStorage.getItem("my-app"));
        if (obj) {
          self.GetPopupNotification = obj.getPopupNotification ? true : false;
        }
        var docMSRef = db
          .collection(eventCollection)
          .doc("AttendeeList")
          .collection("Attendees")
          .doc(attendeeId)
          .collection("Notifications");

        var firstLoad = true;
        notificationListener = docMSRef
          .orderBy("Timestamp", "desc")
          .onSnapshot((querySnapshot) => {
            let changes = querySnapshot.docChanges();
            var cnt = 0;
            if (changes.length > 0) {
              changes.forEach((change) => {
                var data = change.doc.data();
                if (change.type == "added") {
                  if (self.GetPopupNotification) {
                    if (cnt == 0 && data.isSeen == "0") {
                      cnt++;
                      self.notificationId = change.doc.id;
                      self.NotificationTitle = data.NotificationTitle;
                      self.NotificationMessage = data.NotificationMessage;
                      self.displayYelloPopupNotification = true;
                    }
                  }
                  self.NotificationIndex++;
                  var notification = {
                    Index: self.NotificationIndex,
                    NotificationId: change.doc.id,
                    Name: data.Name,
                    NameInitial: common.getInitials(data.Name),
                    Message: data.NotificationMessage,
                    Title: data.NotificationTitle,
                    NotifyTypeIndex: data.NotifyTypeIndex,
                    Timestamp: data.Timestamp,
                    CTimestamp: new Date().getTime(),
                    Sender: data.Sender,
                    Module: data.Module,
                    Time: moment(
                      new Date(
                        (data.CreatedDate.seconds
                          ? data.CreatedDate.seconds
                          : data.CreatedDate._seconds) * 1000
                      )
                    ).fromNow(),
                    ExpireInMinutes: data.ExpireInMinutes,
                    isSeen: data.isSeen,
                    alreadyDialed: data.isSeen == "1",
                    Image: data.ProfilePictureURL,
                    Initials: data.Initials,
                    EventLogo: data.EventLogo,
                    ChannelId: data.ChannelId,
                    MeetingId: data.MeetingId,
                    JoinLink: "/livestage/" + data.ChannelId,
                    MeetingType: data.MeetingType,
                    UserIdList: data.UserIdList ? data.UserIdList : [],
                  };
                  // if (!notification.Sender) {
                  //   notification.Sender = {};
                  // }
                  // if (!notification.Sender.AttendeeId) {
                  //   notification.Sender.AttendeeId = "";
                  // }
                  // if (!notification.Sender.Name) {
                  //   notification.Sender.Name = "";
                  // } else {
                  //   notification.Name = notification.Sender.Name;
                  // }
                  // notification.Sender.NameInitial = common.getInitials(
                  //   notification.Sender.Name
                  // );
                  // notification.NameInitial = common.getInitials(
                  //   notification.Name
                  // );
                  // if (!notification.Sender.ProfilePictureURL) {
                  //   notification.Sender.ProfilePictureURL = "";
                  // } else {
                  //   notification.Image = notification.Sender.ProfilePictureURL;
                  // }
                  let message = notification.Message.split(" ");
                  for (let i = 0; i < message.length; i++) {
                    message[i] = message[i].trim();
                    if (self.isValidURL(message[i])) {
                      message[i] =
                        "<a href='" +
                        message[i] +
                        "' target='_blank'>" +
                        message[i] +
                        "</a>";
                    } else if (self.isValidEmail(message[i])) {
                      message[i] =
                        "<a href='mailto:" +
                        message[i] +
                        "' target='_blank'>" +
                        message[i] +
                        "</a>";
                    }
                    notification.Message = message.join(" ");
                  }
                  if (firstLoad) {
                    notification.CTimestamp =
                      notification.Timestamp.seconds * 1000;
                    if (
                      !self.videoCallNotification[notification.MeetingId] &&
                      [
                        "VideoCalling/CallStarted",
                        "One2OneMeeting/MeetingJoined",
                      ].includes(notification.MeetingType)
                    ) {
                      self.videoCallNotification[notification.MeetingId] = {
                        NotificationId: notification.NotificationId,
                        MeetingId: notification.MeetingId,
                        MeetingType: notification.MeetingType,
                      };
                    }
                    self.NotificationData.push(notification);
                  } else {
                    if (
                      [
                        "VideoCalling/CallStarted",
                        "One2OneMeeting/MeetingJoined",
                      ].includes(notification.MeetingType)
                    ) {
                      self.videoCallNotification[notification.MeetingId] =
                        notification.NotificationId;
                      self.videoCallNotification[notification.MeetingId] = {
                        NotificationId: notification.NotificationId,
                        MeetingId: notification.MeetingId,
                        MeetingType: notification.MeetingType,
                      };
                      self.createVideoCallListener(notification.MeetingId);
                    } else if (
                      notification.MeetingType == "VideoCalling/CallDeclined"
                    ) {
                      self.onClosePlayerDialog(true, notification.Name);
                    }
                    self.NotificationData.unshift(notification);
                  }
                  //if (
                  //  self.NotificationData[
                  //    self.NotificationData.length - 1
                  //  ].Image == ""
                  //) {
                  //  self.NotificationData[
                  //    self.NotificationData.length - 1
                  //  ].Image =
                  //    self.NotificationData[
                  //      self.NotificationData.length - 1
                  //    ].EventLogo;
                  //}
                  if (
                    !self.playerDialog &&
                    !self.isDialing &&
                    !self.dialingNotificationId &&
                    notification.isSeen == "0" &&
                    notification.MeetingId &&
                    notification.MeetingId.includes("room-") &&
                    notification.Sender &&
                    notification.Sender.AttendeeId != self.uid &&
                    notification.Timestamp.seconds * 1000 +
                      (self.dialTime + 1) * 1000 +
                      self.extraTime >
                      self.correntTimeMS
                  ) {
                    self.dialingNotificationId = notification.NotificationId;
                    self.dialTimeRemaining = self.dialTime;
                    self.isDialing = true;
                  }
                } else if (change.type == "modified") {
                  var filteredData = self.NotificationData.filter(function (
                    item
                  ) {
                    return item.NotificationId == change.doc.id;
                  });
                  if (filteredData.length > 0) {
                    filteredData[0].isSeen = data.isSeen;
                  }
                }
              });
              if (firstLoad) {
                self.createVideoCallListener();
              }
            }
            firstLoad = false;
          });
      }
    },
    createVideoCallListener(meetingId) {
      if (self.event_collectionName) {
        var allMeetings = [];
        if (meetingId) {
          allMeetings.push(meetingId);
        } else {
          allMeetings = Object.keys(self.videoCallNotification);
        }
        if (allMeetings.length > 0) {
          for (var i = 0; i < allMeetings.length; i++) {
            // if (allMeetings[i] != "room-dc0ead6e-b8eb-4ae7-b3e1-2393976d8da8") {
            //   continue;
            // }
            if (self.videoCallNotification[allMeetings[i]].listener) {
              self.videoCallNotification[allMeetings[i]].listener();
              self.videoCallNotification[allMeetings[i]].listener = null;
            }
            self.videoCallNotification[allMeetings[i]].listener = db
              .collection(self.event_collectionName)
              .doc("UserVideoActivity")
              .collection("ChatRoom")
              .doc(allMeetings[i])
              .collection("Participances")
              .onSnapshot((querySnapshot) => {
                var mtngId = "";
                if (querySnapshot.docs.length > 0) {
                  mtngId = querySnapshot.docs[0].ref.path.split("/")[3];
                  if (mtngId) {
                    self.videoCallNotification[mtngId].Occupied = 0;
                    querySnapshot.forEach(function (doc) {
                      let data = doc.data();
                      if (data.IsActive) {
                        self.videoCallNotification[mtngId].Occupied++;
                      }
                    });
                    if (self.videoCallNotification[mtngId].Occupied == 0) {
                      if (self.videoCallNotification[mtngId].listener) {
                        self.videoCallNotification[mtngId].listener();
                        self.videoCallNotification[mtngId].listener = null;
                      }
                    }
                    var allKeys = Object.keys(
                      self.videoCallNotification[mtngId]
                    );
                    var videoCallNotification = {};
                    for (var i = 0; i < allKeys.length; i++) {
                      videoCallNotification[allKeys[i]] =
                        self.videoCallNotification[mtngId][allKeys[i]];
                    }
                    delete self.videoCallNotification[mtngId];
                    self.videoCallNotification[mtngId] = videoCallNotification;
                  }
                }
              });
          }
        }
      }
    },
    getMenuDetails: function () {
      let that = this;
      var tempAllMenuData = [];
      var tempLeftData = [];
      var tempMenuData = [];
      var tempMenuIDs = [];
      var eventCollection = "";
      if (self.event_collectionName) {
        eventCollection = self.event_collectionName;
      } else if (self.publicEventCollection) {
        eventCollection = self.publicEventCollection;
      }
      if (eventCollection) {
        db.collection(eventCollection)
          .doc("Menu")
          .get()
          .then((doc) => {
            tempAllMenuData = [];
            tempLeftData = [];
            tempMenuData = [];
            tempMenuIDs = [];

            // self.MenuIDs = [];
            // self.MenuData = [];
            // self.AllMenuData = [];
            // self.LeftData = [];
            // self.MenuData.splice(0, self.MenuData.length);
            tempMenuData.splice(0, tempMenuData.length);
            var data = doc.data();
            $.each(data.AllMenu, function (key, value) {
              if (!tempMenuIDs.includes(value.MenuID)) {
                if (
                  (self.event_collectionName || value.IsPublic) &&
                  value.IsPublished
                ) {
                  tempMenuIDs.push(value.MenuID);
                }
              }
              if (![1011, 1024].includes(value.MenuID)) {
                if (value.GroupID != 99) {
                  var str1 = value.Name;
                  var mainmenuURL;
                  if (
                    value.Name == "Lobby" &&
                    that.$store.state.DefaultLoginLandingPage == "/clientLobby"
                  ) {
                    mainmenuURL = "/mainlobby";
                  }
                  if (
                    value.Name == "Sessions" &&
                    that.$store.state.eventDefaultSessionPage == "/session_cal"
                  )
                    mainmenuURL = "/session_cal";
                  else if (
                    value.Name == "Resources" &&
                    that.$store.state.eventDefaultSessionPage == "/session_cal"
                  )
                    mainmenuURL = "/tasks";
                  else mainmenuURL = value.PageUrl;
                  if (mainmenuURL === "") {
                    mainmenuURL = "#" + str1;
                  }
                  if (str1[str1.length - 1] == ".") str1 = str1.slice(0, -1);
                  var subMenu;
                  if (value.SubMenu === undefined) {
                    subMenu = [];
                  } else {
                    var str2 = subMenu.Name;
                    if (str2[str2.length - 1] == ".") str2 = str2.slice(0, -1);
                    subMenu.push({
                      rowDivId: "row" + str1,
                      Name: subMenu.Name,
                      IconUrl: self.getCDNUrl(subMenu.IconUrl),
                      PageUrl: subMenu.PageUrl,
                    });
                  }

                  if (
                    (self.event_collectionName || value.IsPublic) &&
                    value.IsPublished
                  ) {
                    if (value.PageUrl !== "") {
                      tempMenuData.push({
                        MenuID: value.MenuID,
                        IconUrl: self.getCDNUrl(value.IconUrl),
                        PageUrl: mainmenuURL,
                        ExternalPageUrl: value.ExternalPageUrl,
                        DisplayOrder: value.DisplayOrder,
                        DisplayLabel: value.DisplayLabel,
                        DisplayLabel_fr:
                          value.DisplayLabel_fr == undefined
                            ? ""
                            : value.DisplayLabel_fr,
                        DisplayLabel_zh:
                          value.DisplayLabel_zh == undefined
                            ? ""
                            : value.DisplayLabel_zh,
                        DisplayLabel_de:
                          value.DisplayLabel_de == undefined
                            ? ""
                            : value.DisplayLabel_de,
                        DisplayLabel_es:
                          value.DisplayLabel_es == undefined
                            ? ""
                            : value.DisplayLabel_es,
                        SubMenu: subMenu,
                        RoomId: value.RoomId == undefined ? "" : value.RoomId,
                        tab: "",
                      });
                      tempAllMenuData.push({
                        MenuID: value.MenuID,
                        IconUrl: self.getCDNUrl(value.IconUrl),
                        PageUrl: mainmenuURL,
                        ExternalPageUrl: value.ExternalPageUrl,
                        DisplayOrder: value.DisplayOrder,
                        DisplayLabel: value.DisplayLabel,
                        DisplayLabel_fr:
                          value.DisplayLabel_fr == undefined
                            ? ""
                            : value.DisplayLabel_fr,
                        DisplayLabel_zh:
                          value.DisplayLabel_zh == undefined
                            ? ""
                            : value.DisplayLabel_zh,
                        DisplayLabel_de:
                          value.DisplayLabel_de == undefined
                            ? ""
                            : value.DisplayLabel_de,
                        DisplayLabel_es:
                          value.DisplayLabel_es == undefined
                            ? ""
                            : value.DisplayLabel_es,
                        SubMenu: subMenu,
                        RoomId: value.RoomId == undefined ? "" : value.RoomId,
                        tab: "",
                        IsChatEnabled: value.IsChatEnabled ? true : false,
                      });
                    } else {
                      //alert("B" + mainmenuURL);
                      if (value.MenuID == 1029) {
                        mainmenuURL = "#";
                      }
                      tempMenuData.push({
                        MenuID: value.MenuID,
                        IconUrl: self.getCDNUrl(value.IconUrl),
                        PageUrl: mainmenuURL,
                        ExternalPageUrl: value.ExternalPageUrl,
                        DisplayOrder: value.DisplayOrder,
                        DisplayLabel: value.DisplayLabel,
                        DisplayLabel_fr:
                          value.DisplayLabel_fr == undefined
                            ? ""
                            : value.DisplayLabel_fr,
                        DisplayLabel_zh:
                          value.DisplayLabel_zh == undefined
                            ? ""
                            : value.DisplayLabel_zh,
                        DisplayLabel_de:
                          value.DisplayLabel_de == undefined
                            ? ""
                            : value.DisplayLabel_de,
                        SubMenu: subMenu,
                        RoomId: value.RoomId == undefined ? "" : value.RoomId,
                        tab: "data-toggle:'tab'",
                      });
                      tempAllMenuData.push({
                        MenuID: value.MenuID,
                        IconUrl: self.getCDNUrl(value.IconUrl),
                        PageUrl: mainmenuURL,
                        ExternalPageUrl: value.ExternalPageUrl,
                        DisplayOrder: value.DisplayOrder,
                        DisplayLabel: value.DisplayLabel,
                        DisplayLabel_fr:
                          value.DisplayLabel_fr == undefined
                            ? ""
                            : value.DisplayLabel_fr,
                        DisplayLabel_zh:
                          value.DisplayLabel_zh == undefined
                            ? ""
                            : value.DisplayLabel_zh,
                        DisplayLabel_de:
                          value.DisplayLabel_de == undefined
                            ? ""
                            : value.DisplayLabel_de,
                        SubMenu: subMenu,
                        RoomId: value.RoomId == undefined ? "" : value.RoomId,
                        tab: "data-toggle:'tab'",
                        IsChatEnabled: value.IsChatEnabled ? true : false,
                      });
                    }
                  }
                }
              }
            });
            $.each(data.LeftMenu, function (key, value) {
              if (!tempMenuIDs.includes(value.MenuID)) {
                if (
                  (self.event_collectionName || value.IsPublic) &&
                  value.IsPublished
                ) {
                  tempMenuIDs.push(value.MenuID);
                }
              }
              if (![1011, 1024].includes(value.MenuID)) {
                if (value.GroupID != 99) {
                  var str1 = value.Name;
                  var mainmenuURL = value.PageUrl;
                  if (mainmenuURL === "") {
                    mainmenuURL = "#" + str1;
                  }
                  if (str1[str1.length - 1] == ".") str1 = str1.slice(0, -1);

                  if (
                    (self.event_collectionName || value.IsPublic) &&
                    value.IsPublished
                  ) {
                    if (value.PageUrl !== "") {
                      //alert("A" + mainmenuURL);
                      tempLeftData.push({
                        MenuID: value.MenuID,
                        IconUrl: self.getCDNUrl(value.IconUrl),
                        PageUrl: mainmenuURL,
                        ExternalPageUrl: value.ExternalPageUrl,
                        DisplayOrder: value.DisplayOrder,
                        RoomId: value.RoomId == undefined ? "" : value.RoomId,
                        DisplayLabel: value.DisplayLabel,
                        DisplayLabel_fr:
                          value.DisplayLabel_fr == undefined
                            ? ""
                            : value.DisplayLabel_fr,
                        DisplayLabel_zh:
                          value.DisplayLabel_zh == undefined
                            ? ""
                            : value.DisplayLabel_zh,
                        DisplayLabel_de:
                          value.DisplayLabel_de == undefined
                            ? ""
                            : value.DisplayLabel_de,
                        DisplayLabel_es:
                          value.DisplayLabel_es == undefined
                            ? ""
                            : value.DisplayLabel_es,
                      });
                      tempAllMenuData.push({
                        MenuID: value.MenuID,
                        IconUrl: self.getCDNUrl(value.IconUrl),
                        PageUrl: mainmenuURL,
                        ExternalPageUrl: value.ExternalPageUrl,
                        DisplayOrder: value.DisplayOrder,
                        RoomId: value.RoomId == undefined ? "" : value.RoomId,
                        DisplayLabel: value.DisplayLabel,
                        DisplayLabel_fr:
                          value.DisplayLabel_fr == undefined
                            ? ""
                            : value.DisplayLabel_fr,
                        DisplayLabel_zh:
                          value.DisplayLabel_zh == undefined
                            ? ""
                            : value.DisplayLabel_zh,
                        DisplayLabel_de:
                          value.DisplayLabel_de == undefined
                            ? ""
                            : value.DisplayLabel_de,
                        DisplayLabel_es:
                          value.DisplayLabel_es == undefined
                            ? ""
                            : value.DisplayLabel_es,
                        IsChatEnabled: value.IsChatEnabled ? true : false,
                      });
                    } else {
                      //alert("B" + mainmenuURL);
                      if (value.MenuID == 1029) {
                        mainmenuURL = "#";
                      }
                      tempLeftData.push({
                        MenuID: value.MenuID,
                        IconUrl: self.getCDNUrl(value.IconUrl),
                        PageUrl: mainmenuURL,
                        ExternalPageUrl: value.ExternalPageUrl,
                        DisplayOrder: value.DisplayOrder,
                        RoomId: value.RoomId == undefined ? "" : value.RoomId,
                        DisplayLabel: value.DisplayLabel,
                        DisplayLabel_fr:
                          value.DisplayLabel_fr == undefined
                            ? ""
                            : value.DisplayLabel_fr,
                        DisplayLabel_zh:
                          value.DisplayLabel_zh == undefined
                            ? ""
                            : value.DisplayLabel_zh,
                        DisplayLabel_de:
                          value.DisplayLabel_de == undefined
                            ? ""
                            : value.DisplayLabel_de,
                        DisplayLabel_es:
                          value.DisplayLabel_es == undefined
                            ? ""
                            : value.DisplayLabel_es,
                      });
                      tempAllMenuData.push({
                        MenuID: value.MenuID,
                        IconUrl: self.getCDNUrl(value.IconUrl),
                        PageUrl: mainmenuURL,
                        ExternalPageUrl: value.ExternalPageUrl,
                        DisplayOrder: value.DisplayOrder,
                        RoomId: value.RoomId == undefined ? "" : value.RoomId,
                        DisplayLabel: value.DisplayLabel,
                        DisplayLabel_fr:
                          value.DisplayLabel_fr == undefined
                            ? ""
                            : value.DisplayLabel_fr,
                        DisplayLabel_zh:
                          value.DisplayLabel_zh == undefined
                            ? ""
                            : value.DisplayLabel_zh,
                        DisplayLabel_de:
                          value.DisplayLabel_de == undefined
                            ? ""
                            : value.DisplayLabel_de,
                        DisplayLabel_es:
                          value.DisplayLabel_es == undefined
                            ? ""
                            : value.DisplayLabel_es,
                        IsChatEnabled: value.IsChatEnabled ? true : false,
                      });
                    }
                  }
                }
              }
            });

            if (tempLeftData.length <= 0) {
              $("#leftMenuParent").hide().addClass("hide");
              $("#leftMenuParent").hide();
              self.bodyWith = "width:100%";
            } else {
              $("#leftMenuParent").removeClass("hide");
              $("#leftMenuParent").show();
              self.getWidth();
              setTimeout(() => {
                self.getWidth();
              }, 3000);
              //$("#leftmenu").show();
            }

            //---------------Notification menu settings-----------------
            if (data.ShowNotification != undefined) {
              console.log("Show Notification :- " + data.ShowNotification);
              //  alert("obj.ShowNotification App vue:- " + data.ShowNotification);
              self.showNotification = data.ShowNotification;
              store.commit("setNotification", self.showNotification);
            }
            //------------------------------------------------------
            db.collection(eventCollection)
              .doc("LandingPages")
              .get()
              .then((doc) => {
                if (doc.exists) {
                  var data = doc.data();
                  data.Pages.forEach(function (value) {
                    if (value.IsPublished) {
                      if (value.PositionInPage == 1) {
                        var menu = tempMenuData.filter(function (item) {
                          return item.MenuID == value.MenuID;
                        });
                        if (menu.length == 0) {
                          tempMenuData.push({
                            MenuID: value.MenuID,
                            IconUrl: self.getCDNUrl(value.IconUrl),
                            PageUrl: "/page/" + value.PageUrl,
                            DisplayOrder: value.DisplayOrder,
                            ExternalPageUrl: "",
                            RoomId: "",
                            DisplayLabel: value.DisplayLabel,
                            DisplayLabel_fr: value.DisplayLabel_fr || "",
                            DisplayLabel_zh: value.DisplayLabel_zh || "",
                            DisplayLabel_de: value.DisplayLabel_de || "",
                            DisplayLabel_es: value.DisplayLabel_es || "",
                            SubMenu: null,
                            tab: "data-toggle:'tab'",
                          });

                          tempAllMenuData.push({
                            MenuID: value.MenuID,
                            IconUrl: self.getCDNUrl(value.IconUrl),
                            PageUrl: "/page/" + value.PageUrl,
                            DisplayOrder: value.DisplayOrder,
                            ExternalPageUrl: "",
                            RoomId: "",
                            DisplayLabel: value.DisplayLabel,
                            DisplayLabel_fr: value.DisplayLabel_fr || "",
                            DisplayLabel_zh: value.DisplayLabel_zh || "",
                            DisplayLabel_de: value.DisplayLabel_de || "",
                            DisplayLabel_es: value.DisplayLabel_es || "",
                            SubMenu: null,
                            tab: "data-toggle:'tab'",
                            IsChatEnabled: value.IsChatEnabled ? true : false,
                          });
                        }
                      } else if (value.PositionInPage == 2) {
                        var leftMenu = tempLeftData.filter(function (item) {
                          return item.MenuID == value.MenuID;
                        });
                        if (leftMenu.length == 0) {
                          tempLeftData.push({
                            MenuID: value.MenuID,
                            IconUrl: self.getCDNUrl(value.IconUrl),
                            PageUrl: "/page/" + value.PageUrl,
                            DisplayOrder: value.DisplayOrder,
                            ExternalPageUrl: "",
                            RoomId: "",
                            DisplayLabel: value.DisplayLabel,
                            DisplayLabel_fr: value.DisplayLabel_fr || "",
                            DisplayLabel_zh: value.DisplayLabel_zh || "",
                            DisplayLabel_de: value.DisplayLabel_de || "",
                            DisplayLabel_es: value.DisplayLabel_es || "",
                            SubMenu: null,
                            tab: "data-toggle:'tab'",
                          });
                          tempAllMenuData.push({
                            MenuID: value.MenuID,
                            IconUrl: self.getCDNUrl(value.IconUrl),
                            PageUrl: "/page/" + value.PageUrl,
                            DisplayOrder: value.DisplayOrder,
                            ExternalPageUrl: "",
                            RoomId: "",
                            DisplayLabel: value.DisplayLabel,
                            DisplayLabel_fr: value.DisplayLabel_fr || "",
                            DisplayLabel_zh: value.DisplayLabel_zh || "",
                            DisplayLabel_de: value.DisplayLabel_de || "",
                            DisplayLabel_es: value.DisplayLabel_es || "",
                            SubMenu: null,
                            tab: "data-toggle:'tab'",
                            IsChatEnabled: value.IsChatEnabled ? true : false,
                          });
                        }
                      }
                    }
                  });

                  tempMenuData.sort(function (a, b) {
                    let aName = a.DisplayOrder;
                    let bName = b.DisplayOrder;
                    if (aName < bName) {
                      return -1;
                    }
                    if (aName > bName) {
                      return 1;
                    }
                    return 0;
                  });
                  tempLeftData.sort(function (a, b) {
                    let aName = a.DisplayOrder;
                    let bName = b.DisplayOrder;
                    if (aName < bName) {
                      return -1;
                    }
                    if (aName > bName) {
                      return 1;
                    }
                    return 0;
                  });
                }
              })
              .catch((error) => {
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
            self.MenuData = self.PublicMenuList;
            self.AllMenuData = self.PublicMenuList;
          })
          .finally(() => {
            //alert("in finally");

            self.AllMenuData = tempAllMenuData;
            self.LeftData = tempLeftData;
            self.MenuData = tempMenuData;
            self.MenuIDs = tempMenuIDs;
          });

        //self.getSettings();
      }
    },
    setHomeMenu() {
      let self = this;
      if (self.event_collectionName != "") {
        db.collection(self.event_collectionName)
          .doc("EventInfo")
          .get()
          .then((doc) => {
            if (doc.exists) {
              //var data = doc.data();
              //if (data.LobbyType == 1) {
              self.homeUrl = "/lobby";
              //} else {
              //  self.homeUrl = "/lobby2";
              //}
            }
          })
          .catch((error) => {
            console.log("Error getting documents:", error);
            //alert(error);
          });

        $("#open-button").attr("style", "display:block !important");
      }
    },
    hovermenu: function (obj) {
      $(".tab-content-one .tab-pane").removeClass("active");
      var tabContentSelector = $(obj).attr("href");
      $(obj).tab("show");
      $(tabContentSelector).addClass("active");
    },
    onMobileMenuCLick(item) {
      console.log("item=====", item);
      //if (item.PageUrl == "/exhibitor" || item.PageUrl == "/exhibitorshall") {
      //  var obj = JSON.parse(window.localStorage.getItem("my-app"));
      //  if (obj.eventcollectionname !== undefined) {
      //    if (obj.eventcollectionname !== "") {
      //      db.collection(obj.eventcollectionname)
      //        .doc("Settings")
      //        .collection("Exhibitor")
      //        .get()
      //        .then((querySnapshot) => {
      //          querySnapshot.forEach((doc) => {
      //            if (doc.data().IsMouseCursorEnabled === true) {
      //              store.commit("setMouseCursor", true);
      //            } else {
      //              store.commit("setMouseCursor", false);
      //            }
      //            if (doc.data().IsExpoAlertEnabled === true) {
      //              store.commit("setExpoToolTip", true);
      //            } else {
      //              store.commit("setExpoToolTip", false);
      //            }

      //            if (doc.data().EnableEnhancedExpoMode === true) {
      //              if (screen.width > 768) {
      //                router.push("/exhibitorshall");
      //              } else {
      //                router.push("/exhibitorshalllite");
      //              }

      //              store.commit("setAdvExpo", true);
      //            } else if (doc.data().AllowAerialView === true) {
      //              store.commit("setAdvExpo", false);
      //              router.push("/expohallaerialview");
      //            } else if (doc.data().AllowbirdView === true) {
      //              store.commit("setAdvExpo", false);
      //              router.push("/expohallbirdview");
      //            } else {
      //              store.commit("setAdvExpo", false);
      //              router.push("/exhibitor");
      //            }
      //          });
      //        })
      //        .catch((error) => {
      //          console.log("OnMenuClick : " + error);
      //        });
      //    }
      //  }
      //} else {
      router.push(item.PageUrl);
      //}
    },
    updateLeftMenuActive() {
      if (!this.$route || !this.LeftData) {
        this.activeLeftMenuId = null;
        return;
      }
      const normalizePath = (path) => {
        const cleaned = String(path || "")
          .toLowerCase()
          .split("?")[0]
          .split("#")[0]
          .replace(/\/+$/, "");
        return cleaned === "" ? "/" : cleaned;
      };
      const currentPath = normalizePath(this.$route.path);
      let matchedMenuId = null;
      for (const item of this.LeftData.slice(0, this.showLeftMenuBoxes)) {
        const menuPath = normalizePath(
          String(this.getMenuUrl(item.MenuID, String(item.PageUrl)))
        );
        if (!menuPath) continue;
        if (
          currentPath === menuPath ||
          currentPath.startsWith(menuPath + "/")
        ) {
          matchedMenuId = String(item.MenuID);
          break;
        }
      }
      this.activeLeftMenuId = matchedMenuId;
    },
    onMenuCLick: function (obj1, isMobileMenu) {
      if (isMobileMenu == true) {
        $("#headerMenuParent").removeClass("active");
        $("#headerMenuParent").hide();
      }
      if (obj1 && obj1.target) {
        let element = obj1.target.closest("li");
        if (
          element &&
          $(element).attr("element-type") == "menu" &&
          $(element).attr("data-val") == "1024"
        ) {
          if (window.Tawk_API) {
            window.Tawk_API.maximize();
          }
          //alert("");
          //alert(window.Tawk_API.isChatMaximized());
          //if (window.Tawk_API.isChatMaximized()) {
          //  window.Tawk_API.minimize();
          //} else {
          //  window.Tawk_API.maximize();
          //}
          return;
        } else if (
          element &&
          $(element).attr("element-type") == "menu" &&
          $(element).attr("data-val") == "1027"
        ) {
          let menuId = $(element).attr("data-val");
          let menu = self.MenuData.filter(function (item) {
            return item.MenuID == menuId;
          });
          if (menu.length > 0) {
            //window.location.href = menu[0].ExternalPageUrl;
            router.push(menu[0].ExternalPageUrl);
          }
          return;
        } else if (
          element &&
          $(element).attr("element-type") == "menu" &&
          $(element).attr("data-val") == "1023"
        ) {
          let menuId = $(element).attr("data-val");
          let menu = self.AllMenuData.filter(function (item) {
            return item.MenuID == menuId;
          });
          if (menu.length > 0 && menu[0].RoomId != undefined) {
            this.commonLoader = true;
            bus.$emit("openPredefinedChat", menu[0].RoomId);
          }
        } else if (
          element &&
          $(element).attr("element-type") == "menu" &&
          $(element).attr("data-val") == "1001004"
        ) {
          let menuId = $(element).attr("data-val");
          let menu = self.AllMenuData.filter(function (item) {
            return item.MenuID == menuId;
          });
          if (menu.length > 0 && menu[0].IsChatEnabled == true) {
            //this.showChatComponent = false;
            bus.$emit("hideChatButton", false);
          }
        } else if (
          element &&
          $(element).attr("element-type") == "menu" &&
          $(element).attr("data-val") == "1021"
        ) {
          let menuId = $(element).attr("data-val");
          let menu = self.AllMenuData.filter(function (item) {
            return item.MenuID == menuId;
          });
          if (menu.length > 0) {
            bus.$emit("hideChatButton", false);
          }
        } else if (
          element &&
          $(element).attr("element-type") == "menu" &&
          $(element).attr("data-val") == "1029"
        ) {
          let menuId = $(element).attr("data-val");
          let menu = self.AllMenuData.filter(function (item) {
            return item.MenuID == menuId;
          });
          if (menu.length > 0) {
            common.openRegistrationDialog();
            $("li[data-val=" + menuId + "]  a.router-link-active").removeClass(
              "router-link-active"
            );
          }
        } else {
          bus.$emit("hideChatButton", true);
        }
        const menuId =
          element && $(element).attr("element-type") == "menu"
            ? String($(element).attr("data-val"))
            : null;
        if (menuId) {
          this.activeLeftMenuId = menuId;
        }
      }
      if (obj1.currentTarget.id === "liexhibitor") {
        //alert("")
        $("#liexhibitor")
          .find("a:first")
          .addClass("router-link-exact-active router-link-active");
        var obj = JSON.parse(window.localStorage.getItem("my-app"));
        if (obj.eventcollectionname !== undefined) {
          if (obj.eventcollectionname !== "") {
            db.collection(obj.eventcollectionname)
              .doc("Settings")
              .collection("Exhibitor")
              .get()
              .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                  if (doc.data().IsMouseCursorEnabled === true) {
                    store.commit("setMouseCursor", true);
                  } else {
                    store.commit("setMouseCursor", false);
                  }
                  if (doc.data().IsExpoAlertEnabled === true) {
                    store.commit("setExpoToolTip", true);
                  } else {
                    store.commit("setExpoToolTip", false);
                  }

                  if (doc.data().EnableEnhancedExpoMode === true) {
                    if (screen.width > 767) {
                      router.push("/exhibitorshall");
                    } else {
                      router.push("/exhibitorshalllite");
                    }

                    store.commit("setAdvExpo", true);
                  } else if (doc.data().AllowAerialView === true) {
                    store.commit("setAdvExpo", false);
                    router.push("/expohallaerialview");
                  } else if (doc.data().AllowbirdView === true) {
                    store.commit("setAdvExpo", false);
                    router.push("/expohallbirdview");
                  } else {
                    store.commit("setAdvExpo", false);
                    router.push("/exhibitor");
                  }
                });
              })
              .catch((error) => {
                //alert(error);
                console.log("OnMenuClick : " + error);
              });
          }
        }
      } else {
        $(".lileftmenu").removeClass("active");
        $(".tab-content-one .tab-pane").removeClass("active");

        $(obj1).first().addClass("active");
        //alert("")
        $("#liexhibitor")
          .find("a:first")
          .removeClass("router-link-exact-active router-link-active");
      }
    },
    onLeftMenuCLick: function (obj1) {
      //
      $(".tab-content-one .tab-pane").removeClass("active");
      $(".lileftmenu").removeClass("active");
      //var tabContentSelector = $(obj).children().attr("href");
      $("#" + obj1).addClass("active");

      $(obj1).first().addClass("active");
      if (obj1.currentTarget.id === "liexhibitor") {
        var obj = JSON.parse(window.localStorage.getItem("my-app"));
        if (obj.eventcollectionname !== undefined) {
          if (obj.eventcollectionname !== "") {
            db.collection(obj.eventcollectionname)
              .doc("Settings")
              .collection("Exhibitor")
              .get()
              .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                  if (doc.data().EnableEnhancedExpoMode === true) {
                    router.push("/exhibitorshall");
                    store.commit("setAdvExpo", true);
                  } else {
                    store.commit("setAdvExpo", false);
                    router.push("/exhibitor");
                  }
                });
              })
              .catch((error) => {
                console.log("OnLeftMenuClick : " + error);
                //alert(error);
              });
          }
        }
      }
    },
    clearstate: function (preventRedirection) {
      firebase
        .auth()
        .signOut()
        .then(
          function () {
            console.log("Signed Out");
          },
          function (error) {
            console.error("Sign Out Error", error);
          }
        );
      preventRedirection = false;
      if (this.$store.state.isSSO) {
        document.cookie = "AT=;domain=.edulife.sg;";
        this.$store.commit("addIsSSO", false);
        location.href = "https://edulife.sg/home?logout";
      }
      let hashVal = store.state.IsAccessCodeLogin
        ? `#${store.state.eventid}`
        : "";
      store.commit("ClearState", this);
      document.cookie = "vuid=; path=/;domain=.e2m.live;secure=true";
      document.cookie = "staysigned=";
      document.cookie = "userrole=";
      document.cookie = "userid=";

      //document.cookie.removeCookie("vuid");
      //firebase authentican log out---------------
      // firebase
      //   .auth()
      //   .signOut()
      //   .then(
      //     function () {
      //       console.log("Signed Out");
      //     },
      //     function (error) {
      //       console.error("Sign Out Error", error);
      //     }
      //   );
      //firebase authentican log out---------------
      if (!self.autoLogin) {
        if (preventRedirection == true) {
          setTimeout(() => {
            self.uid = self.getSessionUserId();
            location.reload();
          }, 1000);
        } else if (self.externalLogoutUrl) {
          location.href = self.externalLogoutUrl;
        } else {
          location.href = `/${hashVal}`;
        }
      } else {
        if (self.externalLogoutUrl) {
          location.href = self.externalLogoutUrl;
        }
      }

      self.autoLogin = false;
    },
    getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    openMenu: function () {
      if ($("#headerMenuParent").hasClass("active") == true) {
        $("#headerMenuParent").removeClass("active");
        $(".mob-menu-overlay").removeClass("active");
      } else {
        $("#headerMenuParent").addClass("active");
        $(".mob-menu-overlay").addClass("active");
      }
    },
    closeSubMenu: function () {
      $(".mob-menu-overlay").removeClass("active");
      $("#headerMenuParent").removeClass("active");
    },
    LoadEvent: function () {
      let self = this;
      if (location.pathname === "/lobby") {
        //$("#topmenu").hide();
      }
      if (location.pathname === "/") {
        //$("#topmenu").hide();
      }
      // if (location.pathname !== "/") {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      //alert(location.pathname);

      if (obj !== undefined && obj !== null) {
        if (obj.user !== undefined) {
          if (obj.user.length > 0) {
            //
            var roles = obj.user[0].roles == undefined ? [] : obj.user[0].roles;
            var eventCount = obj.eventCount == undefined ? 0 : obj.eventCount;
            // alert(usrid);

            if (eventCount > 1) {
              $("#switchEventLink").show();
            } else {
              $("#switchEventLink").hide();
            }
            if (roles.includes(2) || roles.includes(3)) {
              $("#AdminConsolelnk").show();
            } else {
              $("#AdminConsolelnk").hide();
            }
          }
        }
        if (obj.eventcollectionname) {
          self.event_collectionName = obj.eventcollectionname;
          self.old_event_collectionName = obj.eventcollectionname;
        }
        //this.MenuData = [];
        //$("#headerMenuParent").empty();
        //$("#ulLeftMenu").empty();
        if (
          self.event_collectionName &&
          self.$store.state.DefaultLoginLandingPage != "/clientLobby"
        ) {
          self.getMenuDetails();
          //self.setHomeMenu();
        } else if (self.publicEventCollection) {
          self.getMenuDetails();
        }
      }

      if (obj !== undefined && obj !== null) {
        if (obj.EventBranding !== undefined) {
          if (obj.EventBranding.length > 0) {
            this.topBannerColour = obj.EventBranding[0].topBar;

            $("#divBannerTop").css(
              "background-color",
              obj.EventBranding[0].topBar
            );
            $("#topmenu").css("background-color", obj.EventBranding[0].topBar);
            $("#leftmenu").css("background-color", obj.EventBranding[0].topBar);
            $("#divdrop").css("background-color", obj.EventBranding[0].topBar);

            var retVal = self.lightOrDark();
            if (retVal == "dark") {
              $("#topmenu").removeClass("lightTop");
              $("#topmenu").addClass("darkTop");
              $("#leftmenu").removeClass("lightMenu");
              $("#leftmenu").addClass("redMenu");
            } else {
              $("#topmenu").addClass("lightTop");
              $("#topmenu").removeClass("darkTop");
              $("#leftmenu").addClass("lightMenu");
              $("#leftmenu").removeClass("redMenu");
            }
            // alert($("#topmenu ul li a"));
            //  $("#topmenu ul li a").css("color",obj.EventBranding[0].fontBar+'!important');
            // $("#leftmenu ul li a").css("color",obj.EventBranding[0].fontBar+'!important');

            //$("#imgBanner").attr("src", obj.EventBranding[0].banner);
            self.SetBannerURL();
            $("#headerMenuParent").css("color", obj.EventBranding[0].fontBar);

            //-----------ujiya spl bannerRedirect-----------------------
            self.bannerRedirectURL = "";
            if (document.getElementById("routerlnkBanner")) {
              document.getElementById("routerlnkBanner").href = "#";
              document.getElementById("routerlnkBanner").target = "";

              if (obj.EventBannerRedirect !== undefined) {
                if (obj.EventBannerRedirect.length > 0) {
                  console.log(
                    "EventBannerRedirect store - " + obj.EventBannerRedirect
                  );
                  self.bannerRedirectURL = obj.EventBannerRedirect;
                  document.getElementById("routerlnkBanner").href =
                    obj.EventBannerRedirect;

                  document.getElementById("routerlnkBanner").target = "_blank";
                }
              }
            }
            //----------------------------------------------------------
          }
        }
      }
      //}
      //self.displayNotification();
    },
    AddUserView: async function () {
      let self = this;
      if (location.pathname !== "/" || location.pathname !== "login") {
        var obj = JSON.parse(window.localStorage.getItem("my-app"));
        if (obj !== undefined) {
          var eventName;
          //var e2mcode;
          if (obj.eventname !== undefined) {
            eventName = obj.eventname;
            //e2mcode = obj.client[0].id + obj.eventid;
          } else {
            eventName = "";
            //e2mcode = "";
          }
          if (obj.eventcollectionname) {
            self.event_collectionName = obj.eventcollectionname;
          }
          analytics.AddUserView(
            this.event_collectionName,
            eventName,
            location.pathname,
            "",
            "view",
            "",
            obj.user[0].id,
            obj.user[0].fname + " " + obj.user[0].lname,
            obj.user[0].Email
          );
        }
      }
      self.loadBannerRedirectUrl();
    },
    lightOrDark: function () {
      var color = "rgb(255,255,255)";
      if (
        this.$store.state.EventBranding &&
        this.$store.state.EventBranding.length > 0 &&
        this.$store.state.EventBranding[0].topBar
      ) {
        color = this.$store.state.EventBranding[0].topBar;
      }
      // Variables for red, green, blue values
      var r, g, b, hsp;
      // Check the format of the color, HEX or RGB?
      if (color.match(/^rgb/)) {
        // If RGB --> store the red, green, blue values in separate variables
        color = color.match(
          /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
        );

        r = color[1];
        g = color[2];
        b = color[3];
      } else {
        // If hex --> Convert it to RGB: http://gist.github.com/983661
        color = +(
          "0x" + color.slice(1).replace(color.length < 5 && /./g, "$&$&")
        );

        r = color >> 16;
        g = (color >> 8) & 255;
        b = color & 255;
      }

      // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
      hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

      // Using the HSP value, determine whether the color is light or dark
      if (hsp > 127.5) {
        return "light";
      } else {
        return "dark";
      }
    },
    ValidateUser: function () {
      var uid = self.getSessionUserId();
      var eventId = self.getEventId();
      var pathName = location.pathname;
      if (pathName) {
        pathName = pathName.trim();
      }
      if (pathName.startsWith("/exhibitorshall/E")) {
        var arr = pathName.split("/E");
        var urlEventId = "";
        if (arr.length > 1) {
          urlEventId = "E" + arr[1];
        }
        if (uid == "") {
          //alert("found: " + pathName);
          if (urlEventId) {
            router.push(
              "/?visitor-login=true&event_id=" +
                urlEventId +
                "&redirect_url=/exhibitorshall"
            );
          } else {
            store.commit("setUrlReq", pathName);
            router.push("/?#visitor-login");
          }
          return false;
        } else {
          if (
            eventId &&
            pathName.toLowerCase().includes("/" + eventId.toLowerCase())
          ) {
            router.push("/exhibitorshall");
            return false;
          } else {
            if (urlEventId) {
              router.push(
                "/?visitor-login=true&event_id=" +
                  urlEventId +
                  "&redirect_url=/exhibitorshall"
              );
            } else {
              store.commit("setUrlReq", pathName);
              router.push("/?#visitor-login");
            }
            return false;
          }
        }
      }
      if (!this.EnableSelfService) {
        if (this.IsAdminMenu) {
          router.push("/");
        }
      }
      pathName = pathName.trim().toLowerCase();
      //alert(self.currentRouteName);
      if (self.DefaultClientRoutes.includes(self.currentRouteName)) {
        //if (!uid && !eventId) {
        return;
        //}
      }
      if (pathName.includes("/login-new")) {
        console.log("redirecting to login-new");
      } else if (pathName.includes("/changepass")) {
        console.log("redirecting to changepass");
      } else if (pathName.includes("/loginexternal")) {
        console.log("redirecting to loginexternal");
      } else if (pathName.includes("/paymentstatus")) {
        console.log("redirecting to paymentstatus");
      } else if (pathName.includes("/stripetest")) {
        console.log("redirecting to stripetest");
      } else if (pathName.includes("/events")) {
        console.log("redirecting to events");
      } else if (pathName.includes("/event")) {
        console.log("redirecting to form");
      } else if (pathName.includes("/events")) {
        console.log("redirecting to reg form");
      } else if (pathName.includes("/showcase")) {
        console.log("redirecting to reg form");
      } else if (pathName.includes("/verifyuser")) {
        console.log("redirecting to form");
      } else if (pathName.includes("/reg")) {
        console.log("redirecting to reg");
      } else if (pathName === "/openReg") {
        console.log("redirecting to open Registration");
      } else if (pathName === "/RegEvent") {
        console.log("redirecting to open Registration");
      } else if (pathName === "/createpass") {
        console.log("redirecting to generate password");
      } else if (pathName.includes("/join")) {
        console.log("redirecting to login bypasss");
      } else if (pathName.includes("/eventlogin")) {
        console.log("redirecting to login bypasss");
      } else if (pathName.includes("/provider")) {
        console.log("redirecting to login bypasss");
      } else {
        if (pathName !== "/") {
          var obj = JSON.parse(window.localStorage.getItem("my-app"));
          if (obj == null) {
            store.commit("setUrlReq", window.location.pathname);
            router.push("/");
          }
          if (obj !== undefined) {
            if (obj.user === null) {
              store.commit("setUrlReq", window.location.pathname);
              router.push("/");
            }
            if (obj.user !== undefined) {
              if (obj.user[0] !== undefined) {
                if (obj.user[0].id !== undefined) {
                  if (obj.user[0].id === "") {
                    store.commit("setUrlReq", window.location.pathname);
                    router.push("/");
                  }
                } else {
                  store.commit("setUrlReq", window.location.pathname);
                  router.push("/");
                }
              } else {
                store.commit("setUrlReq", window.location.pathname);
                router.push("/");
              }
            } else {
              store.commit("setUrlReq", window.location.pathname);
              router.push("/");
            }
          }
        }
      }
    },
    RedirectValidUrl: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj.urlReq !== undefined) {
        if (obj.urlReq !== "") {
          var pathArray = obj.urlReq.split("/");
          var url = pathArray[3];
          if (pathArray.length > 3) {
            url = url + "/" + pathArray[4];
          }
          store.commit("setUrlReq", "");
          if (url) {
            router.push("/" + url);
          }
        }
      }
    },
    showPlugin: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj.eventcollectionname !== undefined) {
        if (obj.eventcollectionname !== "") {
          db.collection(obj.eventcollectionname);
          db.collection(obj.eventcollectionname)
            .doc("EventInfo")
            .get()
            .then((doc) => {
              self.ExhibitorData = [];
              $.each(doc.data().Plugins, function (key, value) {
                if (value.isEnabled === true) {
                  this.helpChatIcon = true;
                  window.Tawk_API.showWidget();
                } else {
                  this.helpChatIcon = false;
                  window.Tawk_API.hideWidget();
                }
              });
            });
        }
      }
    },
    enableTawk(routeName, clientId) {
      if (this.$store.state.user && this.$store.state.user.length > 0) {
        let name = this.$store.state.user[0].fname.trim();
        let email = this.$store.state.user[0].Email.trim();

        if (window.Tawk_API && window.Tawk_API.setAttributes) {
          window.Tawk_API.setAttributes({
            name: name,
            email: email,
          });
        }
      }

      setTimeout(() => {
        if (!routeName) {
          routeName = this.$route.name;
        }
        var defaultChatEnablePages = [
          "Login",
          "EventList",
          "OpenEvent",
          "Event",
          "Reg",
        ];
        //alert(routeName);
        //alert(clientId);
        var enable = false;
        enable = defaultChatEnablePages.includes(routeName);
        //alert("routeName: " + routeName + "; enable: " + enable);
        if (enable) {
          if (window.Tawk_API) {
            if (typeof window.Tawk_API.hideWidget === "function") {
              window.Tawk_API.hideWidget();
            }
          }
          if (!clientId) {
            if (routeName == "Login") {
              clientId = self.$store.state.client[0].id;
            } else if (routeName == "EventList") {
              clientId = self.$store.state.client[0].id;
            } else if (routeName == "OpenEvent") {
              if (self.$route.params) {
                clientId = self.$route.params.c;
                //alert("OpenEvent:" + clientId);
              }
            } else if (routeName == "Event") {
              //clientId = from Branding
            } else if (routeName == "Reg") {
              //clientId = from Branding
            }
          }
          if (clientId) {
            db.collection("OA_UAT")
              .doc("ClientList")
              .collection("Clients")
              .doc(clientId)
              .get()
              .then((doc) => {
                if (doc.exists) {
                  //alert("Success");
                  if (doc.data().EnableHelpChat) {
                    if (window.Tawk_API) {
                      if (typeof window.Tawk_API.hideWidget === "function") {
                        window.Tawk_API.showWidget();
                      }

                      //self.turnOnHelp();
                    }
                  }
                }
              })
              .catch(function (error) {
                //alert(error);
                console.log("Error : " + error);
              });
          }
        } else {
          if (window.Tawk_API) {
            if (typeof window.Tawk_API.hideWidget === "function") {
              window.Tawk_API.hideWidget();
            }
          }
        }
      }, 5000);
    },
    toggleMenuPlayerInfo() {
      common.toggleMenuPlayerInfo();
    },
    fetchEventInfo() {
      if (!eventListener) {
        var eventCollection = "";
        if (self.event_collectionName) {
          eventCollection = self.event_collectionName;
        } else if (self.publicEventCollection) {
          eventCollection = self.publicEventCollection;
        }
        if (eventCollection) {
          self.readAttendeeOnlineStatus();
          eventListener = db
            .collection(eventCollection)
            .doc("EventInfo")
            .onSnapshot(
              (doc) => {
                var data = doc.data();
                if (!data.IsPublished) {
                  let events = self.GetMappedEvents();
                  // let events = store.getters.getAdminRoles;
                  var isClientAdmin = self.isClientAdmin();
                  var isEventAdmin = self.isEventAdmin();
                  // alert("events.length" + events.length);
                  // alert("isClientAdmin: " + isClientAdmin);
                  // alert("isEventAdmin: " + isEventAdmin);
                  if (!isClientAdmin && !isEventAdmin) {
                    if (events.length == 1) {
                      if (welcomeVideoTimer) {
                        clearInterval(welcomeVideoTimer);
                        welcomeVideoTimer = null;
                      }
                      if (self.videoPlayerDialog) {
                        self.videoPlayer.pause();
                        self.onVideoPlayerEnded();
                      }
                      self.Logout();
                      return;
                    } else if (events.length > 1) {
                      if (welcomeVideoTimer) {
                        clearInterval(welcomeVideoTimer);
                        welcomeVideoTimer = null;
                      }
                      if (self.videoPlayerDialog) {
                        self.videoPlayer.pause();
                        self.onVideoPlayerEnded();
                      }
                      router.push("/eventlist");
                      return;
                    }
                  }
                }
                self.externalLogoutUrl = data.LogoutRedirectURL
                  ? data.LogoutRedirectURL
                  : "";
                this.eventDetails = data;
                this.defaultRoomIdForChat = data.DefaultRoomId
                  ? data.DefaultRoomId
                  : null;
                store.commit("setDefaultRoomId", this.defaultRoomIdForChat);
                if (data.Plugins != undefined) {
                  if (data.Plugins.OneToOneChat != undefined) {
                    this.showChatIcon = data.Plugins.OneToOneChat.IsEnabled;
                  }
                }
                store.commit("setBrandingJsonUrl", data.brandingJsonUrl);
                var mobileBanner = self.getMobleBanner(false);
                store.commit("addEventBranding", {
                  topBar: this.$store.getters.getEventBranding[0].topBar,
                  headerBar: this.$store.getters.getEventBranding[0].headerBar,
                  fontBar: this.$store.getters.getEventBranding[0].fontBar,
                  sideNavigationAndIconColor:
                    this.$store.getters.getEventBranding[0]
                      .sideNavigationAndIconColor,
                  eventBGImage: self.getCDNUrl(data.BackgroundImage),
                  eventLogo: self.getCDNUrl(data.EventLogo),
                  banner: self.getCDNUrl(data.EventBanner),
                  mobileBanner: mobileBanner,
                  shareBanner: self.getCDNUrl(
                    this.$store.getters.getEventBranding[0].shareBanner
                      ? this.$store.getters.getEventBranding[0].shareBanner
                      : ""
                  ),
                  themeName: this.$store.getters.getEventBranding[0].themeName,
                });
                //bus.$emit("LoadEventDetails");
                self.LoadEvent();

                if (data.Plugins && data.Plugins.HelpChat) {
                  self.helpChatIcon = data.Plugins.HelpChat.isEnabled;

                  console.log("help==", data);
                  console.log("help=2=", self.helpChatIcon);
                }

                if (data.Plugins && data.Plugins.OneToOneChat) {
                  this.chatEnabledFromPlugins =
                    data.Plugins.OneToOneChat.IsEnabled;
                  if (self.chatEnabledFromPlugins) {
                    self.getChatSettings();
                  }
                }

                if (data.HideEventHeaderAndMenu) {
                  self.hideEventHeaderAndMenu = data.HideEventHeaderAndMenu;
                } else {
                  self.hideEventHeaderAndMenu = false;
                }

                self.toggleMenuAndHeder(self.hideEventHeaderAndMenu);
                self.SetBannerURL();

                if (data.Plugins && data.Plugins.LiveVisitorWidget) {
                  self.liveVisitorIndicator =
                    data.Plugins.LiveVisitorWidget.IsEnabled;
                }

                // if ($("#sectionId") && !self.IsAdminEditPage) {
                //   $("#sectionId").css(
                //     "background-image",
                //     "url(" + self.getCDNUrl(data.BackgroundImage) + ")"
                //   );
                //   $("#headerText").css("color", data.textColor);
                // }
                if (
                  data.IsPublished &&
                  data.WelcomeVideo &&
                  data.WelcomeVideo.IsPublished &&
                  !welcomeVideoTimer
                ) {
                  // alert(data.WelcomeVideo.StartTime.seconds);
                  self.welcomeVideo = data.WelcomeVideo;
                  // alert("Welcome Video is on");
                  self.$nextTick(() => {
                    self.validateAndShowVideoPlayer();
                  });
                } else {
                  self.welcomeVideo = null;
                  if (welcomeVideoTimer) {
                    // alert("Welcome Video is off");
                    clearInterval(welcomeVideoTimer);
                    welcomeVideoTimer = null;
                  }
                }
                if (
                  welcomeVideoTimer &&
                  (!data.IsPublished ||
                    (data.WelcomeVideo && !data.WelcomeVideo.IsPublished))
                ) {
                  clearInterval(welcomeVideoTimer);
                  welcomeVideoTimer = null;
                }
                if (
                  self.videoPlayerDialog &&
                  (!data.IsPublished ||
                    (data.WelcomeVideo && !data.WelcomeVideo.IsPublished))
                ) {
                  self.videoPlayer.pause();
                  self.onVideoPlayerEnded();
                }
              },
              (error) => {
                self.MenuData = self.PublicMenuList;
                self.AllMenuData = self.PublicMenuList;
                console.log(error);
              }
            );

          self.setMyPresence();
          //self.getPageLvlUserPresence();

          //  setTimeout(() => {
          //   self.readAttendeeOnlineStatus();
          //  }, 1000);
        }
      }
    },
    initAttendeeListener(eventCollection, attendeeId) {
      if (attendeeListener) {
        attendeeListener();
        attendeeListener = null;
      }
      if (eventCollection && attendeeId) {
        attendeeListener = db
          .collection(eventCollection)
          .doc("AttendeeList")
          .collection("Attendees")
          .doc(attendeeId)
          .onSnapshot(
            (doc) => {
              var data = doc.data();
              // if (!data.IsPublished) {
              //   if (welcomeVideoTimer) {
              //     clearInterval(welcomeVideoTimer);
              //     welcomeVideoTimer = null;
              //   }
              //   if (self.videoPlayerDialog) {
              //     self.videoPlayer.pause();
              //     self.onVideoPlayerEnded();
              //   }
              //   self.Logout();
              //   return;
              // }
              if (data.Leaderboard && data.Leaderboard.Score) {
                self.myLeaderboardScore = data.Leaderboard.Score;
              } else {
                self.myLeaderboardScore = 0;
              }
              //store.commit("setBrandingJsonUrl", data.brandingJsonUrl);
              //store.commit("addEventBranding", {
              //  topBar: this.$store.getters.getEventBranding[0].topBar,
              //  headerBar: this.$store.getters.getEventBranding[0].headerBar,
              //  fontBar: this.$store.getters.getEventBranding[0].fontBar,
              //  sideNavigationAndIconColor:
              //    this.$store.getters.getEventBranding[0]
              //      .sideNavigationAndIconColor,
              //  eventBGImage: self.getCDNUrl(data.BackgroundImage),
              //  eventLogo: self.getCDNUrl(data.EventLogo),
              //  banner: self.getCDNUrl(data.EventBanner),
              //});
              //if (data.Plugins.HelpChat) {
              //  this.helpChatIcon = data.Plugins.HelpChat.isEnabled;
              //}
              self.userRoleIDs = [];
              if (data.UserRoles && data.UserRoles.length > 0) {
                data.UserRoles.forEach((item) => {
                  self.userRoleIDs.push(item.RoleID);
                });
              }
              if (self.userRoleIDs.includes(11)) {
                self.isSpeaker = true;
              }
              //alert(self.userRoleIDs.length);
            },
            (error) => {
              //alert(error);
              console.log(error);
            }
          );
      }
    },
    async getMyAgendaCount() {
      if (self.userRoleIDs.includes(11)) {
        let result = await self.getSpeakersSessionCount(self.uid);
        if (result && result.status == 0) {
          if (result.data) {
            //alert("result.data.length:" + result.data.length);
            self.myAgendaCount = result.data.length;
          }
        }
      }
    },
    getLeaderBoardSettings(eventCollection) {
      self.displayScoreOnProfile = false;
      if (eventCollection) {
        db.collection(eventCollection)
          .doc("Settings")
          .collection("LeaderBoard")
          .doc("LeaderBoardSettings")
          .get()
          .then((doc) => {
            if (doc.exists) {
              var data = doc.data();
              if (data.DisplayScoreOnProfile == true) {
                self.displayScoreOnProfile = true;
              }
            }
          })
          .catch(function (error) {
            console.log("Error : " + error);
          });
      }
    },
    editProfileSuccess(functionName = null) {
      if (functionName) bus.$emit(functionName);
    },
  },
};
</script>

<style lang="scss">
.lileftmenu:has(a.router-link-active),
.lileftmenu.active {
  background-color: #1a73e8;
}

.lightMenu .lileftmenu:has(a.router-link-active),
.lightMenu .lileftmenu.active {
  background-color: #edf5fa;
}
.presence-fade-out {
  height: 42px;
  width: 160px;
  opacity: 1;
  transition: all 400ms;
  position: relative;
  z-index: 3;
}
// .presence-fade-out.fadeout-text {
//   opacity: 0;
//   height: 42px;
//   width: 0;
//   transition: all 0.75s ease;
// }
.presence-fade-out.fadeout-text1 {
  overflow: hidden;
  display: none;
  animation: 5s slide-left 5s forward;
  animation-delay: 5s;
  height: 42px;
  margin-left: -160px;
  position: relative;
  z-index: -1;
  transition: all 400ms;
}
@keyframes slide-left {
  from {
    margin-left: 0px;
  }

  to {
    position: relative;

    margin-left: -160px;
    z-index: -1;
    transition: all 400ms;
  }
}
#overlay-test {
  position: fixed;
  display: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 2;
  cursor: pointer;
}
.login-attendee {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.login-attendee .attendee-img-hld {
  width: 132px;
  height: 132px;
  overflow: hidden;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 54px;
  text-transform: uppercase;
  border: 1px solid #f2f2f2;
  background-color: #ebeff2;
  color: #6d6f7b;
}
.login-attendee .attendee {
  color: rgb(28, 29, 38);
  font-size: 24px;
  font-weight: 500;
}
.login-attendee .welcome {
  font-size: 24px;
  padding-right: 5px;
}
.banner-upload-dialog .v-dialog__content.v-dialog__content--active {
  z-index: 999999 !important;
}
.wtsp-btn.v-btn:not(.v-btn--round).v-size--default {
  height: 36px;
  min-width: 64px;
  padding: 10px 10px;
}
.client-dialog-briefcase {
  border-radius: 24px;
  width: 50%;
  overflow: hidden;
}
.preview-mode-btn:hover {
  color: blue !important;
}
.page-wrap-inner {
  height: calc(100% - var(--banner-height)) !important;
}
.player-full-screen .page-wrap-inner {
  height: 100% !important;
}
.v-main {
  padding: unset !important;
}
div#topmenu {
  // height: 134px;
  height: var(--banner-height);
}
.v-toolbar {
  height: unset !important;
}
.v-toolbar__extension {
  padding: 0 !important;
}
.v-toolbar__content,
.v-toolbar__extension {
  z-index: unset !important;
  height: unset !important;
}
.v-toolbar__content {
  padding: 0 !important;
  // flex-direction: column;
}
::-webkit-scrollbar {
  width: 3px;
}
::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.5);
}
::-webkit-scrollbar-thumb {
  background: #333;
}

@import "./assets/screen.css";
@import "./assets/login.css";
@import "./assets/responsive.css";
@import "./assets/chatGpt.css";
/*----------survey-modal-----------*/
.survey-start-modal .modal-body {
  padding: 0;
  border-radius: 15px !important;
}
.survey-start-modal .modal-content {
  border-radius: 15px;
}
.survey-start-modal-top {
  height: 90px;
  width: 100%;
  background: url(./assets/Images/background-survey-starter.jpg) no-repeat top
    left / cover;
  border-radius: 10px 10px 0 0;
}
.survey-start-popup-statement {
  padding: 70px 0 55px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.pophead-image {
  position: absolute;
  z-index: 99;
  display: flex;
  justify-content: center;
  top: -24px;
}
.pop-head-image-2 {
  position: absolute;
  z-index: 99;
  bottom: -29px;
}
.pop-head-image-2 img {
  width: 80px;
}
.survey-modal-start-wrap {
  border-radius: 15px;
}
.survey-start-modal-top-wrap {
  display: flex;
  justify-content: center;
}
.survey-start-modal-top-wrap button.close {
  height: 30px;
  width: 30px;
  background: #fff;
  opacity: 1 !important;
  border-radius: 50%;
  right: -11px;
  top: -10px;
}
.survey-start-modal-top-wrap button.close span {
  font-weight: 300;
  text-shadow: none;
  font-size: 37px;
  line-height: 28px;
}
.survey-start-popup-statement h4 {
  font-size: 22px;
  font-weight: 600;
  color: #000;
  width: 348px;
  text-align: center;
  line-height: 27px;
  margin: 0;
}
/*----------survey-modal-----------*/
.v-snack {
  z-index: 1051 !important;
}
</style>
